import React, { ReactElement } from "react";

export function ChineseTerms(): ReactElement {
  return (
    <>
      <p><span style={{ color: "#ff0000" }}>体育博彩规则</span></p>
      <p><br /></p>
      <p>接受投注：</p>
      <p><br /></p>
      <p>赌注可以仅由用户通过其游戏帐户放置；</p>
      <p><br /></p>
      <p>用户所下的任何赌注将被从您自己的用户帐户余额中扣除；</p>
      <p><br /></p>
      <p>赌注可以仅当用户帐户的余额等于或大于您要存入的金额时才被接受；</p>
      <p><br /></p>
      <p>赌注是以固定利率，这表示所考虑的赔率将是下注时提供的赔率，除非进行进一步更改；</p>
      <p><br /></p>
      <p>任何赌注都将始终由我们自行决定接受，总限额可由我们自行决定；</p>
      <p><br /></p>
      <p>所有投注均须经我们部门接受，且不得有任何变更）；</p>
      <p><br /></p>
      <p>要被视为有效，投注必须遵守为您所投注的特定赛事确定的最少赛事选择；</p>
      <p><br /></p>
      <p>对不同体育赛事的投注必须经过授权。在这种情况下，要选择的最少事件数为最低人数最多的运动高；</p>
      <p><br /></p>
      <p>这不是允许对单一赛事进行投注，除非网站上另有说明或授权； 21.1.11。 - 它不是允许插入多个与同一事件相关的预测，除了 sé;明确授权；</p>
      <p><br /></p>
      <p>指定预测的唯一有效缩写是“调度”部分中指示的缩写；</p>
      <p><br /></p>
      <p>这不是如果单一结果会影响结果，则允许进行多次投注。别人的结果；</p>
      <p><br /></p>
      <p>赛事开始后接受的单注将被视为无效，而多注将被视为无效。仅针对特定赛事的相应投注被视为无效 (void)；</p>
      <p><br /></p>
      <p>不符合上述规则、被错误接受、因打印错误而更改或错误反转赔率的投注将被视为无效，并退还相应的投注金额；</p>
      <p><br /></p>
      <p>我们保留这种可能性’如果投注无效，则赛事或整个优惠券无效由于未能更新或输入错误，或者由于技术问题而导致滚球投注被阻止，或者赔率彼此不兼容，因此以明显不正确的赔率进行。</p>
      <p><br /></p>
      <p>单个赛事的赔率可能会发生变化、更正或暂停。如果由于抄录或数据输入错误而导致赔率的发布和定义出现错误，即使在得出最终结果后，我们也保留修改不正确赔率的权利。用户将是通过网站上的新闻或内部消息及时告知这一变化。对于单张，如果此修改是在活动开始之前进行的，则用户可以请求取消。对于基本单、完整单或组合单，取消请求必须在单中包含的任何活动开始之前收到；</p>
      <p><br /></p>
      <p>所发布的赛事日期、时间、实时比分和结果仅供参考。各联合会在赛事结束时公布的结果将被视为正式有效。随后改变结果的决定将不予考虑。基于报纸或其他新闻和信息机构报道的数据和时间提出的反对意见将不予考虑；</p>
      <p><br /></p>
      <p>这不是允许分割复式投注或系统，其唯一目的是超过和逃避每项运动所允许的最大金额。任何奖金都将被取消（无效）；</p>
      <p><br /></p>
      <p>这不是允许分割多重投注或系统，其唯一目的是超过和逃避每个投注单允许的最大获胜金额。任何奖金将被取消（无效）； 21.1.21。 - 如果赛事在公布的时间（或日期）之前提前，则在实际开始之前进行的投注将被视为有效；</p>
      <p><br /></p>
      <p>如果投注带有明显的欺诈意图，因为用户已经在得知活动结果后，我们保留取消获胜投注、关闭账户并保留资金一年的权利。</p>
      <p><br /></p>
      <p>如果对活动的进行进行投诉，用户希望查看活动本身的记录，则所有管理费用（包括运输费用）将由用户承担；</ p>
      <p><br /></p>
      <p>我们保留接受、不接受或部分接受用户发送的注册请求的权利；</p>
      <p><br /></p>
      <p>特别投注的规则将通过通常使用的传播方式不时披露；</p>
      <p><br /></p>
      <p>如果任何学科的参赛者在比赛开始前因任何原因退出，则有关前柱的预测将被视为失败；</p>
      <p><br /></p>
      <p>在没有赛事注册的情况下，被视为官方的结果将始终是各个官方联合会发布的结果；</p>
      <p><br /></p>
      <p>每个网络/附属机构/用户的每日最大预期奖金是25,000 欧元（两万五千欧元），无论投注单数量多少。每个网络/附属机构/用户的每周最大赢奖是50,000 欧元（五万欧元），无论投注单数量多少。</p>
      <p><br /></p>
      <p>我们保留取消（作废）账户持有人与第三方之间协议所产生的奖金的权利，以逃避规定（如网站上不时发布的规定）；</p>
      <p><br /></p>
      <p>奖金将是收到后自动计算并存入用户的帐户。所进行的预测被宣布为获胜者。要领取奖金，用户必须：使用模式优惠并在网站上发布；</p>
      <p><br /></p>
      <p>为了计算获胜预测而被视为有效的赔率是在接受预测本身时有效的赔率；</p>
      <p><br /></p>
      <p>如果同一赛事的参与者之间结果相同，则奖金将计算方法是将费用除以同等成绩的参与者数量；</p>
      <p><br /></p>
      <p>空事件（void）的发生率为等于 1.00。如果事件是一旦单独预测，所玩的金额将是已退款；</p>
      <p>如果单次预测成功，中奖金额将为等于投注金额乘以预测本身的赔率；</p>
      <p><br /></p>
      <p>如果多重预测成功，中奖金额将为等于预测本身的赔率乘积所投注的金额；</p>
      <p><br /></p>
      <p>如果任何金额被错误存入（例如输入结果），则任何金额存入用户帐户的相同的义务进行沟通。因此，因该错误而产生的所有奖金将被视为无效；</p>
      <p><br /></p>
      <p>如果主管体育组织未提供官方信息来确定投注结果，我们保留认为该投注无效的权利。</p>
      <p><br /></p>
      <p>任何由其他博彩公司、用户工会、协会、朋友或亲戚团体或根据其他人的建议进行或通过其他博彩公司、用户工会、协会、朋友或亲戚进行欺诈意图进行的投注，将被视为注销，相关资金将保留一年。</p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}>奖励</span></p>
      <p>奖金金额为奖金的组成部分，并出现在投注摘要中。</p>
      <p>奖金是按包含一定数量有效事件的倍数支付。</p>
      <p>奖金包括中奖金额的百分比增加，可以在参与收据上验证，根据中奖多张彩票中存在的有效事件，适用于潜在奖金的奖金百分比如下所示。</p >
      <p>一些赔率低于一定范围的赛事不会有助于获得奖金。</p>
      <p>可退款活动（配额 1）不会有助于获得奖金，奖金将在支付奖金时重新计算。</p>
      <p><span style={{ color: "#ff0000" }}>现金</span></p>
      <p><span>赛前兑现：玩家可以在一项或多项赛事开始前且没有任何其他赛事正在进行时兑现优惠券。下面我们指出了数学计算：[（兑现时更新的潜在获胜/缺失报价）- 提前领取优惠券费用的 TOT%]。</span></p>
      <p><span>即时投注兑现：玩家可以在一项或多项赛事结束前兑现优惠券。下面我们指出了数学计算：[（兑现时更新的潜在获胜/缺失报价）- 提前领取优惠券费用的 TOT%]。在 CashOut LiveBetting 中，市场可以活跃也可以不活跃，因为它们取决于赛事本身的进展。因此，公司对特定事件的 CashOut 可能导致的市场缺失不承担任何责任。</span></p>
      <p><span>CashOut 优惠券混合赛前 + 现场投注：不允许现金。</span></p>
      <p><span>ps：是否可以提现取决于其他动态因素，例如每次活动的最高费用、跑步活动的数量等，或公司自行决定的其他因素。</span></p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}>足球</span></p>
      <p><br /></p>
      <p>除非另有说明，所有投注均指 90 分钟加伤停补时。如果裁判在90分钟前吹响比赛结束的哨声，则结果为以现场获得的结果为准，所有投注将被视为有效。</p>
      <p>除非另有说明，赛事官方组织机构在任何体育赛事结束后做出的任何决定均无效。考虑在内。更重要的是，如果是现场投注，市场会进行即时报告，赛事结束后不会做出任何决定。考虑在内。</p>
      <p>对于友谊赛，即使没有明确指定，即使在规范的 90 分钟之前结束，所有投注也将被视为有效。 （例如 40 分钟或 30 分钟的两场半比赛）。由 3 支或 3 支以上球队进行的比赛除外。次数，如果没有明确指定，将被视为无效并以 1.00 的赔率考虑</p>
      <p>如果赛事暂停、取消或推迟，如果赛事在第二天晚上 11.59 之前恢复，则投注仍然有效，在此时间之后，获得特定结果的盘口（例如根据结果暂停） 3-0 的赔率将被支付，但不会支付 1 号，因为还不确定）将被定期处理，而对于所有未绝对实现结果的盘口，它们将被处理为无效，但有配额1.00。如果活动被暂停、取消或推迟插入倍数后，投注仍然有效，但仅归因于与赔率等于 1.00 相关的赛事。我们所说的获得的结果是指任何不再是的结果随着比赛的进行可能会发生变化。未完成的结果是指任何可能导致比赛重新开始的结果。发生变化。</p>
      <p>此外，退款可分为两类：</p>
      <p>全额退款：赛事未进行。在这种情况下，事件将会发生以 1 的赔率考虑，随后自动退还赌注。</p>
      <p>每小时退款：赛事在官方接受投注时间之后进行。开放时间之后的所有投注将以 1 赔率考虑</p>
      <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
      <p>您必须在常规比赛结束时预测比赛的最终结果，不包括任何加时赛和点球：</p>
      <p>得分 1 主队获胜；</p>
      <p>画X标志；</p>
      <p>客队得 2 分获胜。</p>
      <p><span style={{ color: "#ff0000" }}>双倍机会 1X</span></p>
      <p>预计比赛最终结果将在主队获胜或常规赛结束时打平，不包括任何加时赛和点球。</p>
      <p><span style={{ color: "#ff0000" }}>双倍机会 X2</span></p>
      <p>预计比赛最终结果将在客队获胜或常规赛结束时打平，不包括任何加时赛和点球。</p>
      <p><span style={{ color: "#ff0000" }}>双倍机会 1/2</span></p>
      <p>预计比赛最终结果将在常规赛结束时主队或客队的胜利，不包括任何加时赛和点球</p>
      <p><span style={{ color: "#ff0000" }}>下/上 </span></p>
      <p>您必须预测两队在比赛中的进球总和是否为高于（高于）或低于（低于）所提供的点差。就投注而言，仅考虑常规时间，不包括任何加时和罚球。</p>
      <p><span style={{ color: "#ff0000" }}>在家下方/上方</span></p>
      <p>您必须在比赛中预测主队是否会获胜。高于（高于）或低于（低于）所提供的点差。就投注而言，仅考虑常规时间，不包括任何加时和罚球。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于访客</span></p>
      <p>您必须在比赛中预测客队是否会获胜。高于（高于）或低于（低于）所提供的点差。就投注而言，仅考虑常规时间，不包括任何加时和罚球。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 1°时间</span></p>
      <p>您必须预测两队上半场比赛的进球总数是否为高于（高于）或低于（低于）所提供的点差。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 2°时间</span></p>
      <p>您必须预测比赛下半场的进球总数是否为高于（高于）或低于（低于）所提供的点差。</p>
      <p><span style={{ color: "#ff0000" }}>得分 1°目标</span></p>
      <p>投注包括确定将在比赛中得分的球队规定时间内的第一个进球，不包括任何加时赛和罚球。</p>
      <p>可预测的结果是：</p>
      <p>第 1 队：将得分球队在主场比赛；</p>
      <p>第 2 队：将得分球队客场作战；</p>
      <p>不会进球。</p>
      <p><span style={{ color: "#ff0000" }}>目标/无目标</span></p>
      <p>它包括预测两队在常规比赛结束时是否至少进球一球，不包括任何加时赛和点球。如果双方都至少进一球，则结果为目标;反之亦然，如果一支或两支球队没有至少进一球，则结果为没有目标。</p>
      <p>示例：卡利亚里-佛罗伦萨：1-1。获胜结果：目标</p>
      <p>示例：卡利亚里-佛罗伦萨：2-0。获胜结果：无进球</p>
      <p><span style={{ color: "#ff0000" }}>上半场进球/无进球</span></p>
      <p>它包括仅考虑上半场来预测两支球队是否至少进球一个进球。如果双方都至少进一球，则结果为目标;反之亦然，如果一支或两支球队都没有至少进一球，则结果为没有目标。</p>
      <p>示例：卡利亚里-佛罗伦萨：1-1。获胜结果：目标</p>
      <p>示例：卡利亚里-佛罗伦萨：2-0。获胜结果：无进球</p>
      <p><span style={{ color: "#ff0000" }}>组合 1x2 + 下/上</span></p>
      <p>投注在于确定最终结果和下/大盘投注结果的正确组合</p>
      <p><span style={{ color: "#ff0000" }}>最终结果 + 目标/无目标</span></p>
      <p>投注包括确定最终结果投注和常规比赛结束时进球/无进球投注结果的正确组合，不包括任何加时赛和罚球。可能的结果是： 1-目标； 1- 没有目标； X——目标; X——没有目标； 2 – 目标； 2 –没有目标。</p>
      <p><span style={{ color: "#ff0000" }}>偶/奇</span></p>
      <p>您必须预测两队在常规时间结束时的进球总数是否为偶数或奇数。</p>
      <p>示例：锡耶纳 - 亚特兰大：0-0。获胜结果：平局</p>
      <p>示例：锡耶纳 - 亚特兰大：2-1。获胜结果：奇数</p>
      <p><span style={{ color: "#ff0000" }}>总目标</span></p>
      <p>它包括预测常规时间结束时一场比赛的进球数，即 90 个进球。更多的可能的恢复，从以下选项之一中选择：0； 1; 2； 3； 4；4.</p>
      <p>结果 4 包括目标总和大于 4 的所有结果。</p>
      <p>示例：都灵 - 雷吉纳 0-0 获胜结果：0</p>
      <p>示例：都灵-雷吉纳 1-0 获胜结果：1</p>
      <p>示例：都灵-雷吉纳 1-1 获胜结果：2</p>
      <p>示例：都灵-雷吉纳 2-1 获胜结果：3</p>
      <p>示例：都灵-雷吉纳 2-2 获胜结果：4</p>
      <p><span style={{ color: "#ff0000" }}>第一次结果 1X2</span></p>
      <p>您必须预测第 1 个末尾的 1X2 符号时间，即45°分钟加可能的恢复，根据以下方案：</p>
      <p>上半场结束时主队得分1，主队获胜；</p>
      <p>上半场结束时画X，两队打平；</p>
      <p>上半场结束时客队拿下2分，客队获胜。</p>
      <p><span style={{ color: "#ff0000" }}>上半场/决赛部分</span></p>
      <p>你必须预测第一个结果时间与比赛最终结果相结合。</p>
      <p>9 种可能的结果是：</p>
      <p>上半场结束和全场比赛结束时，主队将是1-1前进；</p>
      <p>上半场结束时 1-X 主队将最终结果将是平局；</p>
      <p>上半场结束，主队将1-2最终结果将是客队取得胜利；</p>
      <p>上半场结束时X-1，结果将是平局，最终结果将是主队取得胜利；</p>
      <p>上半场结束时和全场比赛结束时的XX结果为平局；</p>
      <p>上半场结束时X-2的结果将是平局，最终结果将是客队获胜；</p>
      <p>上半场结束，客队2-1领先，而最终结果将是主队获胜；</p>
      <p>上半场结束时客队将2-X最终结果将是平局；</p>
      <p>上半场结束时和全场比赛结束时，客队将2-2领先。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 带障碍</span></p>
      <p>投注包括在常规时间结束（包括伤停补时）时预测比赛结果，获得 1X2 的结果，并在比赛结束时计算特许经营商提前输入的进球盘口.</p>
      <p>示例</p>
      <p>尤文图斯-恩波利1X2让分</p>
      <p>尤文图斯 1 球让分</p>
      <p>尤文图斯以 2 场或以上获胜净胜球（2-0、3-0、3-1、4-0 等。获胜结果：1</p>
      <p>尤文图斯以 1 个净胜球优势获胜（1-0、2-1、3-2、4-3 等）。获胜结果：X</p>
      <p>恩波利战平或获胜（0-0、1-1、0-1、0-2 等）。获胜结果：2</p>
      <p><span style={{ color: "#ff0000" }}>得分目标 –主/客队 –是/否</span></p>
      <p>投注包括预测球队是否会在比赛中得分。在一场特定比赛结束时至少进一个球，不包括任何加时赛。</p>
      <p><br /></p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}>确切结果</span></p>
      <p>您需要在常规时间结束时预测比赛的确切结果，90&rsquo;更多的可能的恢复（其他项目包括列表中不存在的任何结果）。</p>
      <p><span style={{ color: "#ff0000" }}>准确比分“上半场”</span></p>
      <p>投注包括确定特定比赛上半场结束时的结果。可能的结果是：</p>
      <p>0-0； 0-1； 0-2； 1-2； 1-0； 2-0； 2-1； 1-1； 2-2；其他。</p>
      <p><span style={{ color: "#ff0000" }}>以 0 获胜 –是/否</span></p>
      <p>投注旨在确定在常规比赛结束时的指定比赛中，不包括任何加时赛和罚球，提议的球队是否将获得一场胜利，同时对方球队不会进球。标记。</p>
      <p><span style={{ color: "#ff0000" }}>第一个进球分钟</span></p>
      <p>投注在于预测比赛发生的时间段。打进了本场比赛的第一个进球。投注包括 6 个对应时间段的赛事和 1 个无进球结果的赛事。</p>
      <p>可能的结果（分钟范围）：</p>
      <p>0 - 15</p>
      <p>16 - 30</p>
      <p>31 - 上半场结束</p>
      <p>46 - 60</p>
      <p>61 - 75</p>
      <p>76 - 游戏结束</p>
      <p>没有目标</p>
      <p><span style={{ color: "#ff0000" }}>目标/无目标 2°时间</span></p>
      <p>该赌注在于预测是否仅在第二季期间，时间，两队都会得分或不得分。就投注目的而言，有效结果是下半场结束时获得的结果（加上任何恢复时间）并且仅与下半场的部分结果相关。</p>
      <p><span style={{ color: "#ff0000" }}>目标最多的时间</span></p>
      <p>投注包括比较比赛中的进球数。符号 1 表示您预测上半场的进球数将多于下半场的进球数。使用 X 符号，您预测上半场的进球数将等于下半场的进球数。使用符号 2，您预测上半场的进球数将少于下半场的进球数。</p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球特殊</span></p>
      <p>投注包括根据“进球/不进球”投注的规则，预测“进球/不进球”1° 投注结果的正确匹配。时间和目标/无目标 2°时间。有四种可预测的结果。</p>
      <p><span style={{ color: "#ff0000" }}>确切的部分/最终答案</span></p>
      <p>您必须同时预测上半场结束时的准确结果和比赛本身结束时的准确结果（不包括加时赛和任何点球）。列表中指示的第二个结果是与比赛的结局有关。</p>
      <p><span style={{ color: "#ff0000" }}>精确结果 10 结果 2°时间</span></p>
      <p>投注包括通过从建议的结果中进行选择来预测比赛下半场的确切结果。就投注目的而言，有效结果是下半场结束时获得的结果（加上任何恢复时间）并且仅与下半场的部分结果相关。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数宫位</span></p>
      <p>您必须预测主队的进球数是否为偶数或奇数。就投注而言，适用规定时间，包括任何恢复时间。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数客人</span></p>
      <p>您必须预测客队的进球数是单数还是双数。就投注而言，适用常规时间，包括任何恢复时间。</p>
      <p><span style={{ color: "#ff0000" }}>偶/奇上半场</span></p>
      <p>你必须预测两队上半场（45分钟，包括伤停补时）的进球总和是否为偶数或奇数。</p>
      <p><span style={{ color: "#ff0000" }}>偶/奇下半场</span></p>
      <p>你必须预测两队下半场（45分钟）（包括伤停补时）的进球总和是否为偶数或奇数。</p>
      <p><span style={{ color: "#ff0000" }}>上半场进球总数</span></p>
      <p>您必须预测结果中上半场（45 分钟，包括伤停补时）的确切进球数：0/1/2/2+。</p>
      <p><span style={{ color: "#ff0000" }}>下半场进球总数</span></p>
      <p>您必须预测下半场（45 分钟，包括伤停补时）的确切进球数：0/1/2/2+。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 上半场让分</span></p>
      <p>您必须考虑两支球队之一的让分来预测比赛上半场的结果。有问题的赌注是仅与第 1 次结束时的结果有关时间，包括任何恢复。</p>
      <p><span style={{ color: "#ff0000" }}>主场进球总数 </span></p>
      <p>您必须预测主队在比赛中在 0/1/2/2+ 结果之间的确切进球数。就投注而言，适用常规时间，包括任何恢复时间。</p>
      <p><span style={{ color: "#ff0000" }}>访客目标总和 </span></p>
      <p>您必须预测客队在比赛中在 0/1/2/2+ 结果之间的确切进球数。就投注而言，适用常规时间，包括任何恢复时间。</p>
      <p><span style={{ color: "#ff0000" }}>两次都超过 1.5</span></p>
      <p>您必须预测比赛上半场和下半场是否至少进两个球。提供两种可能的结果：是（两个半场至少都会进两个球）和否（两个半场至少不会进两个球）。这两个时间必须独立考虑。示例：如果上半场结束时比分是最终比分是3-0 3-1，将意味着仅上半场就至少进了两个球，因为下半场的部分结果是0-1，因此正确的结果将是在这种情况下“否”。</p>
      <p><span style={{ color: "#ff0000" }}>两次均低于 1.5</span></p>
      <p>您必须预测比赛上半场和下半场的进球是否少于两个。提供两种可能的结果：“是”（两个半场进球数均少于两个进球）和“否”（任一半场进球数不少于两个进球）。这两个时间必须独立考虑。示例：如果上半场结束时比分是最终比分是1-0 2-1，意味着由于下半场的部分结果，只有上半场的进球数少于两个1-1.</p>
      <p><span style={{ color: "#ff0000" }}>进球/无进球 + U/O 2.5</span></p>
      <p>该投注旨在确定常规时间结束时进球/无进球以及低于/高于 2.5 的投注结果的正确组合，不包括任何加时赛和罚球。可能的结果是： 目标 + 低于 2.5；无目标+超过2.5；无目标 + 低于 2.5；进球数 + 超过 2.5。</p>
      <p><span style={{ color: "#ff0000" }}>MG 上半场 –下半场</span></p>
      <p>您必须预测两队仅参考上半场的进球数之和，以及仅参考下半场比赛的两队的进球数之和。</p>
      <p><span style={{ color: "#ff0000" }}> MG 上半场 –最终结果</span></p>
      <p>您必须预测两队仅以上半场为参考的进球总数，以及两队整场比赛的进球总数。</p>
      <p><span style={{ color: "#ff0000" }}>1X 双重机会连击 + 多目标</span></p>
      <p>投注包括在相关比赛中同时预测比赛是否会结束（不包括加时赛和点球） 1X 会是什么？两队进球总数</p>
      <p><span style={{ color: "#ff0000" }}>双倍机会连击 X2 + 多目标</span></p>
      <p>投注包括在相关比赛中同时预测比赛是否会结束（不包括加时赛和点球） X 或 2，会是哪一个？两队进球总数</p>
      <p><span style={{ color: "#ff0000" }}>双倍机会连击 12 + 多目标</span></p>
      <p>投注包括在相关比赛中同时预测比赛是否会结束（不包括加时赛和点球） 1 或 2 以及哪一个将是两队进球总数</p>
      <p><span style={{ color: "#ff0000" }}>上半场主场获胜</span></p>
      <p>投注旨在确定在相关比赛中主队是否会完成比赛上半场领先，同时对方球队不执行标记。</p>
      <p>投注仅针对比赛的上半场。</p>
      <p><span style={{ color: "#ff0000" }}>上半场客胜零</span></p>
      <p>投注旨在确定在相关比赛中客队是否能完成比赛上半场领先，同时对方球队不执行标记。</p>
      <p>投注仅针对比赛的上半场。</p>
      <p><span style={{ color: "#ff0000" }}>下半场主场获胜</span></p>
      <p>投注旨在确定在相关比赛中主队是否会成为领先，同时，对方球队不会执行标记。</p>
      <p>投注仅针对比赛的下半场。</p>
      <p><span style={{ color: "#ff0000" }}>下半场以零客胜</span></p>
      <p>投注包括确定在相关比赛中客队是否会领先，同时，对方球队不会执行标记。</p>
      <p>投注仅针对比赛的下半场。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 15 分钟</span></p>
      <p>投注包括预测赛事前 15 分钟结束时的结果。可能的结果是 1（主队优势）、X（平局）和 2（客队优势）。 15:01之后的进球将不计算在内。出于投注目的考虑。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 30 分钟</span></p>
      <p>投注包括预测赛事前 30 分钟结束时的结果。可能的结果是 1（主队优势）、X（平局）和 2（客队优势）。从 30:01 分钟起的进球将不计算在内。出于投注目的考虑。</p>
      <p><span style={{ color: "#ff0000" }}>第一张卡</span></p>
      <p>您必须预测哪支球队将获得比赛常规时间内第一张黄牌或红牌。提供 3 种可能的结果：团队 1、团队 2 和无人（如果没有玩家收到牌，则获胜选择）。计算结果时，不会考虑向场上球员之外的人员（例如教练、替补球员或已被替换的球员）出示的牌。</p>
      <p><span style={{ color: "#ff0000" }}>最后一张卡片</span></p>
      <p>您必须预测哪支球队将获得比赛常规时间内最后一张黄牌或红牌。提供 3 种可能的结果：团队 1、团队 2 和无人（如果没有玩家收到牌，则获胜选择）。计算结果时，不会考虑向场上球员之外的人员（例如教练、替补球员或已被替换的球员）出示的牌。</p>
      <p><span style={{ color: "#ff0000" }}>标签下方/上方（仅限规定）</span></p>
      <p>您必须预测在参考比赛中，不包括加时赛和点球大战，两队出示的牌（黄牌或红牌）的总和是否为更低（低于）或更高（高于）所提供的点差。</p>
      <p>卡片的计数将是按以下方式进行：</p>
      <p>每张黄牌计为 1 分；</p>
      <p>每张红牌价值 2；</p>
      <p>玩家不能累积分数超过 3（典型的双黄牌并随后被驱逐）。</p>
      <p><br /></p>
      <p>出于投注目的，向替补球员和已经在球队中的球员出示的牌不被考虑。更换或终场哨响后，教练或技术人员。</p>
      <p><span style={{ color: "#ff0000" }}>首页标签下方/上方（仅限规定）</span></p>
      <p>您必须预测在参考比赛中，不包括加时赛和点球大战，向主队出示的牌（黄牌或红牌）的总和是否为更低（低于）或更高（高于）所提供的点差。</p>
      <p>卡片的计数将是按以下方式进行：</p>
      <p>每张黄牌计为 1 分；</p>
      <p>每张红牌价值 2；</p>
      <p>玩家不能累积分数超过 3（典型的双黄牌并随后被驱逐）。</p>
      <p>出于投注目的，向替补球员和已经在球队中的球员出示的牌不被考虑。或在终场哨响后更换教练或技术人员。</p>
      <p><span style={{ color: "#ff0000" }}>下/上宾客卡（仅限规定）</span></p>
      <p>您必须预测在参考比赛中，不包括加时赛和点球大战，向客队出示的牌（黄牌或红牌）的总和是否为更低（低于）或更高（高于）所提供的点差。</p>
      <p>卡片的计数将是按以下方式进行：</p>
      <p>每张黄牌计为 1 分；</p>
      <p>每张红牌价值 2；</p>
      <p>玩家不能累积分数超过 3（典型的双黄牌并随后被驱逐）。</p>
      <p>出于投注目的，向替补球员和已经在球队中的球员出示的牌不被考虑。或在终场哨响后更换教练或技术人员。</p>
      <p><span style={{ color: "#ff0000" }}>下/上上半张牌</span></p>
      <p>您必须仅考虑参考比赛的上半场来预测两队出示的牌（黄牌或红牌）的总和是否为更低（低于）或更高（高于）所提供的点差。</p>
      <p>卡片的计数将是按以下方式进行：</p>
      <p>每张黄牌计为 1 分；</p>
      <p>每张红牌价值 2；</p>
      <p>玩家不能累积分数超过 3（典型的双黄牌并随后被驱逐）。</p>
      <p>出于投注目的，向替补球员和已经在球队中的球员出示的牌不被考虑。或在终场哨响后更换教练或技术人员。</p>
      <p><span style={{ color: "#ff0000" }}>总牌数（赛前和现场）</span></p>
      <p>投注在于确定牌的总数，仅考虑参考比赛中的常规时间。</p>
      <p><span style={{ color: "#ff0000" }}>弹出是/否</span></p>
      <p>你必须预测比赛期间是否会在常规时间和任何加时赛中都会进行驱逐。赌注是仅指场上的球员。因此，任何替补球员、教练、经理和技术人员被驱逐的情况均不包括在投注范围内。他们也是不包括比赛结束后实施的任何驱逐。</p>
      <p><span style={{ color: "#ff0000" }}>处罚是/否</span></p>
      <p>您必须预测球队是否会在比赛中获胜。在规定时间和任何加时赛中是否判罚点球。</p>
      <p><span style={{ color: "#ff0000" }}>控球 - 1X2</span></p>
      <p>投注旨在确定在给定赛事结束时（包括任何加时赛和补时赛）哪支球队获得最高分数。高水平的控球能力。通过符号 1，您可以预测建议的第一支球队的最高控球百分比，而 2 则预测第二支建议的球队的最高控球百分比，其中两队之间的控球率。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 标签（仅限规定）</span></p>
      <p>您必须预测在参考比赛中（不包括加时赛和点球）哪支球队在经典 1X2 格式中记录的黄牌和红牌数量是否最多。</p>
      <p>卡片的计数将是按以下方式进行：</p>
      <p>每张黄牌计为 1 分；</p>
      <p>每张红牌价值 2；</p>
      <p>玩家不能累积分数超过 3（典型的双黄牌并随后被驱逐）。</p>
      <p>出于投注目的，向替补球员和已经在球队中的球员出示的牌不被考虑。终场哨响后，更换教练或技术人员。</p>
      <p><span style={{ color: "#ff0000" }}>群组卡片总数</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注在于确定特定赛事结束时所提议的各个组中的牌总数。仅指常规时间，不包括任何加时和罚球。</span></span></span></p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}>1X2 角</span></p>
      <p>您必须预测两支球队中哪一支会赢得比赛。比赛期间角球次数最多（不包括加时赛）。提供 3 种可能的结果：1（主队将获得最多角球）、2（客队将获得最多角球）和 X（两队将获得相同数量的角球）。</p>
      <p><span style={{ color: "#ff0000" }}>上半场1X2角球</span></p>
      <p>您必须预测两支球队中哪一支会赢得比赛。仅考虑参考比赛上半场的最大角球数。</p>
      <p>提供 3 种可能的结果：1（主队将获得最多角球）、2（客队将获得最多角球）和相同数量的角球）。</p>
      <p>如果重新开出角球（例如由于禁区内犯规），出于投注目的，赔率将为算作一个角。</p>
      <p>已判出但未取得的角球不计入在内。</p>
      <p><span style={{ color: "#ff0000" }}>上/下角（2 个选择）</span></p>
      <p>您必须预测比赛期间的角球总数是否为高于（高于）或低于（低于）所提供的点差。就投注而言，仅考虑常规时间，不包括任何加时和罚球。</p>
      <p><span style={{ color: "#ff0000" }}>上/下角（3 种选择）</span></p>
      <p>您必须预测比赛期间的角球总数是否为高于（高于）、低于（低于）或等于（恰好）所提供的点差。就投注而言，仅考虑常规时间，不包括任何加时和罚球。</p>
      <p><span style={{ color: "#ff0000" }}>角球让分 (1X2)</span></p>
      <p>你必须预测哪支球队会赢得比赛。比赛期间角球的最大数量，不包括考虑到投注中显示的让分的任何加时赛。让分指的是主队，当负数，当它是指客队时积极的。提供 3 种可能的结果：1（通过在角球的最终结果中减去或加上让分，主队将获得最多角球数）、2（通过在角球的最终结果中减去或加上让分）角球）角球，客队将获得最多角球）和角）。</p>
      <p><span style={{ color: "#ff0000" }}>奇/偶角球</span></p>
      <p>您必须预测比赛期间的角球总数是否为奇数或偶数。就投注而言，仅考虑常规时间，不包括任何加时和罚球。</p>
      <p><span style={{ color: "#ff0000" }}>上半场偶数/奇数角球</span></p>
      <p>您必须仅考虑比赛的上半场，预测两队开出的角球总数是否为偶数或奇数。</p>
      <p>如果重新开出角球（例如由于禁区内犯规），出于投注目的，赔率将为算作一个角。</p>
      <p>已判出但未取得的角球不计入在内。</p>
      <p><br /></p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}>主角上方/下方</span></p>
      <p>您必须预测主队在比赛中开出的角球总数是否为高于（高于）或低于（低于）所提供的点差。就投注而言，仅考虑常规时间，不包括任何加时和罚球。</p>
      <p><span style={{ color: "#ff0000" }}>本垒角上半场下方/上方</span></p>
      <p>您必须仅考虑比赛的上半场来预测主队开出的角球总数是否为更低（低于）或更高（高于）所提供的点差。</p>
      <p>如果重新开出角球（例如由于禁区内犯规），出于投注目的，赔率将为算作一个角。</p>
      <p>已判出但未取得的角球不计入在内。</p>
      <p><span style={{ color: "#ff0000" }}>客队上半场下/上角球</span></p>
      <p>您必须仅考虑比赛的上半场来预测客队开出的角球总数是否为更低（低于）或更高（高于）所提供的点差。</p>
      <p>如果重新开出角球（例如由于禁区内犯规），出于投注目的，赔率将为算作一个角。</p>
      <p>已判出但未取得的角球不计入在内。</p>
      <p><span style={{ color: "#ff0000" }}>上/下宾客角</span></p>
      <p>您必须预测客队在比赛中开出的角球总数是否为高于（高于）或低于（低于）所提供的点差。就投注而言，仅考虑常规时间，不包括任何加时和罚球。</p>
      <p><span style={{ color: "#ff0000" }}>右脚总数角度</span></p>
      <p>投注包括确定特定赛事结束时的角球总数。仅参考常规时间，不包括任何加时和罚球。</p>
      <p>提出的假设是：</p>
      <p>6-8</p>
      <p>9-11</p>
      <p>12-14</p>
      <p>更多共 14 条</p>
      <p><span style={{ color: "#ff0000" }}> 角落 - 主 O/U + 来宾 O/U</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括在参考比赛（不包括加时赛和点球大战）中预测“U/O 角球队 1”投注结果的正确匹配，其中“球队 1”指球队主办方，以及“U/O Corners Team 2”，其中 Team 2 表示主办球队。有 4 种可能的结果： - “低于 + 低于”：预测 1 队和 2 队开出的角球都将低于预先设定的值。 - “下+上”：预测一队开出的角球将低于预设值，而二队开出的角球将高于预设值。 - “大+小”：您预测第 1 队开出的角球将高于预设值，而第 2 队开出的角球将低于预设值。 - “Over + Over”：预测1队和2队所踢的角球均高于预先设定的值。仅在实际开出角球时才考虑角球，不单独考虑角球对于投注认证目的有效。出于报告目的以及所有其他情况，均以有关该事项的现行立法、法规和相关活动组织者发布的官方数据为准。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}> 角 - 1X2 + O/U</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>该投注旨在预测相关比赛中“1X2 角球”投注结果的正确匹配（不包括加时赛和点球大战）。和“U/O 角”。有 6 种可能的结果： - “1 + Under”：您预测主队将获胜更多的客队的角球数，本场比赛的角球数总和为低于预先设定的值。 - “1+Over”：您预测东道主队将获胜更多的客队的角球数，本场比赛的角球数总和为高于预先设定的值。 - “X + Under”：您预测两队将获得相同数量的角球，并且比赛中获得的角球总数为低于预先设定的值。 - “X + Over”：您预测两队将获得相同数量的角球，并且比赛中获得的角球总数为高于预先设定的值。 - “2 + Under”：您预测客队将击败更多的主队的角球数，并且比赛中角球数的总和为低于预先设定的值。 - “2 + Over”：您预测客队将赢得比赛。更多的主队的角球数，并且比赛中角球数的总和为高于预先设定的值。仅在实际开出角球时才考虑角球，不单独考虑角球对于投注认证目的有效。出于报告目的以及所有其他情况，均以有关该事项的现行立法、规定以及相关活动组织者发布的官方数据为准。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角度 - HT/FT</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测两支球队中哪支球队将赢得比赛。上半场和比赛结束时角球次数最多的是谁。仅指常规时间，不包括任何加时和罚球。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角度 - O/U 1T + O/U 2T</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测上半场角球总数是否为高于（大）或低于（小）于所提供的让分，同时如果比赛期间的角球总数为高于（高于）或低于（低于）所提供的点差。就投注而言，仅考虑常规时间，不包括任何加时和罚球。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}> 角落 - 总房子</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括确定主队在给定比赛结束时开出的角球总数。仅指常规时间，不包括任何加时和罚球。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角落 - 宾客总数</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括确定客队在给定比赛结束时开出角球的总数。仅指常规时间，不包括任何加时和罚球。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}> 角落 - 房屋总计 1T</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括确定主队在指定比赛上半场结束时开出的角球总数。 </span></span></span></p>
      <p><span style={{ color: "#ff0000" }}> 角落 - 房屋总计 2T</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注旨在确定主队在给定比赛下半场开出的角球总数。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}> 角落 - 客人总数 1T</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注旨在确定客队在指定比赛上半场结束时开出的角球总数。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}> 角落 - 客人总数 2T</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注旨在确定客队在给定比赛下半场开出的角球总数</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>角组数量</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>该投注旨在确定特定赛事结束时所提议的各组之间的角球总数。仅指常规时间，不包括任何加时和罚球。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>斧头角球比赛</span></p>
      <p>你必须预测哪支球队会获胜在参考比赛中第一个获得 X 个角球的球队，不包括加时赛和点球大战。</p>
      <p>将有 X 次角球始终在投注描述中注明。</p>
      <p>有 3 种可能的结果：</p>
      <p>Team1：会击败与客队相比，主队之前的角球次数为 X；</p>
      <p>Team2：会击败客队比主队先X次角球；</p>
      <p>两者都没有：两者都不会到达踢指定的 X 个角。</p>
      <p>如果重新开出角球（例如由于禁区内犯规），出于投注目的，赔率将为算作一个角。</p>
      <p>已判出但未取得的角球不计入在内。</p>
      <p><span style={{ color: "#ff0000" }}>机会混合</span></p>
      <p><span style={{ color: "#ff0000" }}>目标超过 2.5</span></p>
      <p>投注在于预测两个选择（进球或超过 2.5）中的至少一个是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>是：游戏将结束o 进球（两队均至少进一球） o 超过 2.5（两队总进球数之和大于两球）或两种结果。</p>
      <p>否：比赛将结束</p>
      <p><span style={{ color: "#ff0000" }}>目标或低于 2.5</span></p>
      <p>投注在于预测两个选择（GOAL 或 UNDER 2.5）中的至少一个是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束o 进球（两队均至少进一球） o 低于 2.5（两队总进球数之和少于三球）或两种结果。</p>
      <p>否：比赛将结束</p>
      <p><span style={{ color: "#ff0000" }}>没有目标或超过 2.5</span></p>
      <p>投注在于预测两个选择（NOGOAL 或 OVER 2.5）中的至少一个是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或 NOGOAL（两队中至少有一支球队在比赛中未得分）或 OVER 2.5（两队之间的总进球数之和将大于两个进球）或两种结果。</p>
      <p>否：比赛将结束</p>
      <p><span style={{ color: "#ff0000" }}>没有目标或低于 2.5</span></p>
      <p>投注在于预测两个选择（NOGOAL 或 UNDER 2.5）中的至少一个是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或 NOGOAL（两队中至少有一支球队在比赛中未得分）或 UNDER 2.5（两队之间的总进球数之和将少于 3 个进球）或两种结果。</p>
      <p>否：比赛将结束在所有其他情况下，因此进球（两支球队将至少进一球）和超过 2.5（两队之间的总进球数之和将大于两球）。</p>
      <p><span style={{ color: "#ff0000" }}>主队获胜或进球</span></p>
      <p>投注在于预测两个选择中至少一个（1 或 GOAL）是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束o 1（主队将赢得比赛） o GOAL（两支球队都至少进一球）或两种结果。</p>
      <p>否：比赛将结束在所有其他情况下，因此 x2（主队不会获胜）和 NOGOAL（两队中至少有一支队在比赛中没有得分）。</p>
      <p><span style={{ color: "#ff0000" }}>主队获胜或没有进球</span></p>
      <p>投注在于预测两个选择中至少一个（1 或 NOGOAL）是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束要么 1（主队将赢得比赛）或 NOGOAL（两队中至少有一支球队在比赛中没有得分）或两种结果。</p>
      <p>否：比赛将结束在所有其他情况下，因此 x2（主队不会获胜）和 GOAL（两支球队都将至少进一球）。</p>
      <p><span style={{ color: "#ff0000" }}>抽签或进球</span></p>
      <p>投注在于预测两个选择（X 或 GOAL）中的至少一个是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或 X（比赛将以平局结束）或 GOAL（两支球队都至少进一球）或两种结果。</p>
      <p>否：比赛将结束在所有其他情况下，因此为 12（比赛不会结束 X）和 NOGOAL（两队中至少有一支队在比赛中没有得分）。</p>
      <p><span style={{ color: "#ff0000" }}>DRAW 或 NOGOAL</span></p>
      <p>投注在于预测两个选择（X 或 NOGOAL）中的至少一个是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或 X（比赛将以平局结束）或 NOGOAL（两队中至少有一支球队在比赛中没有得分）或两种结果。</p>
      <p>否：游戏将结束。在所有其他情况下，因此 12（比赛不会结束 X）和 GOAL（两支球队都将至少进一球）</p>
      <p><span style={{ color: "#ff0000" }}>客队获胜或进球</span></p>
      <p>投注在于预测两个选择中至少一个（2 或 GOAL）是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或 2（客队将赢得比赛）或 GOAL（两支球队都至少进一球）或两种结果。</p>
      <p>否：游戏将结束。在所有其他情况下，因此 1X（客队不会获胜）和 NOGOAL（两队中至少有一支在比赛期间没有得分）。</p>
      <p><span style={{ color: "#ff0000" }}>客队获胜或没有进球</span></p>
      <p>投注在于预测两个选择中至少一个（2 或 NOGOAL）是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或 2（客队将赢得比赛）或 NOGOAL（两队中至少有一支球队在比赛中没有得分）或两种结果。</p>
      <p>否：游戏将结束。在所有其他情况下，因此 1X（客队不会获胜）和 GOAL（两支球队都将至少进一球）。</p>
      <p><span style={{ color: "#ff0000" }}>客队获胜或没有进球</span></p>
      <p>投注在于预测两个选择中至少一个（2 或 NOGOAL）是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或 2（客队将赢得比赛）或 NOGOAL（两队中至少有一支球队在比赛中没有得分）或两种结果。</p>
      <p>否：游戏将结束。在所有其他情况下，因此 1X（客队不会获胜）和 GOAL（两支球队都将至少进一球）。</p>
      <p><span style={{ color: "#ff0000" }}>主队获胜或超过 2.5</span></p>
      <p>投注在于预测两个选择中至少一个（1 或 OVER 2.5）是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束1（主队将赢得比赛）或 OVER 2.5（两队都至少进一球）或两种结果。</p>
      <p>否：游戏将结束。在所有其他情况下，因此 x2（主队不会获胜）和 UNDER 2.5（两队之间的总进球数之和将少于 3 个进球）</p>
      <p><span style={{ color: "#ff0000" }}>主队获胜或低于 2.5</span></p>
      <p>投注在于预测两个选择中至少一个（1 或 UNDER 2.5）是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束1（主队将赢得比赛）或 UNDER 2.5（两队之间的总进球数之和将少于 3 个进球）或两种结果。</p>
      <p>否：游戏将结束。在所有其他情况下，因此 X2（主队不会获胜）和 OVER 2.5（两队之间的总进球数之和将大于两个进球）</p>
      <p><span style={{ color: "#ff0000" }}>绘图或超过 2.5</span></p>
      <p>投注在于预测两个选择（X 或 OVER 2.5）中的至少一个是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或者 </p>
      <p>否：游戏将结束。在所有其他情况下，因此 12（比赛不会结束 X）和 UNDER 2.5（两队之间的总进球数将少于 3 个进球）。</p>
      <p><span style={{ color: "#ff0000" }}>绘图或低于 2.5</span></p>
      <p>投注在于预测两个选择（X 或 UNDER 2.5）中的至少一个是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或者 </p>
      <p>否：游戏将结束。在所有其他情况下，因此 12（比赛不会结束 </p>
      <p><span style={{ color: "#ff0000" }}>客队获胜或超过 2.5</span></p>
      <p>投注在于预测两个选择中至少一个（2 或 OVER 2.5）是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或 2（客队将赢得比赛）或 OVER 2.5（（两队之间的总进球数之和将大于两个进球）或两种结果。</p>
      <p>否：游戏将结束。在所有其他情况下，因此 1X（客队不会获胜）和 UNDER 2.5（两队之间的总进球数之和将少于 3 个进球）。</p>
      <p><span style={{ color: "#ff0000" }}>客队获胜或低于 2.5</span></p>
      <p>投注在于预测两个选择中至少一个（2 或 UNDER 2.5）是否会成功。相关比赛的获胜者，不包括任何加时赛和点球。</p>
      <p>有两种可能的结果：</p>
      <p>是：游戏将结束或 2（客队将赢得比赛）或 UNDER 2.5（两队之间的总进球数之和将少于 3 个进球）或两种结果。</p>
      <p>否：游戏将结束。在所有其他情况下，因此 1X（客队不会获胜）和 OVER 2.5（两队之间的总进球数之和将大于两个进球）。</p>
      <p><span style={{ color: "#ff0000" }}>部分/最终组合 + 下/上</span></p>
      <p>在相关比赛中，您必须同时预测上半场的结果和比赛的最终结果，以及两队的总进球数是否相同更低（UNDER）或更高（OVER）参考点差</p>
      <p><span style={{ color: "#ff0000" }}>三次机会 1 或 OVER 或 NG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 1. 是：游戏结束1（主队获胜）或 Over（比赛中进球总和将高于附加信息指定的阈值）或 NG（两支球队中至少一支球队未进球）或全部三种结果。 2.否：游戏将结束在所有其他情况下，因此 X2 和 Under 和 Goal</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 1 或 OVER 或 DD</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 1. 是：游戏结束1（主队获胜）或 Over（比赛中进球总和将高于附加信息指定的阈值）或 GG（两队均至少进一球）或全部三种结果。 2.否：游戏将结束在所有其他情况下，因此 X2 且低于且无进球</p>
      <p><span style={{ color: "#ff0000" }}>三重可能性 1 或 UNDER 或 NG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 1. 是：游戏结束1（主队获胜）或 Under（比赛中的进球总数将低于附加信息指定的阈值）或 NG（两支球队中至少一支球队未进球）或全部三种结果。 2.否：游戏将结束在所有其他情况下，因此 X2 和 Over 以及 Goal</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 1 或 UNDER 或 GG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 1. 是：游戏结束1（主队获胜）或 Under（比赛中进球总和将低于附加信息指定的阈值）或 GG（两支球队都至少进一球）或全部三种结果。 2.否：游戏将结束在所有其他情况下，因此 X2 和 Over 且没有进球</p>
      <p><span style={{ color: "#ff0000" }}>三次机会 X 或 OVER 或 NG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 1. 是：游戏结束X（平局）或 Over（比赛中进球总和将高于附加信息指定的阈值）或 NG（两支球队中至少一支球队未进球）或全部三种结果。 2.否：游戏将结束在所有其他情况下，因此 12 及以下和目标</p>
      <p><span style={{ color: "#ff0000" }}>三次机会 X 或 OVER 或 GG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 1. 是：游戏结束X（平局）或 Over（比赛中的进球总和将高于附加信息指定的阈值）或 GG（两支球队都将至少进一球）或全部三种结果。 2.否：游戏将结束在所有其他情况下，因此 12 岁及以下且无进球</p>
      <p><span style={{ color: "#ff0000" }}>三重可能性 X 或 UNDER 或 NG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 1. 是：游戏结束X（平局）或 Over（比赛中的进球总和将高于附加信息指定的阈值）或 GG（两支球队都将至少进一球）或全部三种结果。 2.否：游戏将结束在所有其他情况下，因此 12 岁及以下且无进球</p>
      <p><span style={{ color: "#ff0000" }}>三重可能性 X 或 UNDER 或 GG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 1. 是：游戏结束X（平局）或 Under（比赛总进球数少于 1.5）或 GG（两队均至少进一球）或全部三种结果。 2.否：游戏将结束在所有其他情况下，因此 12 岁及以上并且没有进球</p>
      <p><span style={{ color: "#ff0000" }}>三次机会 2 或 OVER 或 NG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 3. 是：游戏结束2（客队获胜）或 Over（比赛进球总和将高于附加信息指定的阈值）或 NG（两队中至少有一支球队未进球）或全部三种结果。 4.否：游戏将结束在所有其他情况下，因此 1X 以及低于和目标</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 2 或 OVER 或 GG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 3. 是：游戏结束2（客队获胜）或 Over（比赛进球总和将高于附加信息指定的阈值）或 GG（两队均至少进一球）或全部三种结果。 4.否：游戏将结束在所有其他情况下，因此 1X 且低于且无目标</p>
      <p><span style={{ color: "#ff0000" }}>三重可能性 2 或 UNDER 或 NG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 3. 是：游戏结束2（客队获胜）或 Under（比赛进球总和将低于附加信息指定的阈值）或 NG（两支球队中至少一支球队未进球）或全部三种结果。 4.否：游戏将结束在所有其他情况下，因此 1X 和 Over 以及 Goal</p>
      <p><span style={{ color: "#ff0000" }}>三重机会 2 或 UNDER 或 GG</span></p>
      <p>您必须预测投注描述中所示的三种结果中的至少一种是否会导致相关比赛的获胜者；一切都在规定范围内，不包括加时赛和任何处罚。结果是： 3. 是：游戏结束2（客队获胜）或 Under（比赛进球总数小于 1.5）或 GG（两队均至少进一球）或全部三种结果。 4.否：游戏将结束在所有其他情况下，因此 1X 和 Over 并且没有进球</p>
      <p><span style={{ color: "#ff0000" }}>裁判咨询VAR监控是/否</span></p>
      <p>您需要预测在相关比赛中他是否会比赛总监咨询（是）或不咨询（否）VAR（“视频助理裁判”）。通过协商，这意味着赛事总监将前往亲自在场外审查监视器上的操作（“现场审查”）；出于投注目的，不考虑仅通过耳机设备使用 VAR（“无声过牌”）；赌注是在“无声检查”的情况下，当裁判只是向 VAR 助理展示视频并相信他们的反应时，被视为失败者。出于投注目的，任何加时都包括在内</p>
      <p><span style={{ color: "#ff0000" }}>锦标赛下/上 – 一天进球数：</span></p>
      <p>对于任何选定锦标赛的某一天，您必须预测所有预定比赛的总进球数是否会高于或低于既定值。如果只有一场比赛被暂停（无论暂停时的结果如何并且在第二天晚上 11.59 之前没有重新开始）或未开始（并且在第二天晚上 11.59 之前没有开始），则授予两个进球；如果数字较大（从 2 开始），则针对该预测的投注将是全额退款（1.00 费用）。</p>
      <p><br /></p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>足球特价及预览</span></span></p>
      <p><span style={{ color: "#ff0000" }}>警告是/否</span></p>
      <p>您必须预测指定的玩家是否会在相关比赛中是否获得黄牌，不包括加时赛和点球。</p>
      <p>直接开除是不可能的。视为警告。</p>
      <p>出于投注目的，向替补球员和已经在球队中的球员出示的牌不被考虑。更换或终场哨响后，教练或技术人员。</p>
      <p>结果的认证是根据活动组织者提供的官方数据进行的。</p>
      <p>如果所选球员没有参加比赛，则对他的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>第一次警告</span></p>
      <p>你必须预测哪位玩家会来在相关比赛中首先获得黄牌，不包括加时赛和点球。</p>
      <p>除了球员姓名外，列表中还提供了以下结果：</p>
      <p>OTHER = 任何不在列表中的玩家</p>
      <p>无警告 = 没有球员在常规时间内预订</p>
      <p>如果公布名单中的球员没有上场，则对他接受的投注将被视为输家，因此在这种情况下这是不可能的。预计将退还赌注。</p>
      <p>直接开除是不可能的。视为警告。</p>
      <p>如果同时出示黄牌，则视为先吃到黄牌的球员。出示第一张黄牌。</p>
      <p>出于投注目的，向替补球员和已经在球队中的球员出示的牌不被考虑。终场哨响后，更换教练或技术人员。</p>
      <p>结果的认证是根据活动组织者提供的官方数据进行的。</p>
      <p><span style={{ color: "#ff0000" }}>射门</span></p>
      <p>您必须预测相关球员的射门总数（不包括加时赛）是否为高于（高于）或低于（低于）所提供的点差。</p>
      <p>在本文中，它被定义为“射门”。任何进入球网的得分尝试，或者如果没有被守门员或最后一人位置的球员阻止则可能进入球网的得分尝试。除非满足上述要求，否则击中球门柱或横梁的射门不计为射门。同样，由不在最后一人位置的球员挡出的射门不算作射门。</p>
      <p>仅在列表中存在的参考玩家不会采取的情况下作为会议的一部分，结果将是视为无效。</p>
      <p>结果的认证是根据赛事组织者和sofascore.com提供的官方数据进行的，以获取有关任何杆和/或横梁的信息。</p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>团队 1/团队 2 的总镜头下/上</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测“总拍摄次数”是否达到预期目标。比赛</span><span data-ccp-para="">，不包括加时赛，</span><span data-ccp-para="">由球队 1 或投注说明中提到的第一支球队进行投注比赛，或由球队 2 或投注说明中提到的第二支球队进行的比赛，将低于（UNDER）或高于（OVER）预先设定的价差。总射门数是指所有瞄准对手球门的射门，无论这些射门是在“内线”。门镜或“外面”门的镜子。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>总镜头数之下/之上</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测“总拍摄次数”是否达到预期目标。两支球队在比赛中的比赛</span><span data-ccp-para="">，不包括加时赛，</span><span data-ccp-para="">将低于（UNDER）或高于（OVER）预先设定的价差。总射门数是指所有瞄准对手球门的射门，无论这些射门是在“内线”。门的镜子，“外面”门的镜子。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>奇数/偶数总镜头</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测两队的总射门得分，</span><span data-ccp-para=" ">不包括加班时间，</span><span data-ccp-para="">应为偶数或奇数。 0 是被认为是平等的。总射门数是指所有瞄准对手球门的射门，无论这些射门是在“内线”。门的镜子，“外面”门的镜子。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>ASSIST</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测所选球员是否会进行比赛。比赛期间贡献 1 次助攻，不包括加时赛。我们所说的助攻是指直接传球让队友进球。对于官方结果，仅参考赛事官方机构 (legaseriea.it) 的总助攻数标题。如果球员没有上场，则选择将是被视为无效</span><span data-ccp-para="">无效</span><span data-ccp-para="">，如果他只上场 1 分钟，则投注将视为有效。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>犯规球员</span></span></p >
      <p>您必须预测在相关比赛中指定球员的犯规次数是否会大于指定的 X 值。任何额外时间将不予考虑。如果球员未参加比赛，则投注将被退还。球员在实际上场时就参加了比赛，即使时间有限。如果赛事未进行、暂停或在任何情况下未在规定规定的条款内结束，且尚未达到投注目的的可证明结果，则将退款。
        出于报告目的，以相关活动主办方发布的官方数据为准，如果没有后者，则以 SOFASCORE.COM 发布的数据为准。
        “犯规”是指被裁判判为禁止比赛并导致任意球或点球的任何违规行为。越位不被视为犯规。在比赛冲突中，比赛官员授予了优势规则，并随后警告球员不要计入该球员的总犯规数。然后必须判罚任意球或点球才能判定犯规。
      </p>
      <p><span style={{ color: "#ff0000" }}>低于/高于成功传球</span></p>
      <p><span data-ccp-para="">您需要预测是否在参考比赛中，排除任何加时</span><br /><span data-contrast="auto"><span>指定的玩家将执行已完成的步数低于（低于）或高于（高于）预先设定的值。</span></span>&nbsp;<br /> <span data-contrast="auto"><span data-ccp-para="">如果所投注的球员未参加比赛（参与是指实际上场的球员） ，这样的赌注是</span></span>&nbsp;<br /><span data-contrast="auto"><span data-ccp-para="">如果参加足球运动员的比赛，即使如果在有限的时间内，投注经过认证。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="">结果认证以活动组织者提供的官方数据为基础。</span> </span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>犯规次数低于/高于</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测“总犯规”次数是否达到预期目标。两队在比赛中的比赛</span><span data-ccp-para="">，不包括补时赛</span><span data-ccp-para="">，</span>< span data-ccp-para=""> 将</span><span data-ccp-para="">低于（低于）或高于（高于）预先设定的点差。</span></span> </p>
      <p><span data-contrast="auto"><span data-ccp-para="">出于报告目的，以相关活动主办方发布的规定和官方数据为准。或者，在官方竞赛网站上没有明确数据的情况下，参考sofascore.com数据</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>失球数低于/高于犯规</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">需要预测参考中是否匹配，</span><span data-ccp-para="">不包括加时赛的次数，</span><span data-ccp-para="">指定的球员将受到影响低于（低于）或高于（高于）预先设定值的犯规次数。如果投注的球员未能参加比赛，则该投注将被退还。如果足球运动员参加比赛，即使在有限的时间内，投注也是经过认证的。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">出于报告目的，以相关活动主办方发布的规定和官方数据为准。或者，在官方竞赛网站上没有明确数据的情况下，参考sofascore.com数据</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>1x2 球员射击</span></span></p >
      <p><span data-contrast="auto"><span data-ccp-para="">投注在于根据传统的 1X2 方法预测两名玩家中哪一位将执行比赛中最高射正次数</span><span data-ccp-para="">，不包括加时赛。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">在这种情况下，“射门”是指“射门”。任何进入球网的射门尝试，或者如果没有被守门员或最后一个位置的球员阻止则可能进入球网的射门尝试。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">射门击中门柱或球门横梁，除非满足上述要求，否则不算射门。同样，由不在最后一人位置的球员挡出的射门不算作射门。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">仅在列表中出现的参考球员不会采取的情况下作为会议的一部分，结果将是被视为 </span><span data-ccp-para="">无效</span><span data-ccp-para="">。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事组织者和sofascore.com 提供的官方数据为基础有关任何桩和/或横杆的信息。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球员预订和得分</span></span></ p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注包括预测球员在相关比赛中是否会得分至少有一个目标，它就会实现警告。如果这个它会发生将会产生结果是的结果是获胜者。在所有其他情况下，都会导致NO 结果为获胜者。投注的验证在常规时间结束时进行。直接驱逐是不可能的。视为警告。赌注将是仅指球场上的球员；终场哨声吹响后实施的任何处罚均不考虑在内，</span><span data-ccp-para="">也不考虑</span><span data- ccp-para="">已经对球员进行的处罚替补席上的人被经理、教练和工作人员取代。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如果指定球员未能参加比赛，则投注将被结算。已退款。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">某球员在以下情况下参加了比赛实际上占据了这个领域，即使是在有限的时间内。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事组织者和sofascore.com 提供的官方数据为基础任何信息。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>低于/高于玩家总镜头</span></span> </p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测“总拍摄次数”是否达到预期目标。由指定的玩家制作，这将是低于（UNDER）或高于（OVER）预先设定的点差。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">总射门数是指瞄准对手球门的所有射门，无论这些射门是否在“内部”门的镜子，“外面”门的镜子。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">一名球员在他参加比赛时实际上占据了这个领域，即使是在有限的时间内。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">仅在列表中出现的参考球员不会采取的情况下作为会议的一部分，结果将是被视为 </span><span data-ccp-para="">无效</span><span data-ccp-para="">。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事组织者和sofascore.com 提供的官方数据为基础任何信息。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注验证在常规时间结束时进行。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球员 X 助攻和得分</span></span> </p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注包括预测球员在相关比赛中是否会得分至少进一球，他就会进球至少一次助攻。如果这个它会发生将会产生结果</span><span data-ccp-para="">结果 YES 获胜。在所有其他情况下，都会导致NO 结果为获胜者。投注的验证在常规时间结束时进行。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如果指定球员未能参加比赛，则投注将已退款。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">一名球员在他参加比赛时实际上占据了这个领域，即使是在有限的时间内。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事组织者和sofascore.com 提供的官方数据为基础任何信息。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>球员 X 得分或助攻</span></span> </p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注包括预测球员在相关比赛中是否会得分至少一个目标或意志至少一次助攻。如果这个它会发生将会产生结果是的结果是获胜者。在所有其他情况下，都会导致NO 结果为获胜者。投注的验证在常规时间结束时进行。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如果指定球员未能参加比赛，则投注将已退款。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">一名球员在他参加比赛时实际上占据了这个领域，即使是在有限的时间内。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事组织者和sofascore.com 提供的官方数据为基础任何信息。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>外部空气进球是/否</span></span ></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测在相关比赛中（不包括加时赛）是否会出现禁区外进球。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如果这是它会发生将会产生结果是的结果是获胜者。在所有其他情况下，都会导致没有结果获胜。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">指定目标必须是从禁区外（罚球区线除外）踢球。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">出于报告目的，乌龙目标不会被视为目标，因此给出失败的结果。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以活动组织者提供的官方数据为基础。</span> </span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>标题目标是/否</span></span> </p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测在相关比赛中（不包括加时赛）是否会出现头球目标。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如果这是它会发生将会产生结果是的结果是获胜者。在所有其他情况下，都会导致没有结果获胜。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">出于报告目的，乌龙目标不会被视为目标，因此给出失败的结果。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以活动组织者提供的官方数据为基础。</span> </span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>恢复目标 是</span></span></ p >
      <p><span data-contrast="auto"><span data-ccp-para="">你必须预测是否会有相关比赛下半场伤停补时阶段至少进一球。下半场伤停补时是指从 90:01 分钟（第 91 秒）到裁判终场哨声响起的时间范围。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">出于报告目的，乌龙目标不会被视为目标，因此给出失败的结果。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以活动组织者提供的官方数据为基础。</span> </span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>低于/高于团队总投篮次数</span></span> </p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测“总拍摄次数”是否达到预期目标。由球队 1 或投注描述中提到的第一支球队在比赛中做出，或者由球队 2 或投注描述中提到的第二支球队做出，将被视为低于（UNDER）或高于（OVER）预先设定的价差。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">总射门数是指瞄准对手球门的所有射门，无论这些射门是否在“内部”门镜或“外面”门的镜子。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事组织者和sofascore.com 提供的官方数据为基础任何信息。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注验证在常规时间结束时进行。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>团队射门得分</span></span ></p>
      <p><span data-contrast="auto"><span data-ccp-para="">您必须预测“击中目标”的次数是否会达到目标。由球队 1 或投注描述中提到的第一支球队在比赛中做出，或者由球队 2 或投注描述中提到的第二支球队做出，将被视为低于（UNDER）或高于（OVER）预先设定的点差。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">在这种情况下，“射门”是指“射门”。任何进入球网的射门尝试，或者如果没有被守门员或最后一个位置的球员阻止则可能进入球网的射门尝试。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">射门击中门柱或球门横梁，除非满足上述要求，否则不算射门。同样，由不在最后一人位置的球员挡出的射门不算作射门。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以赛事组织者和sofascore.com 提供的官方数据为基础任何信息。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注验证在常规时间结束时进行。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>控球</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>1x2 控球</span></span></p >
      <p><span data-contrast="auto"><span data-ccp-para="">投注在于根据传统的 1X2 方法预测两支球队中哪支球队将赢得比赛。合计百分比最高参考比赛中的高控球权。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">结果认证以活动组织者提供的官方数据为基础。</span> </span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注验证在常规时间结束时进行。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>U/O 球队控球</span></span> </p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注在于预测参考比赛中球队是否控球率小于或等于（低于）或大于（高于）预先设定的值。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">指定如果球队记录的控球百分比“低于”结果获胜。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">出于报告目的，以及在所有其他情况下，针对该事项的现行立法、法规和官方数据以相关活动主办方发布为准。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注验证在常规时间结束时进行。</span></span></p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>替换不足/过度</span></span></ p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注在于预测两队在常规时间内（包括伤停补时）的换人次数总和是否为任何额外的时间，都会是低于（UNDER 结果）或高于（OVER 结果）指定阈值。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">报告以活动官方组织机构发布的为准。</span></span> </p>
      <p><span data-contrast="none"><span data-ccp-para="" style={{ color: "#ff0000" }}>偶数/奇数保存</span></span></ p>
      <p><span data-contrast="auto"><span data-ccp-para="">您需要预测在参考比赛中指定的守门员/球员是否会进球。偶数或奇数保存。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">球员未参加比赛的情况（参与是指实际上场的球员）谁是投注的主体，此类投注将被退还。</span></span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">如果足球运动员参加比赛，即使在有限的时间内，投注也是经过认证的。</span></span></p>
      <p><span data-ccp-para="">出于报告目的，以相关活动主办方发布的规定和官方数据为准。</span></p>
      <p><span data-contrast="auto"><span data-ccp-para="">投注验证在常规时间结束时进行。</span></span></p>
      <p><span style={{ color: "#ff0000" }}>第一得分手</span></p>
      <p>您必须预测在预定义列表中常规时间内第一个进球的球员。</p>
      <p>如果某个球员没有参加比赛（我们所说的参加是指实际上场的球员），而该球员的可能得分为投注对象，此类投注将被退还。</p>
      <p>如果一名球员在比赛进行期间替换，他将被仅当比赛结果为0a0</p>
      <p><span style={{ color: "#ff0000" }}>最后标记</span></p>
      <p>您必须从预定义的列表中预测在常规时间内最后进球的球员。</p>
      <p>如果某个球员没有参加比赛（我们所说的参与是指实际在球场上的球员），而他的目标可能是投注对象，此类投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>组合第一得分 + 精确结果</span></p>
      <p>你必须预测哪位球员会得分比赛的第一个进球将会是什么比赛的确切结果。可能得分为 的球员未参加比赛（参加是指实际在场的球员）投注对象，此类投注将被退还。</p>
      <p>如果所选球员尽管参加了比赛，但没有进球，则投注为失败者，即使有问题的玩家是在第一个进球进球前就被换下。</p>
      <p>就投注而言，仅计算常规时间，包括伤停补时，不包括任何加时和点球。投注涉及赛事描述中指示的比赛以及同一描述中指示的玩家。</p>
      <p>如果一名球员在比赛进行期间替换，他将被仅当比赛结果为0a0</p>
      <p><span style={{ color: "#ff0000" }}>组合标记是/否 + 确切结果</span></p>
      <p>你必须预测哪一个会是比赛的确切结果是赛事描述中指定的球员是否得分至少一个网络。就投注而言，仅计算常规时间，包括伤停补时，不包括任何加时和点球。</p>
      <p>如果在场的球员没有上场，则对其接受的投注将被退还。</p>
      <p>投注是指赛事描述中指定的比赛以及同一描述中指定的玩家。</p>
      <p><span style={{ color: "#ff0000" }}>是/否匹配中的双倍</span></p>
      <p>您必须预测所选球员是否会得分。比赛中至少进两个球。</p>
      <p>出于投注目的，只有常规时间才被视为有效。</p>
      <p>如果所选球员没有参加比赛，则对该球员的投注将被退还。如果选定的球员上场，即使是在有限的时间内，所下的投注也将得到认证。</p>
      <p><span style={{ color: "#ff0000" }}>HATRICK 是/否匹配</span></p>
      <p>您必须预测所选球员是否会得分。比赛中至少进三个球。出于投注目的，只有常规时间才被视为有效。</p>
      <p>如果所选球员没有参加比赛，则对该球员的投注将被退还。如果选定的球员上场，即使在有限的时间内，对其假设标记的投注也将得到验证。</p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}>组合第一得分 + 最终结果 1X2</span></p>
      <p>您必须预测最终结果以及事件描述中指定的玩家是否会得分。第一个网络。</p>
      <p>就投注目的而言，仅计算常规时间，包括伤停补时，不包括任何加时和点球。</p>
      <p>如果可能得分为0的球员未能参加比赛（参加是指实际在场的球员）投注对象，此类投注将被退还。</p>
      <p>如果一名球员在比赛进行期间替换，他将被仅当比赛结果为0a0</p>
      <p><span style={{ color: "#ff0000" }}>得分组合 + 最终结果 1X2</span></p>
      <p>您必须预测比赛的最终结果以及赛事描述中指定的球员是否会得分。至少一个网络。</p>
      <p>就投注目的而言，仅计算常规时间，包括伤停补时，不包括任何加时和点球。</p>
      <p>如果在场的球员没有上场，则对其接受的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>赢得赛事最佳得分手</span></p>
      <p>投注包括预测赛事结束时将获得的选手在常规时间和任何加时赛中进球数最多的球员，包括伤停补时，不包括 TS 后的点球</p>
      <p>其他项目（如果存在）包括列表中未明确指出的所有结果。</p>
      <p>如果多个进球获得最多进球数足球运动员是预计配额划分。</p>
      <p>如果梅西是赔率 2.50 与另一位玩家一起赢得排名，赔率 2.50 将是除以2..2.50/2=1.25</p>
      <p>如果 3 名玩家赢得排名，赔率将为除以3...2.50/3=0.83...等等。离开</p>
      <p><br /></p>
      <p>应当注意的是，对报告有效的分类是‘’。仅涉及进球数，不包括 TS 后的点球。</p>
      <p>官方进球数以赛事官方机构发布的信息为准</p>
      <p><span style={{ color: "#ff0000" }}>越位/越位</span></p>
      <p>您必须预测参考比赛中两队的越位总和是否为高于（高于）或低于（低于）所提供的点差。</p>
      <p>被视为“越位”当对方球队获得任意球并主罚时，向处于越位位置的球员吹哨。出于分配投注的目的，不考虑优势：必须判罚并踢出任意球。如果越位在上半场结束或比赛结束时未被判越位，则不会被判越位。在投注结束时考虑，因为没有被踢。</p>
      <p>结果的认证是根据活动组织者和/或sofascore.com提供的官方数据进行的</p>
      <p><span style={{ color: "#ff0000" }}>1X2 越位</span></p>
      <p>您必须根据传统的 1X2 方法预测两支球队中哪支球队将进行比赛。参考比赛中越位的最高次数。</p>
      <p>被视为“越位”当对方球队获得任意球并主罚时，向处于越位位置的球员吹哨。出于分配投注的目的，不考虑优势：必须判罚并踢出任意球。如果越位在上半场结束或比赛结束时未被判越位，则不会被判越位。在投注结束时考虑，因为没有被踢。</p>
      <p>结果的认证是根据活动组织者和/或sofascore.com提供的官方数据进行的</p>
      <p><span style={{ color: "#ff0000" }}>弹射是/否玩家 X</span></p>
      <p>投注包括预测指定的玩家是否会在相关比赛中被罚下场或未罚下场，不包括加时赛和点球。出于投注目的，向替补球员和已经在球队中的球员出示的牌不被考虑。或在终场哨响后更换教练或技术人员。</p>
      <p>结果的认证是根据活动组织者提供的官方数据进行的。</p>
      <p>如果所选球员没有参加比赛，则对他的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>成功传球的球员包括 TS。</span></p>
      <p>您需要预测指定球员是否会在相关比赛（包括加时赛）中上场。低于（低于）或高于（高于）预先设定值的已完成步数。如果所投注的球员没有参加比赛（参与是指实际上场的球员），则该投注将被退还。如果足球运动员参加比赛，即使在有限的时间内，投注也是经过认证的。报告时以相关活动主办方发布的规定和官方数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>保存玩家下/上TS.</span></p>
      <p>您需要预测在相关比赛（包括任何加时赛）中，指定的守门员/球员是否会进球。低于（低于）或高于（高于）预先设定值的扑救次数。如果所投注的球员没有参加比赛（我们所说的参加是指实际上场的球员），则该投注将被退还。如果足球运动员参加比赛，即使在有限的时间内，投注也是经过认证的。出于报告目的，以 Riferimento.com 活动主办方发布的规定和官方数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>U/O POLES/CROSSPIECES</span></p>
      <p>您需要预测参考比赛中击中的木制品（柱子/横杆）的数量是否为低于（低于）或高于（高于）预先设定的值。</p>
      <p>出于报告目的以及所有其他情况，均以有关此事的现行立法、法规和相关活动组织者发布的官方数据为准</p>
      <p><span style={{ color: "#ff0000" }}>上半场换人是/否</span></p>
      <p>您必须预测在相关比赛中是否会出现上半场结束前至少换人一次。</p>
      <p>出于分配投注的目的，半场期间的变化和比赛下半场的变化将不被考虑。</p>
      <p>结果的认证是根据活动组织者提供的官方数据进行的。</p>
      <p><span style={{ color: "#ff0000" }}>意大利的梦幻足球</span></p>
      <p>就投注目的而言，国家体育报纸《米兰体育报》显示的结果（fantavote）有效。</p>
      <p>如果选手没有参加比赛，则参考交锋记录为视为无效。</p>
      <p>如果玩家掷出 sv，则正面对战的参考将是视为无效。</p>
      <p>如果一名球员在比赛进行期间进入，则在任何时刻，投注将定期有效。</p>
      <p>如果两名玩家获得相同的幻想票，他们就会获胜。将会是的玩家’已经更多上场时间（伤病时间不计算在内）。</p>
      <p>海棠奖金：</p>
      <p>&middot;每进球 +3 分</p>
      <p>&middot;每扑出一个罚球，+3 分</p>
      <p>&middot;每得分 +3 分</p>
      <p>&middot;每次助攻 +1 分</p>
      <p>&middot;每次警告 -0.5 分</p>
      <p>&middot; +1 不败门将</p>
      <p>&middot;守门员每丢一个球 -1 分</p>
      <p>&middot;每次开除-1分</p>
      <p>&middot;每个乌龙球 -2 分</p>
      <p>&middot;错过点球-3分</p>
      <p><span style={{ color: "#ff0000" }}>梦幻足球（意大利甲级联赛除外）</span></p>
      <p>就投注目的而言，国家体育报《米兰体育报》所标明的成绩单成绩有效（如果报纸出于任何原因未公布成绩单，则以 fantapazz 应用成绩单为准），其中奖励/恶意将被添加或减少，如下所示。</p>
      <p>如果选手没有参加比赛，则参考交锋记录为视为无效。</p>
      <p>如果玩家获得 sv，则对战参考将被视为无效。</p>
      <p>如果一名球员在比赛进行期间进入，则在任何时刻，投注将定期有效。</p>
      <p>如果两名玩家获得相同的幻想票，他们就会获胜。将会是的玩家’已经更多上场时间（伤病时间不计算在内）。</p>
      <p>关于助攻，在欧冠比赛中，不会被计入梦幻票的计算中。</p>
      <p>海棠奖金：</p>
      <p>&middot;每进球 +3 分</p>
      <p>&middot;每扑出一个罚球，+3 分</p>
      <p>&middot;每得分 +3 分</p>
      <p>&middot;每次警告 -0.5 分</p>
      <p>&middot; +1 不败门将</p>
      <p>&middot;守门员每丢一个球 -1 分</p>
      <p>&middot;每次开除-1分</p>
      <p>&middot;每个乌龙球 -2 分</p>
      <p>&middot;错过点球-3分</p>
      <p>至于助攻，不会计入幻想票计算。</p>
      <p><span style={{ color: "#ff0000" }}>赢得比赛</span></p>
      <p>它包括预测将赢得比赛的球队。特定的体育赛事、锦标赛或比赛，从可能的结果列表中进行选择。其他项目（如果存在）包括列表中未明确指出的所有结果。</p>
      <p>最终成绩认证以赛事官方排名为准。</p>
      <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
      <p>投注包括预测列表中指定的球队将实现根据赛事排名确定最佳名次。如果已公布名单中的球队因任何原因未参加赛事，则已接受的投注将被视为输家且不予考虑。预计退款。</p>
      <p><span style={{ color: "#ff0000" }}>头对头</span></p>
      <p>您必须预测提议的两支球队中哪一支会获胜。在锦标赛结束时有一个更好的位置，否则他就会通过特定赛事（例如欧洲冠军联赛、意大利杯、世界锦标赛等）或杯赛决赛的轮次将获得胜利（包括任何加时赛和点球）。</p>
      <p>最终成绩认证以赛事官方排名为准。</p>
      <p>降级球队是/否投注包括预测特定球队是否会降级。本赛季结束后降级至低级别联赛。</p>
      <p>成绩认证指赛事官方排名。</p>
      <p><span style={{ color: "#ff0000" }}>团队晋升是/否</span></p>
      <p>投注包括预测特定球队是否会来足球锦标赛结束后晋升至高级锦标赛。</p>
      <p>成绩认证指赛事官方排名。</p>
      <p>除非另有说明，对赛事获胜者的赛前投注始终指谁成为持有者。不考虑附加赛前的排名。报告地’我只计算优惠券中相关冠军的最终获胜者。</p>
      <p><span style={{ color: "#ff0000" }}>下一位团队经理</span></p>
      <p>您必须预测列表中提供的球队中哪支球队将担任教练指定的教练。在列表中它将是他们所属的团队也始终在转会开始时在场。下注的结果是OTHER 存在表示教练与列表中不存在的球队签订合同的情况。对于此类投注，将注明以下内容：必须在截止日期之前将发生指示的事件。对于支付投注，我将执行以下操作：一线队官方网站上披露的信息是真实的。消息将会发生过渡到新团队。</p>
      <p><span style={{ color: "#ff0000" }}>下一支足球队</span></p>
      <p>您必须预测列表中提供的球队中哪支球队将参加比赛指定的玩家。在列表中它将是他们所属的团队也始终在转会开始时在场。下注的结果是OTHER 存在表示球员与列表中不存在的球队签订合同的情况。对于此类投注，将注明以下内容：必须在截止日期之前将发生指示的事件。对于支付投注，我将执行以下操作：一线队官方网站上披露的信息是真实的。消息将是转移到另一个团队。</p>
      <p><span style={{ color: "#ff0000" }}>教练团队 X 日期 Y</span></p>
      <p>你必须预测哪一个会是指定球队的下一位教练，从之前制定的名单中选择。截止日期是投注中指定的那个。下注的结果是提供“其他”，表明与指定球队签订合同的教练不是出现在列表中。为了结算投注，您将：教练签约球队或联合会的官方声明是真实的。</p>
      <p><span style={{ color: "#ff0000" }}>团队教练日期是/否</span></p>
      <p>投注包括预测指定人员是否会在提议的日期之前执教（是结果）或不是（否结果）赛事描述中指出的球队/国家。对于此类投注，将有一个指定了活动结束的最后期限将发生指示的事件。活动即将来临正式暂停指定个人的新任务。</p>
      <p>示例：</p>
      <p>&bull;足球特价</p>
      <p>巴西佩普·瓜迪奥拉教练（截至 2023 年 1 月 6 日）</p>
      <p>结果：是/没有</p>
      <p><span style={{ color: "#ff0000" }}>团队变更是/否</span></p>
      <p>投注在于预测指定的球员是否会在提议的日期改变/离开球队。您所属的团队（是）或不属于（否）</p>
      <p>。明确规定： - 投注将是报告结果为“是”如果指定球员在提议的日期之前终止合同。与主队的合同。 - 赌注将是报告结果为“否”在事件中其中指定的球员将退出比赛。对于此类投注，将有一个指定截止日期（日期发生指示的事件。出于报告目的并执行以下操作俱乐部发布的官方声明是真实的，并且对于所有不真实的内容现行部长令提到。</p>
      <p>出于报告目的以及所有其他情况，我将相关俱乐部发布的官方新闻稿真实可信。</p>
      <p><span style={{ color: "#ff0000" }}>上半场换人是/否</span></p>
      <p>您必须预测在相关比赛中是否会出现上半场结束前至少换人一次。</p>
      <p>出于分配投注的目的，半场期间的变化和比赛下半场的变化将不被考虑。</p>
      <p>结果的认证是根据赛事组织者提供的官方数据进行的。如果比赛暂停且未在一般规则规定的期限内恢复，则结果将在任何情况下处理无效。</p>
      <p><span style={{ color: "#ff0000" }}>主教练在比赛中受到警告</span></p>
      <p>您必须预测在相关比赛中，包括加时赛中，是否会出现指定主队的教练发出警告。直接驱逐是不可能的。视为警告。出于分配投注的目的，比赛终场哨响后的警告将不被考虑。结果的认证是根据赛事组织者提供的官方数据进行的。如果比赛暂停且未在一般规则规定的期限内恢复，则结果将在任何情况下处理无效。</p>
      <p><span style={{ color: "#ff0000" }}>比赛中客座教练警告</span></p>
      <p>您必须预测在相关比赛中，包括加时赛中，是否会出现指定客场球队的教练发出警告。直接驱逐是不可能的。视为警告。出于分配投注的目的，比赛终场哨响后的警告将不被考虑。结果的认证是根据赛事组织者提供的官方数据进行的。如果比赛暂停且未在一般规则规定的期限内恢复，则结果将在任何情况下处理无效。</p>
      <p><span style={{ color: "#ff0000" }}>主教练在比赛中被罚下场</span></p>
      <p>您必须预测在相关比赛中，包括加时赛中，是否会出现指定主队的教练被开除。出于分配投注的目的，比赛终场哨响后的警告/驱逐将不被考虑。结果的认证是根据赛事组织者提供的官方数据进行的。如果比赛暂停且未在一般规则规定的期限内恢复，则结果将在任何情况下处理无效。</p>
      <p><span style={{ color: "#ff0000" }}>客座教练在比赛中被罚下场</span></p>
      <p>您必须预测在相关比赛中，包括加时赛中，是否会出现将指定球队的教练开除。出于分配投注的目的，比赛终场哨响后的警告/驱逐将不被考虑。结果的认证是根据赛事组织者提供的官方数据进行的。如果比赛暂停且未在一般规则规定的期限内恢复，则结果将在任何情况下处理无效。</p>
      <p><span style={{ color: "#ff0000" }}>SCOR 主场处罚是/否</span></p>
      <p>您必须预测主队是否会得分。或在相关比赛（包括加时赛）中罚点球。不要这样做对加时赛结束时可能进行点球大战的信心。结果的认证是根据赛事组织者提供的官方数据进行的。如果比赛暂停且未在一般规则规定的期限内恢复，则结果将在任何情况下处理无效。</p>
      <p><span style={{ color: "#ff0000" }}>嘉宾得分处罚是/否</span></p>
      <p>您必须预测客队是否会进球。或在相关比赛（包括加时赛）中罚点球。不要这样做对加时赛结束时可能进行点球大战的信心。结果的认证是根据赛事组织者提供的官方数据进行的。如果比赛暂停且未在一般规则规定的期限内重新开始，则结果将在任何情况下处理无效。</p>
      <p><span style={{ color: "#ff0000" }}>错过主场罚球是/否</span></p>
      <p>你必须预测主队是否会犯错。或在相关比赛（包括加时赛）中罚点球。不要这样做对加时赛结束时可能进行点球大战的信心。结果的认证是根据赛事组织者提供的官方数据进行的。如果比赛暂停且未在一般规则规定的期限内重新开始，则结果将在任何情况下处理无效。</p>
      <p><span style={{ color: "#ff0000" }}>错过宾客处罚是/否</span></p>
      <p>你必须预测客队是否会犯错。或在相关比赛（包括加时赛）中罚点球。不要这样做对加时赛结束时可能进行点球大战的信心。结果的认证是根据赛事组织者提供的官方数据进行的。如果比赛暂停且未在一般规则规定的期限内重新开始，则结果将在任何情况下处理无效。</p>
      <p><span style={{ color: "#ff0000" }}>CASA DUO</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测在比赛的常规时间内，球员是否替补出场，至少进一球</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>嘉宾双人组</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测在比赛的常规时间内，球员是否替补出场，至少进一球</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>首页 - 目标+卡片+助攻</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测比赛选手是否在常规时间内被卡片训斥。出于投注目的，向替补席上或终场哨响后的球员出示的牌不被视为有效。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>嘉宾 - 目标+卡片+助攻</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测比赛选手是否在常规时间内带有标签。出于投注目的，向替补席上或终场哨响后的球员出示的牌不被视为有效。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>HOME - 进球或卡或助攻</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测比赛选手是否在常规时间内出于投注目的，向替补席上或终场哨响后的球员出示的牌不被视为有效。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>嘉宾 - 进球或卡片或助攻</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测比赛选手是否在常规时间内出于投注目的，向替补席上或终场哨响后的球员出示的牌不被视为有效。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>替换标记 </span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测在比赛的常规时间内替补出场的球员是否至少进球</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>标记回家间隔 30 分钟。</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测主队的特定球员是否会得分。至少一个目标，仅考虑指定的时间段。 </span></span></span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>出于投注目的，仅考虑指定的分钟数。</span></span></span><span style={{ color: "#666666" }}><span style={{ fontFamily: "宋体,无衬线" }}><span style={{ fontSize: "medium" }}><br /> </span></span></span><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>如果所选球员在指定分钟内未上场，则投注其中将是已退款。</span></span></span></p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}>标记访客间隔 30 分钟。</span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>投注包括预测客队的特定球员是否会得分。至少一个目标，仅考虑指定的时间段。 </span></span></span></p>
      <p><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>出于投注目的，仅考虑指定的分钟数。</span></span></span><span style={{ color: "#666666" }}><span style={{ fontFamily: "宋体,无衬线" }}><span style={{ fontSize: "medium" }}><br /> </span></span></span><span style={{ color: "#666666" }}><span style={{ fontFamily: "Arial, sans-serif" }}><span style={{ fontSize: "medium" }}>如果所选球员在指定分钟内未上场，则投注其中将是已退款。</span></span></span></p>
      <p><span style={{ color: "#ff0000" }}>记分器输入和得分</span></p>
      <p>你必须预测所选玩家是否会接管替补上场并且会得分至少一个网络。参加比赛的球员将与未参加比赛的球员一样被视为无效。在比赛中甚至没有一秒钟。如果赛事暂停和/或推迟，则适用足球的一般规则。</p>
      <p><span style={{ color: "#ff0000" }}>U/O PLUS </span></p>
      <p>投注在于预测在参考比赛期间，进球数和门柱\横杆的总和是否会低于（UNDER）或高于（OVER）特定值 X。出于投注目的，仅考虑次数被视为规则，不包括任何加时赛和处罚。示例：指数 X = 2.5； “尤文图斯-那不勒斯”赛事。如果“尤文图斯 - 那不勒斯”比赛最终双方1-1战平，第70分钟，尤文图斯球员击中立柱，进球数与门柱/横梁之和为3，胜负结束。如果“尤文图斯 - 那不勒斯”比赛最终比分 1-0，且双方均未击中门柱，进球数与门柱/横梁之和为 1，因此获胜结果为“下”。出于报告目的以及所有其他情况，将以赛事组织机构的报告为准。在组织机构未提供具体数据的情况下，以sofascore.com发布的数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>U/O PLUS TEMPO Y</span></p>
      <p>投注包括预测在参考比赛的时间 Y 期间，进球数和门柱/横梁的总和是否会低于（UNDER）或高于（OVER）特定值（仅限指定的常规时间加上任何恢复时间） 。示例：索引 X = 1.5 且 Y= 时间 1； “米兰-国际米兰”活动。如果“米兰 - 国际米兰”比赛的下半场最终比分1-0，国米球员在第30分钟击中门柱，进球数与门柱/横梁之和为2，因此胜负结束。如果“米兰 - 国际米兰”比赛的下半场最终比分是 0-0，且两队均未击中门柱，进球数与门柱/横梁之和为 0，因此获胜结果为 UNDER。出于报告目的以及所有其他情况，将以赛事组织机构的报告为准。在组织机构未提供具体数据的情况下，以sofascore.com发布的数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>U/O PLUS Y 队 </span></p>
      <p>该投注旨在预测在相关比赛期间，Y 队的进球数和门柱/横梁总和是否低于 (UNDER) 或高于 (OVER) 特定值 X。出于投注目的，他们仅考虑常规时间，不包括任何加时赛和罚球。示例：X 索引 = 1.5，Y 索引 = 团队 2； “米兰-国际米兰”活动。如果“米兰 - 国际米兰”比赛最终双方1-1战平，第70分钟国际米兰球员击中立柱，国际米兰进球数和门柱/横梁总数为2，因此胜负结束。如果“米兰 - 国际米兰”比赛最终比分是 1-0，国米没有球员击中门柱，国米的进球数和门柱/横梁总和为 0，因此获胜结果为 UNDER。出于报告目的以及所有其他情况，将以赛事组织机构的报告为准。在组织机构未提供具体数据的情况下，以sofascore.com发布的数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>有目标/无目标加</span></p>
      <p>投注包括预测在相关比赛期间，两队是否都至少进球一球，或者两队是否击中至少一个门柱/横梁，或者一个进球而另一队击中至少一个门柱/横梁。出于投注目的，仅考虑常规时间，不包括任何加时和罚球。示例：“米兰 - 国际米兰”事件。如果“米兰 - 国际米兰”比赛最终1-0结束，国际米兰击中立柱，获胜结果是YES。如果“米兰 - 国际米兰”比赛1-0结束，米兰击中立柱，结果是失败者。出于报告目的以及所有其他情况，将以赛事组织机构的报告为准。在组织机构未提供具体数据的情况下，以sofascore.com发布的数据为准。</p>
      <p><span style={{ color: "#ff0000" }}>PLUS MARKER </span></p>
      <p>投注包括预测在比赛的常规时间和任何加时赛中，所投注的球员或替补席上的球员是否至少进球一个进球或击中至少一个门柱/横梁。 </p>
      <p>结果的认证是根据赛事组织者提供的官方数据进行的。对于任何未指定的内容，适用于足球的一般规则。</p>
      <p>应该注意的是，在偏转后最终击中立柱或横梁的射门可能不会被认证为直接射门，因此这种结果将导致失败。无论如何，官方认证是’始终由赛事组织者发布，只有在赛事组织者缺乏官方报告的情况下，才会替代参考sofascore.com发布的数据。
      </p>
      <p><span style={{ color: "#ff0000" }}>U/O 射门+</span></p>
      <p>投注包括预测球员 Y 及其可能的替补球员在比赛结束（包括任何加时赛）时的射门总数是否为低于或高于参考指数结束。<br />
        “UNDER”结果如果出现以下情况，则会发生：<br />
        ＆公牛;球员 Y 击中目标的次数低于参考指数 X，并且不会被替换
        ＆公牛;球员 Y 被替换，球员 Y 及其替补球员的射门次数为低于参考指数X<br />
        ＆公牛;球员 Y 替补出场，未被替换，射门次数低于参考指数
        ＆公牛;球员 Y 替补出场并被替换，球员 Y 及其替补球员的射门次数为低于参考指数X。 <br />
        “结束”的结果如果出现以下情况，则会发生：<br />
        ＆公牛;球员 Y 射门次数高于参考指数 X，且不被替换
        ＆公牛;球员 Y 被替换，球员 Y 及其替补球员的射门次数为高于参考指数X<br />
        ＆公牛;球员 Y 及其替补球员的射正次数均高于参考指数
        ＆公牛;球员 Y 替补出场，射门次数高于参考指数 X，且未被替换<br />
        ＆公牛;球员 Y 替补出场并被替换，球员 Y 及其替补球员的射门次数为高于参考指数X。 <br />
        如果选手 Y 没有参加比赛，则投注将被退还。一名球员在他参加比赛时实际上，尽管时间有限，但还是占据了这个领域。对于“射门”指射入对方球门内的射门（即使击中门柱或横梁），或者如果没有被守门员或最后一人位置的球员阻止则可能射入球网；任何击中门柱或横梁的行为都将被视为射门。出于报告目的，我将对官方组织机构（Legacalcio - UEFA - FIFA 等）传达的信息有信心，否则将被参考SOFASCORE提供的数据。对于未提及的任何内容，请参考一般足球规则。示例：对于索引TS 如果球员 Y 及其替补球员的射门总数为低于 2.5 获胜结果是在下面。如果球员 Y 及其替补球员的射门次数为高于 2.5 获胜结果是结束。<br />
      </p>
      <p><span style={{ color: "#ff0000" }}>加号标签</span></p>
      <p>投注在于预测玩家是否为了确定获胜结果，在球员比赛、伤停补时、任何加时、任何点球大战以及终场哨响后发出的所有可能的牌（黄牌或红牌）。</p>
      <p>• 如果结果为“是”，则预测以下可能性之一：</p>
      <p>- 球员 X 至少收到一张牌（黄色或红色）[即使是在替补席上或在终场哨响后]； </p>
      <p>- 玩家 </p>
      <p>- 玩家 </p>
      <p>- 球员 X 被之前在替补席上得到黄牌的球员替换；</p>
      <p>- 玩家 </p>
      <p>如果球员 X 替补上场，代替已经收到牌的球员，并且球员 </p>
      <p>如果玩家X没有参加比赛，则投注将被退还。</p>
      <p>球员在实际上场时参加了比赛，即使是在有限的时间内。</p>
      <p>出于报告目的以及所有其他情况，将适用相关活动组织者发布的规定和官方数据。对于任何未指定的内容，适用于足球的一般规则。</p>
      <p style={{ color: "#ff0000" }}>助攻二人组+黄牌加分</p>
      <p>投注包括预测在相关比赛的常规时间和任何加时赛中，球员是否替补席上的球员将至少送出一次助攻并获得至少一张牌（黄牌或红牌）。出于投注目的，球员 X 及其替补球员的助攻数和收到的牌数都会被考虑在内。如果球员 X 没有被替换，则仅考虑他的助攻和牌。注意。为了确定获胜结果，在球员比赛、伤停补时、任何加时、任何点球大战以及终场哨响后发出的所有可能的牌（黄牌或红牌）。</p>
      <p>结果为“是”预测出现以下可能性之一：</p>
      <p>- 球员 X 至少做出一次助攻并收到至少一张牌（黄色或红色）；</p>
      <p>- 玩家 </p>
      <p>- 玩家 </p>
      <p>- 玩家 </p>
      <p>结果为“否”预测出现以下可能性之一：</p>
      <p>- 玩家 </p>
      <p>- 玩家 </p>
      <p>- 玩家 </p>
      <p>- 玩家 </p>
      <p>- 玩家 </p>
      <p>- 玩家 X 没有协助，收到至少一张牌并且没有被替换。</p>
      <p>如果玩家做出助攻并收到一张牌，并且球员“否”。如果选手 X 没有参加比赛，则投注将为已退款。一名球员在他参加比赛时实际上占据了这个领域，即使是在有限的时间内。</p>
      <p>示例：莱奥或其替补助攻并领到黄牌 1. 莱奥在第 35 分钟吃到黄牌，没有助攻，并在第 57 分钟被换下。莫拉塔在第80分钟助攻。获胜结果：是。 2.莱奥第42分钟助攻但他没有收到任何牌，也没有被替换。获胜结果：NO。</p>
      <p>出于报告目的以及所有其他情况，均以有关该事项的现行立法、法规和相关活动组织者发布的官方数据为准；如果没有后者，将使用OPTA提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>Assist Duo O Ammonito Plus</p>
      <p>投注包括预测在相关比赛的常规时间和任何加时赛中，球员是否他将代替他在替补席上得分至少一次助攻或将获得相关比赛中至少有一张牌（黄牌或红牌）。注意。为了确定获胜结果，在球员比赛、伤停补时、任何加时赛、任何点球大战以及终场哨响后发出的所有可能的牌（黄牌或红牌）。结果“是”预测出现以下可能性之一：</p>
      <p>- 球员 X 至少获得一次助攻；</p>
      <p>- 玩家 </p>
      <p>- 吹响终场哨;</p>
      <p>- 玩家 </p>
      <p>- 玩家 </p>
      <p>- 球员 X 被替补席上先前收到黄牌的球员替换；</p>
      <p>- 玩家 </p>
      <p>结果为“否”预测出现以下可能性之一：</p>
      <p>- 玩家 </p>
      <p>- 玩家 </p>
      <p>如果玩家做出助攻或收到牌，并且球员“否”。如果选手 X 未能参加比赛，则投注金额为已退款。一名球员在他参加比赛时实际上占据了这个领域，即使是在有限的时间内。</p>
      <p>示例：R.Leao 或他的替补球员助攻或吃牌。 1. R.Leao没有助攻也没有吃到牌，第45分钟被换下贝纳塞尔在第 70 分钟助攻。获胜结果：是 2. R.Leao 没有助攻，没有收到牌，也没有被替换。获胜结果：NO。</p>
      <p>出于报告目的以及所有其他情况，均以有关此事的现行立法、法规和相关活动组织者发布的官方数据为准；如果没有后者，将使用OPTA提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>Assist Duo + Marker Plus</p>
      <p>投注包括预测玩家是否在常规时间和任何加时赛中替补上场的球员将至少进一球，或者至少击中门柱或横梁，并且球员 X 或其替补将在常规时间内至少送出 1 次助攻，并且比赛可能恢复，包括加时赛（是结果）或否（否结果），如果球员 X 未能参加比赛，则投注将已退款。球员在实际上场时就参加了比赛，即使是在有限的时间内。</p>
      <p>示例：莱奥或他的替补球员至少进球一球或击中至少一个门柱或横梁并至少获得一次助攻 包括 ST 1. 莱奥在第 35 分钟获得一次助攻但没有得分（也没有击中门柱/横梁）； 70’时他被莫拉塔换下，莫拉塔在第83分钟进球。获胜结果：是。 2.莱奥第35分钟助攻但没有得分（也没有击中门柱/横梁）； 70’时他被莫拉塔换下，并助攻85’但没有得分（也没有击中门柱/横梁）；获胜结果：NO。</p>
      <p>出于报告目的以及所有其他情况，均以有关此事的现行立法、法规和相关活动组织者发布的官方数据为准。专门针对门柱/横梁和助攻，如果没有后者，将使用 OPTA 提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>Assist Duo O Marker Plus</p>
      <p>投注包括预测在相关比赛的常规时间和加时赛中，球员是否在替补席上代替他的位置，至少进一球，或击中至少一根门柱或横梁，或至少助攻一次（结果是）或更少（结果否）。如果选手 X 没有参加比赛，则投注将为已退款。球员在实际上场时就参加了比赛，即使时间有限。示例：莫拉塔或他的替补球员至少进一球，或者至少击中一根门柱或横梁，或者至少送出一次助攻。 1.莫拉塔没有进球，没有击中立柱/横梁，也没有助攻，第55分钟被换下莱奥第70分钟助攻0. 获胜结果：是 2. 莫拉塔没有得分，没有击中门柱/横梁，没有助攻，也不是替补。获胜结果：NO。</p>
      <p>出于报告目的以及所有其他情况，请参阅有关该事项的现行立法、法规和政府发布的官方数据相关活动的组织者；专门针对门柱/横梁和助攻，如果没有后者，将使用 OPTA 提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>开始游戏。 X PLUS 得分 + PLUS 警告</p>
      <p>投注包括预测玩家是否在他的位置上，他们将在替补席上至少进一球，或者在常规时间内击中门柱或横梁。比赛的任何伤停补时阶段，包括加时赛，并且在任何加时赛、任何一系列罚球以及终场哨响后（“是”结果）或“否”（“否”结果），将至少收到一张牌（黄牌或红牌）的球员。如果选手 X 没有参加比赛，则投注将为已退款。球员在实际上场时就参加了比赛，即使是在有限的时间内。</p>
      <p>示例：球员 X 或其替补球员至少进一球或击中至少一根门柱或横梁，包括。 ts 并收到至少一张卡，包括。 ts、点球、替补、终场哨响后 1. D.Vlahovic 在第 37 分钟吃到一张牌并在 60’ 处更换。第75分钟，伊尔迪兹射门击中立柱。获胜结果：是。 2. D.Vlahovic进球但没有收到牌，第58分钟被换下来自耶尔迪兹（Yildiz），他击中了门柱/横梁，但没有收到牌。获胜结果：NO。</p>
      <p>出于报告目的以及所有其他情况，均以有关此事的现行立法、法规和相关活动组织者发布的官方数据为准。专用于柱子/横梁，如果没有后者，将使用OPTA提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>开始游戏。 X 加记分器或加警告</p>
      <p>投注包括预测相关比赛的常规时间和加时赛中，球员是否在替补席上代替他的位置，至少进一球或击中至少一个门柱/横梁或收到至少一张卡片（黄色或红色）。为了确定获胜结果，在球员比赛、伤停补时、任何加时赛、任何点球大战以及终场哨响后发出的所有可能的牌（黄牌或红牌）。如果玩家的结果是“是”，则获胜者如果玩家的结果为“否”，则获胜者如果玩家得分或击中门柱\横梁或已经如果已收到卡，并且玩家“否”。如果选手 X 没有参加比赛，则投注将为已退款。一名球员在他参加比赛时实际上占据了这个领域，即使是在有限的时间内。</p>
      <p>示例：玩家60°时更换第75分钟，耶尔迪兹击中立柱分钟。获胜结果：是。 2. D. Vlahovic 没有得分（也没有击中门柱/横梁），没有收到黄牌，也没有被换下。获胜结果：NO。</p>
      <p>出于报告目的以及所有其他情况，均以有关此事的现行立法、法规和相关活动组织者发布的官方数据为准。专用于柱子/横梁，如果没有后者，将使用OPTA提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>助攻二人组+得分手+黄牌+</p>
      <p>投注包括预测玩家是否替补席上的球员将至少进一球，否则将击中门柱或横梁以及球员比赛的任何伤停补时阶段，包括加时赛，并且在任何加时赛、任何一系列罚球以及终场哨响后（“是”结果）或“否”（“否”结果），将至少收到一张牌（黄牌或红牌）的球员。如果选手 X 没有参加比赛，则投注将为已退款。球员在实际上场时就参加了比赛，即使是在有限的时间内。</p>
      <p>示例：莱奥或他的替补球员至少进一球，或者至少击中一根门柱或横梁，至少做出一次助攻，并至少收到一张牌，包括罚牌。 ts，点球，终场哨响后坐在替补席上。 1、莱奥第35分钟助攻； 70’时他被莫拉塔换下，莫拉塔在第83分钟进球并被警告于84’。获胜结果：是。 2、莱奥第35分钟助攻； 70’时第73分钟，他被莫拉塔换下，后者击中立柱并且每次都会做出助攻85’；获胜结果：NO。</p>
      <p>出于报告目的以及所有其他情况，均以有关此事的现行立法、法规和相关活动组织者发布的官方数据为准。专门针对门柱/横梁和助攻，如果没有后者，将使用 OPTA 提供的数据。</p>
      <p>&nbsp;</p>
      <p style={{ color: "#ff0000" }}>助攻二人组或得分手 Plus 或预定 Plus</p>
      <p>投注在于预测玩家是否球员 X 或其替补球员，无论是在场上还是在替补席上，在比赛的任何时间，包括上场休息时间、伤停补时、任何加时、任何点球大战以及终场哨响后（“是”结果）或“否”（“否”结果）。如果选手 X 未能参加比赛，则投注金额为已退款。球员在实际上场时就参加了比赛，即使是在有限的时间内。</p>
      <p>示例：莫拉塔或他的替补球员至少打入一球，或击中至少一根门柱或横梁，或做出至少一次助攻，或至少收到一张牌，包括。 ts,.点球，替补，终场哨响后 1. 莫拉塔没有进球，没有击中门柱或横梁，没有助攻，也没有得到任何牌，他在第 55 分钟被换下第70分钟，莱奥助攻。获胜结果：是 2. 莫拉塔没有得分，没有击中门柱或横梁，没有助攻，没有收到牌，也不是替补。获胜结果：NO。</p>
      <p>出于报告目的以及所有其他情况，请参阅有关该事项的现行立法、法规和政府发布的官方数据相关活动的组织者。专门针对门柱/横梁和助攻，如果没有后者，将使用 OPTA 提供的数据。</p>
      <p><span style={{ color: "#ff0000" }}>双标签</span></p>
      <p>
        投注包括预测在比赛的常规时间内，球员是否
        结果的认证是根据赛事组织者提供的官方数据进行的。
      </p>
      <p><span style={{ color: "#ff0000" }}>警告二人组</span></p>
      <p>
        投注包括预测在比赛的常规时间内，球员 X 或替补席上的球员是否会在相关比赛中收到至少一张黄牌。
        结果的认证是根据赛事组织者提供的官方数据进行的。
      </p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>中场休息时进球数 XX.XX - YY.YY </span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内任一队是否会进球。有两种可能的结果：是或否。  例如：尤文图斯-国际米兰，进球时间为 00:00 分钟至 00:59 分钟。客户投注“是”，因此预测两支球队中的任何一支将在比赛期间进球。 00:00 和 00:59。如果在 00:00-00:59 期间（例如，当官方时钟显示 00:35 时）至少进一球，则投注获胜。如果在 00:00-00:59 期间没有进球，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，请参考是根据 ADM 的部长规则制定的。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>中场休息时踢出的角球 XX.XX - YY.YY </span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内任一队是否会发出角球。可能的结果有两种：是或否。出于结算目的，将考虑实际开出角球的时间，而不是判定角球的时间。  示例：尤文图斯-国际米兰角球从 00:00 分钟到 00:59 分钟客户投注“是”，因此预测比赛中任一队都会发出角球。在 00:00 到 00 之间： 59. 如果在 00:00-00:59 期间（例如当官方时钟显示 00:35 时）至少发出一个角球，则投注获胜。如果在 00:00-00:59 期间没有角球，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，该赌注参考了 ADM 的部长级条例。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>在 XX.XX - YY.YY 区间内提取卡</span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内，任一队是否会被出示黄牌或红牌。有两种可能的结果：是或否。为了结算投注，将考虑实际抽牌的时间，而不是犯规的时间。  示例：尤文图斯和国际米兰比赛从 00:00 分钟到 00:59 分钟，客户投注“是”，因此预测在 00:00 分钟到 00 分钟之间的比赛期间，任何一支球队都会抽出一张牌： 59. 和 00:59。如果在 00:00-00:59 期间（例如当官方时钟显示 00:35 时）出示至少一张黄牌或红牌，则投注获胜。如果在 00:00-00:59 期间没有抽牌，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，请参考是根据 ADM 的部长规则制定的。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>中场休息期间任意球 XX.XX - YY.YY </span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内任一队是否会踢任意球。可能的结果有两种：是或否。出于结算目的，实际踢出任意球的时间才计算，而不是判出任意球的时间。  例如：尤文图斯-国际米兰从 00:00 分钟到 00:59 分钟的任意球客户投注“是”，因此预测在 00:00 分钟到 00:59 分钟的比赛期间，任何一支球队都会发出任意球和 00:59。如果在 00:00-00:59 期间（例如，当官方时钟显示 00:35 分钟时）至少踢出一次任意球，则投注获胜。如果在 00:00-00:59 期间没有任意球，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，请参阅 ADM 的部长级条例。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>中场休息时后方掷界外球 XX.XX - YY.YY</span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内任一队是否会踢球门球。可能的结果有两种：是或否。出于结算目的，将考虑实际开出球门球的时间，而不是判定球门球的时间。  例如：尤文图斯-国际米兰球门球从 00:00 分钟到 00:59 分钟客户投注“是”，因此预测在 00:00 分钟到 00:59 分钟的比赛期间，任一队将发出球门球和 00:59。如果在 00:00-00:59 期间（例如，当官方时钟显示 00:35 分钟时）至少发出一个球门球，则投注获胜。如果在 00:00-00:59 期间没有开出球门球，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，请参阅 ADM 的部长级条例。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>半场休息时边线犯规 XX.XX - YY.YY </span></span></p>
      <p> 您必须预测在比赛的指定 1 分钟时间内任一队是否会掷界外球。可能的结果有两种：是或否。出于结算目的，将考虑实际掷界外球的时间，而不是判定掷界外球的时间。  例如：尤文图斯-国际米兰界外球从 00:00 分钟到 00:59 分钟客户投注“是”，因此预测在 00 分钟到 00:59 分钟的比赛期间，任一队将进行界外球:00 和 00:59。如果在 00:00-00:59 期间（例如，当官方时钟显示 00:35 时）至少判罚一次界外球，则投注获胜。如果在 00:00-00:59 期间没有发生横向犯规，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，请参阅 ADM 部长条例。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>中场休息时判罚点球 XX.XX - YY.YY </span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内任一队是否会判罚点球。可能的结果有两种：是或否。为了结算投注，将考虑判罚点球的时间。  示例：尤文图斯-国际米兰在 00:00 分钟至 00:59 分钟之间获得点球。客户投注“是”，因此预测在 00:00 分钟至 00 分钟之间的比赛期间，任一队将获得点球： 59. 和 00:59。如果在 00:00-00:59 期间（例如当官方时钟显示 00:35 时）至少判罚一次点球，则投注获胜。如果在 00:00-00:59 期间没有判罚点球，则投注失败。结果认证以赛事组织者提供的官方数据为依据。如果比赛暂停或中断，将参考 ADM 的部长规定。 进球数 中场休息 XX.XX -是呀是呀 您必须预测在比赛的指定 1 分钟时间内任一队是否会进球。有两种可能的结果：是或否。  例如：尤文图斯-米兰，进球时间为 00:00 分钟至 00:59 分钟。客户投注“是”，因此预测在比赛期间，两支球队中的任何一支都会进球。 00:00 和 00:59。如果在 00:00-00:59 期间（例如，当官方时钟显示 00:35 时）至少进一球，则投注获胜。如果在 00:00-00:59 期间没有进球，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，请参考是根据一般足球规则制定的。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>中场休息时踢出的角球 XX.XX - YY.YY</span></span></p>
      <p> 您必须预测在比赛的指定 1 分钟时间内任一队是否会发出角球。可能的结果有两种：是或否。出于结算目的，将考虑实际开出角球的时间，而不是判定角球的时间。  示例：尤文图斯-那不勒斯角球从 00:00 分钟到 00:59 分钟客户投注“是”，因此预测比赛中任一队将发出角球。在 00:00 到 00 之间： 59. 如果在 00:00-00:59 期间（例如当官方时钟显示 00:35 时）至少发出一个角球，则投注获胜。如果在 00:00-00:59 期间没有角球，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，投注依据一般足球规则。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>在 XX.XX - YY.YY 区间内提取卡 </span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内，任一队是否会被出示黄牌或红牌。有两种可能的结果：是或否。为了结算投注，将考虑实际抽牌的时间，而不是犯规的时间。  示例：那不勒斯国际米兰对阵国际米兰的比赛从 00:00 分钟到 00:59 分钟，客户投注“是”，因此预测在 00:00 分钟到 00 分钟之间的比赛期间，任何一支球队都会抽出一张牌： 59. 和 00:59。如果在 00:00-00:59 期间（例如当官方时钟显示 00:35 时）出示至少一张黄牌或红牌，则投注获胜。如果在 00:00-00:59 期间没有抽牌，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，请参考是根据一般足球规则制定的。</p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>中场休息期间任意球 XX.XX - YY.YY</span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内任一队是否会踢任意球。可能的结果有两种：是或否。出于结算目的，实际踢出任意球的时间才计算，而不是判出任意球的时间。  例如：尤文图斯-国际米兰从 00:00 分钟到 00:59 分钟的任意球客户投注“是”，因此预测在 00:00 分钟到 00:59 分钟的比赛期间，任何一支球队都会发出任意球和 00:59。如果在 00:00-00:59 期间（例如，当官方时钟显示 00:35 分钟时）至少踢出一次任意球，则投注获胜。如果在 00:00-00:59 期间没有踢出任意球，则投注失败。 结果认证以赛事主办方提供的官方数据为准。如比赛暂停或中断，则参考一般足球规则。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>中场休息时后方掷界外球 XX.XX - YY.YY </span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内任一队是否会踢球门球。可能的结果有两种：是或否。出于结算目的，将考虑实际开出球门球的时间，而不是判定球门球的时间。  例如：罗马队-国际米兰球门球从 00:00 分钟到 00:59 分钟客户投注“是”，因此预测在 00:00 分钟到 00:59 分钟的比赛期间，任一队将发出球门球和 00:59。如果在 00:00-00:59 期间（例如，当官方时钟显示 00:35 分钟时）至少发出一个球门球，则投注获胜。如果在 00:00-00:59 期间没有开出球门球，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，参照足球一般规则。</p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}> 第 XX.XX 至 YY.YY 节期间发生横向犯规 </span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内任一队是否会掷界外球。可能的结果有两种：是或否。出于结算目的，将考虑实际掷界外球的时间，而不是判定掷界外球的时间。  例如：米兰国际米兰在 00:00 分钟至 00:59 分钟之间掷界外球。客户投注“是”，因此预测比赛期间两队中任意一队将掷界外球00:00 至 00:59 分钟之间。如果在 00:00-00:59 期间（例如当官方时钟显示 00:35 时）至少判罚一次界外球，则投注获胜。如果在 00:00-00:59 期间没有发生横向犯规，则投注失败。结果的认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，参考一般足球规则。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}> 中场休息时判罚点球 XX.XX - YY.YY </span></span></p>
      <p>您必须预测在比赛的指定 1 分钟时间内任一队是否会判罚点球。可能的结果有两种：是或否。为了结算投注，将考虑判罚点球的时间。  示例：尤文图斯对阵国际米兰的点球从 00:00 分钟到 00:59 分钟 客户投注“是”，从而预测在 00:00 至 00:59 的比赛期间，任一队将获得点球。如果在 00:00 期间至少获得一个点球- 00:59（例如当官方时钟显示00:35时），投注即获胜。如果在 00:00-00:59 期间没有判罚点球，则投注失败。结果认证以赛事组织者提供的官方数据为准。如果比赛暂停或中断，则参考一般足球规则。20:01 在任何情况下，以及任何未明确规定的市场如上所示，规则为：第 1 分钟从开球到 00:59...第 2 分钟从 01:00 到 01:59 等等。如果明确指示分钟和秒，则参考时间范围是市场上指示的时间范围。 </p>
      <br />
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>篮子</span></span></p>
      <p><span style={{ color: "#ff0000" }}>电汇结果</span></p>
      <p>投注包括通过选择以下两个选项之一来预测比赛的最终结果：</p>
      <p>为主队取得1场胜利；客队取得2胜。</p>
      <p>有效结果是比赛结束时获得的成绩，包括加时赛。</p>
      <p>示例：</p>
      <p>波士顿 - 多伦多 98-90：获胜分数：1</p>
      <p>波士顿 - 多伦多 92-95：获胜分数：2</p>
      <p><span style={{ color: "#ff0000" }}>电汇盘口</span></p>
      <p>投注包括通过选择以下两个选项之一来预测比赛的最终结果：</p>
      <p>为主队取得1场胜利；客队取得 2 场胜利，考虑到最喜欢的球队已被指定让分，出于投注目的，将从比赛结束时场上取得的成绩中减去。</p>
      <p>有效结果是比赛结束时获得的成绩，包括加时赛</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 1°时间</span></p>
      <p>投注包括预测哪支球队将赢得比赛。 1 日开会的时间到了，结果将是通过将让分差值应用于所选球队的总得分来确定。出于投注目的，它将是仅考虑上半场取得的得分会议内容。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 2°时间</span></p>
      <p>投注包括预测哪支球队将赢得比赛。 2号开会的时间到了，结果将是通过将让分差值应用于所选球队的总得分来确定。出于投注目的，它将是仅考虑下半场取得的得分比赛时间和任何加时赛均不予考虑。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 1°第四</span></p>
      <p>投注包括预测哪支球队将赢得比赛。 1 日每四分之一场比赛的结果将是通过将让分差值应用于所选球队的总得分来确定。出于投注目的，它将是仅考虑第一轮取得的分数第四。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 2°第四</span></p>
      <p>投注包括预测哪支球队将赢得比赛。 2号每四分之一场比赛的结果将是通过将让分差值应用于所选球队的总得分来确定。出于投注目的，它将是仅考虑第二节取得的成绩第四。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 盘口 3°第四</span></p>
      <p>投注包括预测哪支球队将赢得比赛。 3号每四分之一场比赛的结果将是通过将让分差值应用于所选球队的总得分来确定。出于投注目的，它将是仅考虑第三节取得的得分第四。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 让分 4°第四</span></p>
      <p>投注包括预测哪支球队将赢得比赛。第四个每四分之一场比赛的结果将是通过将让分差值应用于所选球队的总得分来确定。出于投注目的，它将是仅考虑第四节取得的得分季度和任何加时将不被考虑。</p>
      <p><span style={{ color: "#ff0000" }}>T/T – X/季度</span></p>
      <p>投注在于预测比赛特定季度的最终结果。</p>
      <p>符号 1 预测第一个提议的球队获胜，符号 2 预测第二个提议的球队获胜。如果出现平局，赌注将被退还。</p>
      <p>对于第一节比赛之后的比赛，为了证明投注的目的，将参考该比赛季度在球场上取得的成绩。如果比赛暂停，则与比赛季度或未完成比赛季度相关的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 5pt 边距 </span></p>
      <p>投注包括根据以下方法预测比赛的最终结果：</p>
      <p>我为主队取得 1 场胜利，净胜分大于 5 分；</p>
      <p>签署 X 胜利，其中一支球队的差距不超过 5 分；</p>
      <p>客队以5分以上的优势取得2场胜利；</p>
      <p>有效结果是比赛结束时获得的成绩，包括加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 赛前 - 现场</span></p>
      <p>投注在于使用传统的 1X2 方法预测常规时间结束时的最终比赛结果：</p>
      <p>得分 1 主队获胜；</p>
      <p>画X标志；</p>
      <p>客队得 2 分获胜。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 1°时间</span></p>
      <p>投注旨在预测上半场比赛的结果。会议的。提供三种可能的结果：1（主队领先）、2（客队领先）、X（上半场比赛结束时两队势均力敌）。</p >
      <p><span style={{ color: "#ff0000" }}>1X2 2°时间</span></p>
      <p>投注在于预测下半场的结果。会议的。提供三种可能的结果：1（主队领先）、2（客队领先）、X（下半场比赛结束时两队势均力敌）。出于投注目的，它将是仅考虑下半场取得的得分比赛时间和任何加时赛均不予考虑。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 1°第四（不丢弃）</span></p>
      <p>投注在于预测第一场比赛的结果四分之一比赛。提供三种可能的结果：1（主队领先）、2（客队领先）、)。出于投注目的，它将是仅考虑第一轮取得的分数第四场比赛。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 2°第四（不丢弃）</span></p>
      <p>投注在于预测第二场比赛的结果四分之一比赛。提供三种可能的结果：1（主队领先）、2（客队领先）、)。出于投注目的，它将是仅考虑第二节取得的成绩第四场比赛。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 3°第四（不丢弃）</span></p>
      <p>投注在于预测第三场比赛的结果四分之一比赛。提供三种可能的结果：1（主队领先）、2（客队领先）、)。出于投注目的，它将是仅考虑第三节取得的得分第四场比赛。</p>
      <p><span style={{ color: "#ff0000" }}>1X2 4°第四（不丢弃）</span></p>
      <p>投注在于预测第四场比赛的结果四分之一比赛。提供三种可能的结果：1（主队领先）、2（客队领先）、)。出于投注目的，它将是仅考虑第四节取得的得分比赛的四分之一和任何加时赛将不被考虑。</p>
      <p><span style={{ color: "#ff0000" }}>1X2&ndash; X/季度（利差 2.5）</span></p>
      <p>投注在于预测比赛特定季度的最终结果。</p>
      <p>使用符号 1，您预测以大于 2 分的优势提出的第一支球队获胜，使用符号 2 预测以大于 2 分的优势提出的第二支球队获胜，使用符号 X 表示平局或分差小于或等于2分。</p>
      <p>对于第一节比赛之后的比赛，为了证明投注的目的，将参考该比赛季度在球场上取得的成绩。如果比赛暂停，则与比赛季度或未完成比赛季度相关的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>U/O点数3种选择（常规时间）</span></p>
      <p>您必须预测比赛结束时两队的得分总和是否为UNDER（低于预设参数）、OVER（高于预设参数）或 EXACTLY 等于预设参数。出于投注目的，仅考虑常规时间。</p>
      <p><span style={{ color: "#ff0000" }}>下/上分（包括附加分）（实时）</span></p>
      <p>投注包括预测比赛结束时两队的得分总和是否为UNDER（低于预设参数）或 OVER（高于预设参数）。出于投注目的，任何额外时间也将被考虑。</p>
      <p><span style={{ color: "#ff0000" }}>下/上点 1°时间</span></p>
      <p>投注在于预测两支球队在第一场比赛中的得分总和是否会议时间将是UNDER（低于设定点差）或 OVER（高于设定参数）。</p>
      <p><span style={{ color: "#ff0000" }}>下/上点 2°时间</span></p>
      <p>投注是预测两队在第二节的得分总和是否相同会议时间将是UNDER（低于设定点差）或 OVER（高于设定参数）。</p>
      <p><span style={{ color: "#ff0000" }}>下/上点 1°第四</span></p>
      <p>投注在于预测两支球队在第一场比赛中的得分总和是否每节比赛将UNDER（低于设定点差）或 OVER（高于设定参数）。</p>
      <p><span style={{ color: "#ff0000" }}>下/上点 2°第四</span></p>
      <p>投注是预测两队在第二节的得分总和是否相同每节比赛将UNDER（低于设定点差）或 OVER（高于设定参数）。</p>
      <p><span style={{ color: "#ff0000" }}>下/上点 3°第四</span></p>
      <p>投注是预测两队在第三节的得分总和是否相同每节比赛将UNDER（低于设定点差）或 OVER（高于设定参数）。</p>
      <p><span style={{ color: "#ff0000" }}>下/上点 4°第四</span></p>
      <p>投注是预测两队在第四节的得分总和是否相同每节比赛将UNDER（低于设定点差）或 OVER（高于设定参数）。</p>
      <p>出于投注目的，仅考虑第四节取得的得分四分之一比赛和任何加时赛将不被考虑。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于房屋分数（包括额外）（也实时）</span></p>
      <p>投注包括预测比赛结束时第 1 队的得分总和是否为UNDER（低于预设参数）或 OVER（高于预设参数）。出于投注目的，任何额外时间也将被考虑。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于宾客积分（包括额外）（也实时）</span></p>
      <p>投注包括预测比赛结束时第 2 队的得分总和是否为UNDER（低于预设参数）或 OVER（高于预设参数）。出于投注目的，任何额外时间也将被考虑。</p>
      <p><span style={{ color: "#ff0000" }}>下/上房屋点数 1°时间</span></p>
      <p>投注包括预测第一轮的总得分是否第 1 队的比赛时间为低于或高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于客人点 1°时间</span></p>
      <p>投注包括预测第一轮的总得分是否第 2 组的会议时间为低于或高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>下/上房屋点数 1°第四</span></p>
      <p>投注包括预测第一轮的总得分是否第 1 队的每节比赛将低于或高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于客人点 1°第四</span></p>
      <p>投注包括预测第一轮的总得分是否第 2 队的四分之一比赛将是低于或高于某个值。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数（包括附加）</span></p>
      <p>投注包括预测比赛结束时两队的总得分是否为偶数或奇数。加时赛也将被考虑用于投注目的。</p>
      <p><span style={{ color: "#ff0000" }}>偶/奇 1°时间</span></p>
      <p>投注是预测两支球队在第一场比赛中的得分总和是否会议时间将是偶数或奇数。出于投注目的，它将是仅考虑上半场取得的得分会议内容。</p>
      <p><span style={{ color: "#ff0000" }}>偶/奇 2°时间</span></p>
      <p>投注是预测两队在第二节的总得分是否相同会议时间将是偶数或奇数。出于投注目的，它将是仅考虑下半场取得的得分比赛时间和任何加时赛均不予考虑。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数庄家点数（包括附加点数）</span></p>
      <p>投注包括预测第 1 队在一场比赛（包括加时赛）中得分的总和是否为偶数或奇数。</p>
      <p><span style={{ color: "#ff0000" }}>奇数/偶数宾客积分（包括附加积分）</span></p>
      <p>投注包括预测第 2 队在一场比赛（包括加时赛）中的得分总和是否为偶数或奇数。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数 – X/季度</span></p>
      <p>投注包括预测两支球队在给定季度比赛中的得分总和是偶数还是奇数。</p>
      <p>如果比赛暂停，与比赛季度或未完成比赛季度相关的投注将被退还。</p>
      <p><span style={{ color: "#ff0000" }}>1°时间/决赛</span></p>
      <p>投注包括在比赛期间预测谁将赢得比赛的确切组合。上半场以及谁会获胜比赛。出于投注目的，仅考虑常规时间。</p>
      <p><span style={{ color: "#ff0000" }}>电汇结果 + U/O 积分（包括附加积分）</span></p>
      <p>投注同时预测比赛的获胜者以及两支球队的总得分是否为高于或低于预定指标。出于投注目的，任何额外时间也将被考虑。</p>
      <p><span style={{ color: "#ff0000" }}>得分最高的第四名高</span></p>
      <p>投注包括预测一场比赛的四分之一比赛，其中将有不止一场比赛得分。得分，将两支球队的得分相加。将提供 5 种可能的结果： 1°；第四，2°第四、第三第四，4°季度（不包括加时赛）和平局，当所有季度得分相同或 2 或以上时发生平局各季度的得分均高于其他季度。</p>
      <p><span style={{ color: "#ff0000" }}>加时赛是/否</span></p>
      <p>投注在于预测比赛是否会继续或者不在加时赛中。如果常规时间结束时的比分是如果是平局，比赛将通过加时赛继续进行，因此获胜的结果将是是的。如果获胜者已经确定从比分到第四节结束，不进行加时赛，胜出结果没有。</p>
      <p><span style={{ color: "#ff0000" }}>T/T 直播</span></p>
      <p>投注包括通过选择以下两个选项之一来预测比赛的最终结果：</p>
      <p>为主队取得1场胜利；客队取得2胜。</p>
      <p>有效结果是比赛结束时获得的成绩，包括加时赛。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于 Live house 积分</span></p>
      <p>该投注旨在预测比赛结束时第 1 队的得分总和是否为UNDER（低于预设参数）或 OVER（高于预设参数）。出于投注目的，任何额外时间也将被考虑。</p>
      <p><span style={{ color: "#ff0000" }}>现场嘉宾积分下/上</span></p>
      <p>投注包括预测比赛结束时第 2 队的得分总和是否为UNDER（低于预设参数）或 OVER（高于预设参数）。出于投注目的，任何额外时间也将被考虑。</p>
      <p><span style={{ color: "#ff0000" }}>低于/高于实时积分</span></p>
      <p>投注包括预测比赛结束时两队的得分总和是否为UNDER（低于预设参数）或 OVER（高于预设参数）。出于投注目的，任何额外时间也将被考虑。</p>
      <p><span style={{ color: "#ff0000" }}>下/上点 2°节奏直播</span></p>
      <p>投注是预测两队在第二节的得分总和是否相同会议时间将是UNDER（低于预先设定的点差）或OVER（高于预先设定的参数）。任何额外时间也将计入投注目的。</p>
      <p><span style={{ color: "#ff0000" }}>偶数/奇数直播</span></p>
      <p>投注包括预测比赛结束时两队的总得分是否为偶数或奇数。加时赛也将被考虑用于投注目的。</p>
      <p><span style={{ color: "#ff0000" }}>偶/奇 2°节奏直播</span></p>
      <p>投注是预测两队在第二节的总得分是否相同会议时间将是偶数或奇数。就投注目的而言，它将是考虑下半场的比分，包括加时赛</p>
      <p><span style={{ color: "#ff0000" }}>1X2 2°节奏直播</span></p>
      <p>投注在于预测下半场的结果。会议的。提供三种可能的结果：1（主队领先）、2（客队领先）、X（下半场比赛结束时两队势均力敌）。就投注目的而言，它将是考虑下半场的比分，包括加时赛</p>
      <p><span style={{ color: "#ff0000" }}>获胜点 n° x</span></p>
      <p>您必须预测两支球队中哪一支将最先获得所提供的各种分差中指定的分数。</p>
      <p>出于投注目的，加时赛也将被考虑。</p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}>注意</span></p>
      <p><span style={{ color: "#ff0000" }}>在现场 NBA 比赛中，出于热情好客的原因和英勇，球队倒序排列，即客队在前。</span></p>
      <p><br /></p>
      <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>篮球特价</span></span></p>
      <p><span style={{ color: "#ff0000" }}>1X2 标记</span></p>
      <p>投注旨在预测两名球员中哪一位将在给定比赛中获得最高分。有 3 种可能的投注结果： 符号 1 表示您预测第一个提议的玩家的最高分；使用符号 2，您预测第二个提议的玩家的最高分；用 X 符号表示您预测平局。两名提议球员之间的得分。如果两名球员之一或两人都没有进入比赛镶木地板（未能进入场地），则投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>球员得分低于/高于 3 分</span></p>
      <p>投注在于预测特定球员在给定比赛中的三分球命中数是否高于或低于给定值。任何额外的时间也将被考虑用于报告目的。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>低于/高于玩家分数</span></p>
      <p>投注包括预测特定球员在特定比赛中的总得分是高于（高于）还是低于（低于）给定的分差。在任何加时赛中获得的分数也被考虑用于投注目的。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>球员篮板下方/上方</span></p>
      <p>投注包括预测特定球员在特定比赛中赢得的篮板总数。任何额外的时间也将被考虑用于报告目的。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>辅助玩家下方/上方</span></p>
      <p>投注包括预测特定球员在特定比赛中的助攻总数。任何额外的时间也将被考虑用于报告目的。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>玩家双双是/否</span></p>
      <p>投注在于预测特定玩家是否会实现目标一场比赛中两双或以下（得分、篮板、助攻、盖帽、抢断两项主要统计项目合计至少10分）。如果你的分数至少超过 10 分其中2个统计项目中，市场的获胜结果将是“是的”。出于投注目的，还考虑在任何加时赛中取得的成绩。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><br /></p>
      <p><span style={{ color: "#c00000" }}>玩家三双是/否</span></p>
      <p>投注在于预测特定玩家是否会实现目标一场比赛中三双或以下（得分、篮板、助攻、盖帽、抢断三项统计合计至少10分）。如果你的分数至少超过 10 分其中 3 个统计项目中，市场的获胜结果将是“是”。出于投注目的，还考虑在任何加时赛中取得的成绩。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>得分+篮板+球员助攻下/上总和</span></p>
      <p>投注包括预测特定球员在特定比赛中得分、篮板和助攻的总和是否为高于或低于某个值。任何额外的时间也将被考虑用于报告目的。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>U/O 营业额</span></p>
      <p>投注包括预测比赛结束时两队的失误总数是否为高于（Over）或低于（Under）某个值。出于投注目的，任何额外时间也将被考虑。</p>
      <p><span style={{ color: "#c00000" }}>U/O篮板+被阻挡球员</span></p>
      <p>您必须预测特定球员在给定比赛中的断球和拦球总数是否为高于（Over）或低于（Under）某个值。任何额外的时间也将被考虑用于报告目的。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>U/O 球员抢断</span></p>
      <p>您必须预测特定球员在给定比赛中偷球是否会被高于（Over）或低于（Under）某个值。任何额外的时间也将被考虑用于报告目的。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>U/O 阻止玩家</span></p>
      <p>您必须预测在给定比赛中特定球员阻挡的球是否会被阻挡。高于（Over）或低于（Under）某个值。任何额外的时间也将被考虑用于报告目的。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>U/O 球员失误</span></p>
      <p>它包括预测特定球员在特定比赛中丢球的总数是否为高于（Over）或低于（Under）某个值。任何额外的时间也将被考虑用于报告目的。如果投注对象的球员没有上场，则所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>组合得分+助攻+篮板</span></p>
      <p>投注包括预测特定球员在特定比赛中得分、篮板和助攻的总和是否为高于或低于某个值。</p>
      <p>出于报告目的，任何额外时间也将被考虑。</p>
      <p>如果投注对象球员未上场，所有投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>组合 Puntii+ 辅助</span></p>
      <p>投注包括预测特定球员在特定比赛中得分和助攻的总和是否为高于或低于某个值。</p>
      <p>出于报告目的，任何额外时间也将被考虑。</p>
      <p>如果投注对象球员未上场，所有投注将被退还</p>
      <p><span style={{ color: "#c00000" }}>积分 + 篮板组合</span></p>
      <p>投注包括预测特定球员在特定比赛中得分和篮板的总和是否为高于或低于某个值。</p>
      <p>出于报告目的，任何额外时间也将被考虑。</p>
      <p>如果投注对象球员未上场，所有投注将被退还</p>
      <p><span style={{ color: "#c00000" }}>点 1°第四</span></p>
      <p>投注包括预测特定球员在第一节的总得分是否为高于（超过）或低于（低于）指定的十进制 X 值。</p>
      <p>如果球员没有上场或没有参加该季度，则所有投注将被退还。</p>
      <p>出于报告目的，我将组织机构传达的信仰。对于未提及的内容，请参阅现行法规。</p>
      <p><span style={{ color: "#c00000" }}>辅助 1°第四</span></p>
      <p>该投注旨在预测特定球员在第一节的助攻总数是否为高于（超过）或低于（低于）指定的十进制 X 值。</p>
      <p>如果球员没有上场或没有参加该季度，则所有投注将被退还。</p>
      <p>出于报告目的，我将组织机构传达的信仰。对于未提及的内容，请参阅现行法规。</p>
      <p><span style={{ color: "#c00000" }}>篮板 1°第四</span></p>
      <p>投注包括预测特定球员在第一节的篮板总数是否为高于（超过）或低于（低于）指定的十进制 X 值。</p>
      <p>如果球员没有上场或没有参加该季度，则所有投注将被退还。</p>
      <p>出于报告目的，我将组织机构传达的信仰。对于未提及的内容，请参阅现行法规。</p>
      <p><br /></p>
      <p><span style={{ color: "#c00000" }}><span style={{ fontSize: "large" }}>网球 / 网球直播</span></span></p>
      <p>如果其中一名球员在比赛前或比赛期间退赛（或取消资格），则该场比赛的所有投注均无效。所有结果为以下情况的投注均属例外：已经获得的成绩将根据场上取得的成绩进行更新（获胜第一盘-U/O第一盘-等），否则所有未获得明确认证的成绩将作废，包括头对-头。然而，如果是现场比赛，则将报告截至退出时所获得的所有成绩，所有未获得明确认证的成绩将被视为无效，包括面对面的比赛。如果球员在首场比赛前退出比赛，则与该球员相关的锦标赛获胜者或下一轮比赛的投注将被视为无效，而在其他情况下将被视为有效。如果在双打比赛中，四名选手中至少有一位在比赛开始前退出，而他的搭档决定与另一名选手一起参加比赛，则对该赛事的所有投注都将无效。</p>
      <p><span style={{ color: "#c00000" }}>头对头结果</span></p>
      <p>投注包括预测将赢得比赛的网球运动员。会议：</p>
      <p>表示网球运动员“1”的胜利。</p>
      <p>表示网球运动员“2”的胜利。</p>
      <p><span style={{ color: "#c00000" }}>HH 设置</span></p>
      <p>你必须预测哪位网球运动员会获胜参考集。</p>
      <p>如果由于两名网球运动员之一退出而导致该局比赛尚未开始或结束，则与该局本身相关的所有结果将被视为无效。</p>
      <p><span style={{ color: "#c00000" }}>设置投注</span></p>
      <p>投注包括预测比赛结束的确切比分（以局数表示）。会议。</p>
      <p><span style={{ color: "#c00000" }}>优胜者 1°设置</span></p>
      <p>投注包括预测将赢得比赛的网球运动员。 1 日九月。</p>
      <p><span style={{ color: "#c00000" }}>比赛下/上比赛</span></p>
      <p>投注在于预测在特定赛事结束时，比赛总数是否为高于或低于预先设定的保证金。</p>
      <p><span style={{ color: "#c00000" }}>对于上述投注，我们将继续如果事件没有发生或最终中断（如果事件尚未发生），则对相同的费用进行补偿。出于投注目的取得任何可证明的结果。</span></p>
      <p><span style={{ color: "#c00000" }}>如果赛事规则规定，如果出现平局，则采用超级抢七计分系统进行决胜局，如下对于大多数双打比赛，出于报告目的，该盘将是完全算作 1 场比赛</span></p>
      <p><br /></p>
      <p><span style={{ color: "#c00000" }}>设置数字 2/3</span></p>
      <p>您必须预测 3 盘两胜锦标赛中两名选手所打的总盘数。可能的结果是：“2” （比赛以2盘结束）和“3” （比赛以3局结束）。</p>
      <p><span style={{ color: "#c00000" }}>设置数字 3/5</span></p>
      <p>您必须预测 5 盘两胜制锦标赛中两名选手所打的总局数，可能的结果是：“3”或“3”。 （比赛以3局结束），“4” （比赛以4盘结束）和“5” （比赛将于9月5日结束）</p>
      <p><span style={{ color: "#c00000" }}>TIE-BREAK SET 1 YES/NO</span></p>
      <p>您必须预测在选定的比赛中是否会决定第一盘。或者不在抢七局。提供两种可能的结果：是；不会。如果该盘比赛未进行或最终中断，则投注将被退还，除非该盘比赛的比分未达到 6-6，在这种情况下，获胜结果将是“是”。</p>
      <p><span style={{ color: "#c00000" }}>精确结果集 1</span></p>
      <p>您必须预测所选比赛第一盘比赛的准确结果。如果比赛未进行或最终中断，投注将被退还。</p>
      <p><span style={{ color: "#c00000" }}>头对头让分游戏</span></p>
      <p>您必须通过将投注中指示的让分差应用于最终比赛结果来预测比赛的获胜者。</p>
      <p>注意：如果比赛规则规定，在出现平局的情况下，决胜局将采用超级抢七计分系统，就像大多数双打比赛一样，出于报告比赛结果的目的设置将是完全算作 1 场比赛。</p>
      <p><span style={{ color: "#c00000" }}>至少一组 6-0 或 0-6</span></p>
      <p>投注包括预测至少一组比赛是否以 0-6 或 6-0 的比分结束。我们将继续如果赛事未发生或最终中断（如果赛事尚未发生），则退还投注。出于投注目的取得任何可证明的结果。</p>
      <p><span style={{ color: "#c00000" }}>长盘/决胜局直播</span></p>
      <p>预计所有盘均已打完（3盘或5盘），最后盘将达到6-6</p>
      <p><span style={{ color: "#c00000" }}>UNDER/OVER 游戏 1°设置</span></p>
      <p>投注包括预测在给定赛事的第一盘结束时，比赛总数是否为高于或低于预先设定的保证金。如果赛事未发生，则投注将被退还；如果赛事尚未发生，则投注将被明确中断。出于投注目的取得任何可证明的结果。</p>
      <p><br /></p>
      <p><br /></p>
      <p><span style={{ color: "#c00000" }}>游戏玩家 1 下/上</span></p>
      <p>投注包括预测在特定赛事结束时，玩家 1 赢得的比赛总数是否为高于或低于预先设定的保证金。如果赛事未发生，则投注将被退还；如果赛事尚未发生，则投注将被明确中断。出于投注目的取得任何可证明的结果。</p>
      <p><span style={{ color: "#c00000" }}>游戏玩家 2 下/上</span></p>
      <p>投注包括预测在特定赛事结束时，玩家 2 赢得的比赛总数是否为高于或低于预先设定的保证金。如果赛事未发生，则投注将被退还；如果赛事尚未发生，则投注将被明确中断。出于投注目的取得任何可证明的结果。</p>
      <p><span style={{ color: "#c00000" }}>设置盘口</span></p>
      <p>您必须通过将投注中指示的盘分差应用于盘结束时的最终结果来预测比赛的获胜者。</p>
      <p>如果网球运动员在上场前或比赛期间退出，则让分盘接受的投注将被退还，除非结果可证明。</p>
      <p><span style={{ color: "#c00000" }}>1X2 让子游戏</span></p>
      <p>您必须预测一场比赛的结果，获得 1X2 的结果并在比赛结束时计算投注中显示的比赛让分。如果网球运动员在上场前或比赛期间退出，则在 1X2 让分盘吉奥奇上接受的投注将被退还，除非结果可证明。</p>
      <p><span style={{ color: "#c00000" }}>赢得至少一盘</span></p>
      <p>您必须预测所选玩家在比赛结束时是否赢得至少一场比赛。</p>
      <p>如果网球运动员在上场前或比赛期间退出，则赢得至少一盘的投注将被退还，除非结果可证明。</p>
      <p><span style={{ color: "#c00000" }}>第 X 盘获胜/下盘</span></p>
      <p>您必须预测优势比赛中获胜的总局数。有 2 种可能的结果：大盘和小盘。如果网球运动员在上场前或在第 X 盘比赛期间退出，则在第 X 盘获胜的小/大比赛中所接受的投注将被退还，除非结果可证明。</p>
      <p><span style={{ color: "#c00000" }}>精确得分游戏 X 设置 Y</span></p>
      <p>您必须预测指定游戏中的确切结果。结果是：玩家 1 以 0 获胜，玩家 1 以 15 获胜，玩家 1 以 30 获胜，玩家 1 以优势获胜；玩家以 2 比 0 获胜；玩家获胜 2 至 15；玩家 2 在 30 岁时获胜；玩家2以优势获胜。如果网球运动员在上场前或比赛期间退出
        <p><span style={{ color: "#c00000" }}>获胜组合 + 下/上</span></p>
        <p>您必须同时预测比赛的获胜者以及双方玩家的总局数是否为如果赛事没有发生或最终中断（如果下盘/大盘盘口尚未发生），则高于或低于预先设定的指数的投注将被退还。出于投注目的取得任何可证明的结果。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>体育</span></span></p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>在田径场上仅允许获胜投注，即预测已发布名单中的运动员中获胜者。比赛。</p>
        <p>注意：如果公布名单中的运动员没有参加比赛或在比赛期间退出，则针对他接受的投注将被视为输家，因此不被视为有效。预计退款。</p>
        <p>如果出现平局， 2 个或以上运动员，获胜者的份额必须除以最先到达的参赛者数量。</p>
        <p>示例：</p>
        <p>与 2 名运动员并列抵达，价格分别为 2.20 和 3.00。</p>
        <p>赔率将除以 2，因此将分别变为 1.10 和 1.50。</p>
        <p><span style={{ color: "#ff0000" }}>赢得奥运会</span></p>
        <p>它包括预测已发布名单中的球队中哪支球队将赢得比赛。金牌。</p>
        <p>注意：如果公布名单中的球队没有参加比赛或在比赛期间退出，则对其接受的投注将被视为输家，因此不予考虑。预计将退还赌注。</p>
        <p>如果出现平局， 2 个或以上团队，获胜者的份额必须除以最先到达的参赛者数量。</p>
        <p>示例：2 支球队的比分是 2.20 和 3.00。</p>
        <p>赔率将除以 2，因此将分别变为 1.10 和 1.50。</p>
        <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
        <p>投注旨在预测运动员是否会下注特定比赛或赛事的前三名或更少。</p>
        <p><span style={{ color: "#ff0000" }}>面对面</span></p>
        <p>投注在于预测在两个提案之间将实现的运动员或团队根据比赛/活动结束时的排名确定最佳名次。</p>
        <p>注意，投注的认证是通过参加比赛的两个结果以及同一场比赛的至少一个结果的结束来进行的。否则，投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
        <p>投注在于预测在列表中指定的运动员或团队中，将实现根据比赛/活动结束时的排名确定最佳名次。</p>
        <p>如果公布名单中的运动员或团队没有参加或退出，则对其接受的投注将被视为输家，因此无效。预计退款。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>羽毛球</span></span></p>
        <p><span style={{ color: "#ff0000" }}>赢得奥运会</span></p>
        <p>它包括预测已发布名单中的球队中哪支球队将赢得比赛。金牌。</p>
        <p>注意：如果公布名单中的球队没有参加比赛或在比赛期间退出，则对其接受的投注将被视为输家，因此不予考虑。预计将退还赌注。如果出现平局， 2 个或以上团队，获胜者的份额必须除以最先到达的参赛者数量。</p>
        <p>示例</p>
        <p>与 2 支球队并列，价格分别为 2.20 和 3.00。</p>
        <p>赔率将除以 2，因此将分别变为 1.10 和 1.50。</p>
        <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
        <p>投注包括预测运动员或球队是否会获得参赛资格特定比赛或赛事的前三名或更少。</p>
        <p><span style={{ color: "#ff0000" }}>面对面</span></p>
        <p>投注在于预测在两个提案之间将实现的运动员或团队根据比赛/活动结束时的排名确定最佳名次。</p>
        <p>注意，投注的认证是通过参加比赛的两个结果以及同一比赛的至少一个结果的结束来进行的。否则，投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
        <p>投注在于预测在列表中指定的运动员或团队中，将实现根据比赛/活动结束时的排名确定最佳名次。</p>
        <p>如果公布名单中的运动员或团队没有参加或退出，则对其接受的投注将被视为输家，因此无效。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>无 X 获胜</span></p>
        <p>投注包括预测将被分类的运动员或球队通过从列表中排除特定结果，在比赛或体育赛事中获得第一名。</p>
        <p>如果公布名单中的运动员或团队没有参加比赛或在比赛期间退出，则针对他接受的投注将被视为输家，因此不可能进行。预计退款。如果并非所有可能的结果都出现在提议的列表中，则始终包括“其他”项目。</p>
        <p><span style={{ color: "#ff0000" }}>获胜是/否</span></p>
        <p>投注包括预测提议的运动员或团队是否会赢得比赛（结果是）或不是（结果否）某场比赛/活动</p>
        <p><span style={{ color: "#ff0000" }}>U/O Ori</span></p>
        <p>您必须预测特定运动员或团队赢得的金牌总数是否为低于（低于）或高于（超过）预设限制。</p>
        <p><span style={{ color: "#ff0000" }}>U/O 奖牌</span></p>
        <p>您必须预测特定运动员或团队赢得的奖牌总数（金牌、银牌和铜牌）是否为低于（低于）或高于（超过）预设限制。</p>
        <p><span style={{ color: "#ff0000" }}>头对头套装 1</span></p>
        <p>投注包括预测将赢得比赛的玩家。比赛的第一盘。</p>
        <p>如果一名网球运动员在一场比赛中退赛，则对该网球运动员接受的投注将被视为输；反之亦然，如果网球运动员在比赛开始前退出，则赌注将被退还</p>
        <p><span style={{ color: "#ff0000" }}>将投注设置为 3</span></p>
        <p>您必须根据给定比赛的组数来预测准确的结果。如果比赛未进行或最终中断，投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>将投注设置为 5</span></p>
        <p>您必须根据给定比赛的组数来预测准确的结果。如果比赛未进行或最终中断，投注将被退还。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>BANDY</span></span></p>
        <p><span style={{ color: "#ff0000" }}>1X2</span></p>
        <p>投注旨在预测比赛结果，不包括任何加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>投注在于预测将被分类的球队。在特定锦标赛中获得第一名。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>棒球</span></span></p>
        <p>对于棒球投注，有效结果是比赛结束时获得的分数，包括任何加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>电汇结果</span></p>
        <p>投注包括预测将赢得比赛的球队。任何加时赛结束时的比赛：</p>
        <p>1.表示主队获胜；</p>
        <p>2.表示主队胜利。</p>
        <p><span style={{ color: "#ff0000" }}>电汇盘口</span></p>
        <p>投注包括预测将赢得比赛的球队。考虑到分配给两支球队之一的让分（以分表示），任何加时赛结束时的比赛。</p>
        <p>投注结果由劣势球队在场上取得的得分减去让分值决定已分配。</p>
        <p>示例A</p>
        <p>纽约——洛杉矶 15&ndash;8（让纽约 5.5 分）</p>
        <p>获胜结果 1（15 - 5.5 =10.5 → 最终结果 10.5 - 8 因此 1）</p>
        <p>示例B</p>
        <p>纽约——洛杉矶 15 - 12（让纽约 5.5 分）</p>
        <p>获胜结果 2（15 - 5.5 = 9.5 &rarr；最终结果 9.5 - 12 因此 2）</p>
        <p><span style={{ color: "#ff0000" }}>1X2（不包括加时赛）</span></p>
        <p>投注在于使用传统的 1X2 方法预测比赛结果。出于投注目的，任何加时局将不被考虑。</p>
        <p><span style={{ color: "#ff0000" }}>T/T + 下/上（包括加时局）</span></p>
        <p>投注包括同时预测比赛的获胜者以及两队的总得分是否为高于或低于预定指标。出于投注目的，任何加时局也将被考虑。</p>
        <p><span style={{ color: "#ff0000" }}>下/上</span></p>
        <p>投注在于预测一场比赛中的总得分是否超过设定的限制（从 6.5 到 12.5）。</p>
        <p>在假设下，预测将是一场比赛最高分为 6、7、8...12； with over 预测预测两队得分总和等于或大于 7, 8, 9...13。有效结果是任何加时赛（加时赛）结束时的那一场。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于第 1 队</span></p>
        <p>投注包括预测第 1 队在一场比赛中的总得分。任何加时局也将被考虑用于计分。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于第 2 队</span></p>
        <p>投注包括预测第 2 队在一场比赛中的总得分。任何加时局也将被考虑用于计分。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 1°局数</span></p>
        <p>投注包括预测哪支球队赢得第一&ordm;按照传统的 1x2 方法进行局数。</p>
        <p><br /></p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>下/上点 1°局数</span></p>
        <p>该投注旨在预测比赛第一局两队的得分总和是否为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>5局后1X2</span></p>
        <p>投注在于预测第五局结束时的比赛结果局。如果比赛在第 5 局结束之前中断或推迟，则适用 ADM 规则。</p>
        <p><span style={{ color: "#ff0000" }}>5 局后低于/高于</span></p>
        <p>投注在于预测是否在第五局结束时每局比赛的比分将是高于或低于一定价差。如果比赛在未完成前 5 局的情况下被明确中断，且未取得可证明的结果，则投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>Margine Vittoria Fasce</span></p>
        <p>投注包括预测两支球队之一在任何加时局结束时赢得比赛的分数差异。</p>
        <p><span style={{ color: "#ff0000" }}>加时赛是/否</span></p>
        <p>投注包括预测比赛是否会结束或不参加加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇</span></p>
        <p>该投注旨在预测两队在任何加时赛结束时获得的分数总和是否为偶数或奇数。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>沙滩足球 </span></span></p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>投注包括预测将赢得比赛的球队。某场比赛或将获胜的玩家一定的排名。</p>
        <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
        <p>投注包括预测常规时间结束时的结果，不包括任何加时赛。可能的结果是 1（主队获胜）、X（平局）和 2（客队获胜）。</p>
        <p><span style={{ color: "#ff0000" }}>UNDER/OVER x,5</span></p>
        <p>您必须在比赛期间预测常规时间内的总进球数是否为高于（大）或低于（低于）所提供的点差，不包括加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>头对头障碍</span></p>
        <p>投注包括预测哪支球队会获胜常规时间结束时领先，不包括任何加时赛。结果将是通过将让分差值应用于所选球队的总进球数来确定。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>沙滩排球</span></span></p>
        <p><span style={{ color: "#ff0000" }}>实时点下方/上方</span></p>
        <p>投注包括预测比赛结束时的最终得分总和（因此将所进行的比赛中累积的所有得分相加）是否低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>下针/上针设置 1</span></p>
        <p>投注包括预测最终得分是否为第一名游戏设置低于或高于某个值。</p>
        <p>如果该盘赛未进行，投注将无效。</p>
        <p>示例：</p>
        <p>客户投注第二节得分超过 38.5 分。放。如果盘局以 21-18 结束，则投注为获胜是因为该盘的总得分为共 39 盘。如果盘局比分 21-15，则投注为失败者，因为该盘的总得分为共 36 个。</p>
        <p><span style={{ color: "#ff0000" }}>下针/上针设置 2</span></p>
        <p>投注包括预测第二局的最终比分游戏设置低于或高于某个值。</p>
        <p>如果该盘赛未进行，投注将无效。</p>
        <p>示例：</p>
        <p>客户投注第二节得分超过 38.5 分。放。如果盘局以 21-18 结束，则投注为获胜是因为该盘的总得分为共 39 盘。如果盘局比分 21-15，则投注为失败者，因为该盘的总得分为共 36 个。</p>
        <p><span style={{ color: "#ff0000" }}>下针/上针设置 3</span></p>
        <p>投注包括预测第三局的最终比分游戏设置低于或高于某个值。</p>
        <p>如果该盘赛未进行，投注将无效。</p>
        <p>示例：</p>
        <p>客户投注第二节得分超过 38.5 分。放。如果盘局以 21-18 结束，则投注为获胜是因为该盘的总得分为共 39 盘。如果盘局比分 21-15，则投注为失败者，因为该盘的总得分为共 36 个。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于集合点</span></p>
        <p>投注在于预测比赛结束时的最终得分总和（因此将所进行的比赛中累积的所有得分相加）是否低于或高于某个值。</p>
        <p>示例：</p>
        <p>下面是显示了一个示例，其中值 [n] 为等于 92.5：</p>
        <p>客户投注比赛得分超过 92.5 分。如果比赛结果为 21-19、17-21 和 15-12，则投注为获胜是因为比赛中的总得分为105. 如果比赛结果为 21-8、12-21 和 15-8，则投注为失败者，因为比赛中的总得分为85.</p>
        <p><span style={{ color: "#ff0000" }}>奇/偶设置 1</span></p>
        <p>这个市场包括预测第一轮的总得分是否设置将是‘偶数’或“奇数”。因此，市场预计有两种可能的结果。总计为根据该盘中两支球队的得分进行计算。</p>
        <p>如果该盘赛未进行，投注将无效。</p>
        <p>示例：</p>
        <p>客户总共下注 2°设置‘奇数’。如果将结果设置在第 2 次结束时设置为21-16 中，投注为获胜，第二盘的总分是37. 投注于‘Pari’相反，他们将被指定为失败者。</p>
        <p><span style={{ color: "#ff0000" }}>奇/偶设置 2</span></p>
        <p>这个市场包括预测第二季度的总得分是否设置将是‘偶数’或“奇数”。因此，市场预计有两种可能的结果。总计为根据该盘中两支球队的得分进行计算。</p>
        <p>如果该盘赛未进行，投注将无效。</p>
        <p>示例：</p>
        <p>客户总共下注 2°设置‘奇数’。如果将结果设置在第 2 次结束时设置为21-16 中，投注为获胜，第二盘的总分是37. 投注于‘Pari’相反，他们将被指定为失败者。</p>
        <p><span style={{ color: "#ff0000" }}>奇/偶设置 3</span></p>
        <p>这个市场包括预测第三季度的总得分是否设置将是‘偶数’或“奇数”。因此，市场预计有两种可能的结果。总计为根据该盘中两支球队的得分进行计算。</p>
        <p>如果该盘赛未进行，投注将无效。</p>
        <p>示例：</p>
        <p>客户总共下注 2°设置‘奇数’。如果将结果设置在第 2 次结束时设置为21-16 中，投注为获胜，第二盘的总分是37. 投注于“Pari”相反，他们将被指定为失败者。</p>
        <p><span style={{ color: "#ff0000" }}>面对面比赛直播</span></p>
        <p>您必须预测比赛的获胜者。</p>
        <p><span style={{ color: "#ff0000" }}>头对头盘口直播</span></p>
        <p>您必须通过将投注中指定的让分差值应用到两队最终的总得分来预测比赛的获胜者。处于劣势的球队将会有积极的让分，受青睐的球队将有负障碍。</p>
        <p><span style={{ color: "#ff0000" }}>T/T SET 1 障碍</span></p>
        <p>这个市场包括预测每支球队在第一节的得分。设定，经过一定的障碍 [n] 后应用于所选球队的得分。市场上有两种可能的结果。</p>
        <p>[n] 的值为在不同的比赛中有所不同，代表分配给弱队的优势分的数量。处于劣势的球队将会有积极的让分，受青睐的球队将有负障碍。</p>
        <p>如果该盘赛未进行，投注将无效。</p>
        <p>示例：</p>
        <p>客户在第二盘投注意大利让分设置-3.5点。如果意大利赢得第二名9 月 21 日至 17 日，投注为获胜，因为应用让分后意大利以 17.5 比 17 获胜。如果意大利以 21-18 获胜，则投注为失败者采用让分盘后意大利队以 17.5-18 输掉比赛。</p>
        <p><span style={{ color: "#ff0000" }}>T/T SET 2 障碍</span></p>
        <p>这个市场包括预测每支球队在第二节的得分。设定，经过一定的障碍 [n] 后应用于所选球队的得分。市场上有两种可能的结果。</p>
        <p>[n] 的值为在不同的比赛中有所不同，代表分配给弱队的优势分的数量。处于劣势的球队将会有积极的让分，受青睐的球队将有负障碍。</p>
        <p>如果该盘赛未进行，投注将无效。</p>
        <p>示例：</p>
        <p>客户在第二盘投注意大利让分设置-3.5点。如果意大利赢得第二名9 月 21 日至 17 日，投注为获胜，因为应用让分后意大利以 17.5 比 17 获胜。如果意大利以 21-18 获胜，则投注为失败者采用让分盘后意大利队以 17.5-18 输掉比赛。</p>
        <p><span style={{ color: "#ff0000" }}>T/T SET 3 障碍</span></p>
        <p>这个市场包括预测每支球队在第三节的得分。设定，经过一定的障碍 [n] 后应用于所选球队的得分。市场上有两种可能的结果。</p>
        <p>[n] 的值为在不同的比赛中有所不同，代表分配给弱队的优势分的数量。处于劣势的球队将会有积极的让分，受青睐的球队将有负障碍。</p>
        <p>如果该盘赛未进行，投注将无效。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>BIATHLON </span></span></p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>投注在于预测滑雪者将赢得比赛。单场比赛或特定赛事。</p>
        <p>注意如果名单中的运动员或队伍没有参加比赛，或在比赛期间因任何原因退出，则针对该特定运动员或队伍接受的投注将被视为输家且无效。预计将退还赌注。</p>
        <p><span style={{ color: "#ff0000" }}>放置在讲台上</span></p>
        <p>投注包括预测特定运动员是否会排名进入特定比赛的前三名。</p>
        <p><span style={{ color: "#ff0000" }}>头对头</span></p>
        <p>该投注旨在预测在两个提议者之间将实现以下目标的运动员根据比赛结束时的排名确定最佳名次。投注的认证是通过参加两种结果的比赛以及至少一个结果的同一比赛的结束来进行的。否则，投注将被退还。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>台球 </span></span></p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>您必须预测特定锦标赛的获胜选手或队伍。出于投注目的，如果所选球员或球队没有参加比赛或因任何原因退出比赛，则已接受的投注将被视为输家且不符合资格。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>电汇会议</span></p>
        <p>您必须预测比赛的获胜者。仅在比赛未进行的情况下才会退还投注，如果球员在比赛中退赛或比赛中断但已宣布获胜者，则投注将被视为有效。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>5 人制足球 </span></span></p>
        <p><span style={{ color: "#ff0000" }}>1X2</span></p>
        <p>投注包括确定常规时间结束时对特定比赛的预测，包括任何伤停补时时间。</p>
        <p>使用符号 1，您可以预测第一个提议的团队的胜利，使用 2 预测第二个提议的团队的胜利，X 则为平局。</p>
        <p>并且可以接受带让分的 1X2 投注类型。</p>
        <p><span style={{ color: "#ff0000" }}>与让分盘交锋</span></p>
        <p>特许公司将两支球队中的一支视为小数让分，因此对于投注来说，不会导致平局。</p>
        <p><span style={{ color: "#ff0000" }}>下/上</span></p>
        <p>它包括预测一场比赛中的进球总数是高于还是低于设定的限制（分散）。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 4.5</span></p>
        <p>投注包括确定在给定比赛中得分是否低于 4.5（低于）或更高。多出 4.5 个球（超过）。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 5.5</span></p>
        <p>投注包括确定在给定比赛中得分是否低于 5.5（下）或更多。多出 5.5 个球（超过）。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 6.5</span></p>
        <p>投注包括确定在给定比赛中得分是否低于 6.5（下）或更高。 6.5 个进球（超过）。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 7.5</span></p>
        <p>投注包括确定在给定比赛中得分是否低于 7.5（低于）或更高。 7.5 个进球（超过）。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 8.5</span></p>
        <p>投注包括确定在给定比赛中得分是否低于 8.5（下）或更高。 8.5 个进球（超过）。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 9.5</span></p>
        <p>投注包括确定在给定比赛中得分是否低于 9.5（下）或更高。 9.5 个进球（超过）。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇</span></p>
        <p>投注包括确定给定比赛结束时得分是奇数还是偶数。 0-0 的结果给出结果是均匀的。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>骑行 </span></span></p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>投注包括预测将赢得比赛的自行车手或团队。单路或阶段比赛。</p>
        <p>注意，如果自行车手或车队没有参加比赛，则针对该自行车手接受的投注将被视为输家。</p>
        <p><span style={{ color: "#ff0000" }}>最佳列表</span></p>
        <p>投注在于预测提议列表中指定的自行车手或团队将获得最好的排名。</p>
        <p>注意，如果自行车手或车队没有参加比赛，则针对该自行车手或车队接受的投注将被视为输。</p>
        <p><span style={{ color: "#ff0000" }}>骑手赢得的赛段</span></p>
        <p>它包括预测在给定的赛段比赛（例如环意自行车赛、环法自行车赛等）中自行车手将赢得的确切赛段数，从以下 5 个选项之一中进行选择： </p>
        <p>没有停止；</p>
        <p>1 阶段；</p>
        <p>2 个阶段；</p>
        <p>3 个阶段；</p>
        <p>4 个阶段；</p>
        <p>5 个阶段或更多阶段。</p>
        <p><span style={{ color: "#ff0000" }}>头对头</span></p>
        <p>该赌注在于预测在两个提议者之间哪个骑自行车者将获得比赛结束时的最佳名次。</p>
        <p>注意，投注的认证是通过两种结果（例如车手）参加比赛以及至少一个结果的同一比赛的结束来进行的。否则，投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>速度平均</span></p>
        <p>投注包括预测玩家将属于 AMMS 提议的列表中指定的哪个等级。速度运行的平均值。</p>
        <p>乐队是：</p>
        <p>{"<="} 39</p>
        <p>{">"}39 {"<="}40</p>
        <p>{">"}40 {"<="}41</p>
        <p>&gt;41 {"<="}42</p>
        <p>{">"}42</p>
        <p>注意，上述频段会根据比赛类型进行修改。</p>
        <p><span style={{ color: "#ff0000" }}>登上领奖台的意大利自行车手</span></p>
        <p>该赌注在于预测不同国籍的骑自行车者的数量意大利队在某场比赛中将获得前三名。</p>
        <p><span style={{ color: "#ff0000" }}>登上领奖台 - 是/否</span></p>
        <p>该赌注包括预测自行车手是否会分类在特定比赛中获得前三名。</p>
        <p>注意，如果自行车手或车队没有参加比赛，已接受的投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>获胜自行车队</span></p>
        <p>投注包括预测自行车手所在的团队将赢得比赛。竞争。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>板球</span></span></p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>你必须预测哪一个会是被提议的团队中，赢得参考赛事的团队。</p>
        <p><span style={{ color: "#ff0000" }}>头对头比赛结果</span></p>
        <p>你必须预测哪支球队会获胜会议。出于投注目的，将举行考虑可能的“SuperOver”结束时产生的结果。如果符合以下条件，则投注视为有效至少投出了一个球。</p>
        <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
        <p>你必须预测哪支球队会获胜会议。如果符合以下条件，则投注视为有效至少投出了一个球。如果比赛以“平局”结束，则适用公平规则，平局投注将被视为输家。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>卷曲</span></span></p>
        <p><span style={{ color: "#ff0000" }}>头对头结果</span></p>
        <p>您必须预测哪支球队将赢得比赛。比赛中，任何加时赛也将被视为投注目的。</p>
        <p><span style={{ color: "#ff0000" }}>头对头障碍</span></p>
        <p>您必须通过在最终结果中添加或减去投注中所示的差额来预测比赛结果。任何加时赛也将被考虑用于投注目的。</p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>投注在于预测将被分类的球队。在比赛或体育赛事中获得第一名。</p>
        <p><span style={{ color: "#ff0000" }}>头对头</span></p>
        <p>您必须预测提议的两支球队中哪一支会获胜。在给定事件结束时获得更好的位置。</p>
        <p><span style={{ color: "#ff0000" }}>无需 X 即可获胜</span></p>
        <p>投注在于预测被提议的团队将获得活动结束时的最佳名次，不包括列表中的特定结果。</p>
        <p><span style={{ color: "#ff0000" }}>放置在讲台上</span></p>
        <p>投注包括预测一支球队是否会获得第一名。赛事排名前三位或以下。</p>
        <p><span style={{ color: "#ff0000" }}>获胜是/否</span></p>
        <p>投注在于预测提议的球队是否会赢得比赛。 （结果是）或不是（结果否）某个事件。</p>
        <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
        <p>投注包括预测列表中指定的球队将实现根据活动排名确定最佳排名。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>骑马 </span></span></p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>投注包括预测特定比赛或赛事的获胜者。如果名单上的运动员或队伍没有参加比赛，或在比赛期间因任何原因退出，则针对该特定运动员或队伍接受的投注将被视为输家且不符合资格。预计将退还赌注。</p>
        <p><span style={{ color: "#ff0000" }}>奥运会冠军</span></p>
        <p>它包括预测已发布名单中的球队中哪支球队将赢得比赛。金牌。</p>
        <p>注意：如果公布名单中的球队没有参加比赛或在比赛期间退出，则对其接受的投注将被视为输家，因此不予考虑。预计将退还赌注。</p>
        <p>如果出现平局， 2 个或以上团队，获胜者的份额必须除以最先到达的参赛者数量。</p>
        <p>示例：</p>
        <p>与 2 支球队并列，价格分别为 2.20 和 3.00。</p>
        <p>赔率将除以 2，因此将分别变为 1.10 和 1.50。</p>
        <p><span style={{ color: "#ff0000" }}>获胜是/否</span></p>
        <p>投注包括预测提议的运动员或团队是否会赢得比赛（结果是）或不是（结果否）某场比赛/活动。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 金牌</span></p>
        <p>您必须预测指定的两个国家中哪一个将赢得比赛。更多的金牌。</p>
        <p><span style={{ color: "#ff0000" }}>奖牌获得者</span></p>
        <p>您必须预测哪个国家将成为获胜者。特定学科的奖牌榜获奖者（确定获奖者时，会考虑所获奖牌的重要性）。如果并非所有可能的结果都出现在提议的列表中，则始终包括“其他”项目。</p>
        <p><span style={{ color: "#ff0000" }}>无需 X 即可获胜</span></p>
        <p>投注包括预测将被分类的运动员或球队通过从列表中排除特定结果而在比赛或体育赛事中获得第一名。如果并非所有可能的结果都出现在提议的列表中，则始终包括“其他”项目。</p>
        <p><span style={{ color: "#ff0000" }}>放置在讲台上</span></p>
        <p>投注旨在预测运动员或球队是否会获得名次特定比赛或赛事的前三名或更少。</p>
        <p><span style={{ color: "#ff0000" }}>头对头</span></p>
        <p>投注包括预测在两个提案之间将实现的运动员或团队根据比赛/活动结束时的排名确定最佳名次。</p>
        <p>注意，投注的认证是通过参加比赛的两个结果以及同一场比赛的至少一个结果的结束来进行的。否则，投注将被退还。</p>
        <p><br /></p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>美式足球 </span></span></p>
        <p><span style={{ color: "#ff0000" }}>电汇结果</span></p>
        <p>投注包括预测将赢得比赛的球队。任何加时赛结束时的比赛：</p>
        <p>1.表示主队获胜；</p>
        <p>2.表示主队胜利。</p>
        <p><span style={{ color: "#ff0000" }}>电汇盘口</span></p>
        <p>投注包括预测将赢得比赛的球队。考虑到分配给两支球队之一的让分（以分数表示），在任何加时赛结束时进行比赛。</p>
        <p>投注结果由劣势球队在场上取得的得分减去让分值决定已分配。</p>
        <p>示例A：</p>
        <p>巴尔的摩小马队 - 达拉斯 25 – 18（巴尔的摩让分 5.5 分）</p>
        <p>获胜结果 1 ( 25- 5.5 =19.5 &rarr; 最终结果 19.5 -18 因此 1)</p>
        <p>示例 B：</p>
        <p>巴尔的摩小马队 - 达拉斯 25 – 22（巴尔的摩让分 5.5 分）</p>
        <p>获胜结果 2 ( 25- 5.5 =19.5 &rarr; 最终结果 19.5 -22 因此 2)</p>
        <p><span style={{ color: "#ff0000" }}>1X2 NFL</span></p>
        <p>投注包括根据以下方法预测比赛的最终结果，包括任何加时赛：</p>
        <p>- 分差大于5分的主队获胜得1分；</p>
        <p>- X 表示平局或两队其中一支球队的分差小于或等于 5 分获胜；</p>
        <p>- 分差大于 5 分的客队获胜得 2 分。</p>
        <p>示例A</p>
        <p>纽约巨人队 - 底特律雄狮队 28-20：获胜分数：1</p>
        <p>示例B</p>
        <p>纽约巨人队 - 底特律雄狮队 28-25：获胜结果：X</p>
        <p>示例C</p>
        <p>纽约巨人队 - 底特律雄狮队 23-29：获胜分数：2</p>
        <p><span style={{ color: "#ff0000" }}>1X2 常规时间</span></p>
        <p>投注以传统的 1x2 方式预测常规时间结束时的比赛结果：得分 1，主队获胜；得分 1，主队获胜；得分 1，主队获胜。 X 画标志；得分 2 客队获胜。</p>
        <p><br /></p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>双重机会IN</span></p>
        <p>投注在于预测比赛的最终结果是否会出现主队获胜或常规时间结束时打平，不包括任何加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会出局</span></p>
        <p>投注在于预测比赛的最终结果是否会出现客队获胜或常规时间结束时打平，不包括任何加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会进/出</span></p>
        <p>投注在于预测比赛的最终结果是否会出现常规时间结束时主队或客队获胜，不包括任何加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>下/上匹配</span></p>
        <p>投注在于预测特定赛事结束时的总得分是否为高于或低于预先设定的保证金。出于报告目的，任何额外时间也将被考虑。</p>
        <p><span style={{ color: "#ff0000" }}>在家下方/上方</span></p>
        <p>投注包括预测第 1 队在一场比赛中的总得分是否为低于或高于某个值。出于报告目的，任何额外时间也将被考虑。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于访客</span></p>
        <p>投注包括预测第 2 队在一场比赛中的总得分是否为低于或高于某个值。出于报告目的，任何额外时间也将被考虑。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇</span></p>
        <p>投注包括预测两支球队在一场比赛（包括加时赛）中的得分总和是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>偶数/奇数宫位</span></p>
        <p>投注包括预测第 1 队在一场比赛（包括加时赛）中得分的总和是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>偶数/奇数客人</span></p>
        <p>投注包括预测第 2 队在一场比赛（包括加时赛）中的得分总和是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 让分 1°时间</span></p>
        <p>投注在于预测哪支球队将完成比赛上半场通过在第一局结束时的结果中添加或减去投注中指示的让分来确定接下来的比赛时间</p>
        <p><span style={{ color: "#ff0000" }}>1X2 1°时间</span></p>
        <p>投注包括预测哪支球队将赢得比赛。上半场一场比赛。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 1°时间</span></p>
        <p>投注包括预测在上半场结束时是否给定事件的总得分为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 1°时间</span></p>
        <p>投注在于预测两队上半场的得分总和是否为一场比赛的比赛时间将是偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 让分 2°时间</span></p>
        <p>投注包括预测哪支球队将赢得比赛。下半场会议的结果将是通过将让分差值应用于所选球队的总得分来确定。出于投注目的，它将是仅考虑下半场取得的得分比赛时间和任何加时赛均不予考虑。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 2°时间</span></p>
        <p>投注在于预测下半场的结果。会议的。提供三种可能的结果：1（主队领先）、2（客队领先）、X（下半场比赛结束时两队势均力敌）。出于投注目的，它将是仅考虑下半场取得的得分比赛时间和任何加时赛均不予考虑。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 2°时间</span></p>
        <p>投注在于预测两队下半场的得分总和是否会议的UNDER（低于设定点差）或 OVER（高于设定点差）。出于投注目的，它将是仅考虑下半场取得的得分比赛时间和任何加时赛均不予考虑。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 2°时间</span></p>
        <p>投注包括预测两队下半场得分总和是否会议的偶数或奇数。出于投注目的，它将是仅考虑下半场取得的得分比赛时间和任何加时赛均不予考虑。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 让分 1°第四</span></p>
        <p>投注包括预测哪支球队将赢得比赛。 1 日每四分之一场比赛的结果将是通过将让分差值应用于所选球队的总得分来确定</p>
        <p><span style={{ color: "#ff0000" }}>1X2 1°第四（不丢弃）</span></p>
        <p>投注在于预测第一场比赛的最终结果比赛的四分之一。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 1°第四</span></p>
        <p>投注在于预测最后是否为 1°。本节比赛的总得分为高于或低于预先设定的保证金。</p>
        <p><br /></p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 1°第四宫</span></p>
        <p>投注在于预测最后是否1°本节比赛中，1 队的总得分为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 1°第四位嘉宾</span></p>
        <p>投注在于预测最后是否1°本节比赛中，2 队的总得分为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>下/上触地 1°第四</span></p>
        <p>投注包括预测两支球队在第一节的达阵总数是否一场比赛的四分之一是高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 1°第四</span></p>
        <p>投注在于预测两支球队在第一场比赛中的得分总和是否每四分之一场比赛，这将是偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 让分 2°第四</span></p>
        <p>投注包括预测哪支球队将赢得比赛。 2号每四分之一场比赛的结果将是通过将让分差值应用于所选球队的总得分来确定。出于投注目的，它将是仅考虑第二节取得的成绩第四。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 2°第四（不丢弃）</span></p>
        <p>投注在于预测第二场比赛的最终结果比赛的四分之一。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 2°第四</span></p>
        <p>投注在于预测最后 2° 是否会超过 2°。本节比赛的总得分为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 2°第四</span></p>
        <p>投注是预测两队在第二节的得分总和是否相同每四分之一场比赛，这将是偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 盘口 3°第四</span></p>
        <p>投注包括预测哪支球队将赢得比赛。 3号每四分之一场比赛的结果将是通过将让分差值应用于所选球队的总得分来确定。出于投注目的，它将是仅考虑第三节取得的得分第四。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 3°第四（不丢弃）</span></p>
        <p>投注在于预测第三场比赛的最终结果比赛的四分之一。</p>
        <p><span style={{ color: "#ff0000" }}>3°以下/以上第四</span></p>
        <p>投注在于预测最后 3° 是否会达到 3°。本节比赛的总得分为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 3°第四</span></p>
        <p>投注是预测两队在第三节的得分总和是否相同每四分之一场比赛，这将是偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 让分 4°第四</span></p>
        <p>投注包括预测哪支球队将赢得比赛。第四个每四分之一场比赛的结果将是通过将让分差值应用于所选球队的总得分来确定。出于投注目的，它将是仅考虑第四节取得的得分第四，任何加时赛将不被考虑。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 4°第四（不丢弃）</span></p>
        <p>投注在于预测第四场比赛的最终结果比赛的四分之一，出于投注目的，仅参考第四节比赛进行了四分之一，他不会来考虑任何加时赛中取得的分数。</p>
        <p><span style={{ color: "#ff0000" }}>4°以下/以上第四</span></p>
        <p>投注在于预测最后 4° 是否会达到 4°。本节比赛的总得分为高于或低于预先设定的保证金，出于投注目的，仅参考第四个比赛进行了四分之一，他不会来考虑任何加时赛中取得的分数。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 4°第四</span></p>
        <p>投注是预测两队在第四节的得分总和是否相同每四分之一场比赛，这将是偶数或奇数。出于投注目的，仅参考第四个；比赛进行了四分之一，他不会来考虑任何加时赛中取得的分数。</p>
        <p><span style={{ color: "#ff0000" }}>得分最高的第四名高</span></p>
        <p>投注包括预测一场比赛的四分之一比赛，其中将有不止一场比赛得分。将两支球队的得分相加得到分数。将提供 5 种可能的结果 1 季度、2 季度、3 季度、4 季度，当所有季度得分相同或 2 或更多时，将出现平局各季度的得分均高于其他季度。</p>
        <p><span style={{ color: "#ff0000" }}>部分/最终</span></p>
        <p>投注在于预测第一场比赛的结果出于投注目的，时间与比赛的最终结果相结合仅考虑常规时间结束时的结果。</p>
        <p><span style={{ color: "#ff0000" }}>胜利幅度</span></p>
        <p>投注包括预测两支球队之一在任何加时赛结束时赢得比赛的分数差异。</p>
        <p>投注包括主队获胜的 6 个括号和客队胜利的 6 个括号：</p>
        <p>A(1-5); A（6-10）； A(11-15)； A(16-20)； A(21-25)； A(&gt;25);</p>
        <p>B(1-5)； B（6-10）； B（11-15）； B（16-20）； B（21-25）； B（&gt;25）。</p>
        <p><span style={{ color: "#ff0000" }}>胜利边际（7 个结果）</span></p>
        <p>投注包括预测两支球队之一在任何加时赛结束时赢得比赛的分数差。有 7 种可能的结果：</p>
        <p>A (1-7)</p>
        <p>A (8-14)</p>
        <p>A (&gt;14)</p>
        <p>画画</p>
        <p>B (1-7)</p>
        <p>B (8-14)</p>
        <p>B (&gt;14)</p>
        <p><span style={{ color: "#ff0000" }}>加时赛是/否</span></p>
        <p>投注在于预测比赛是否会继续或者不在加时赛中。</p>
        <p><span style={{ color: "#ff0000" }}>首次触地</span></p>
        <p>投注包括预测将得分的球队。 1 日一场比赛中的达阵，包括加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>最后一次触地</span></p>
        <p>投注包括预测将得分的球队。一场比赛中最后一次达阵，包括加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>触地下方/上方</span></p>
        <p>投注包括预测两队在一场比赛（包括加时赛）中的达阵总数是否为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>在 TouchDown Home 下方/上方</span></p>
        <p>投注包括预测第 1 队在一场比赛（包括加时赛）中得分的总达阵次数是否为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>在 TouchDown 访客下方/上方</span></p>
        <p>投注包括预测第 2 队在一场比赛（包括加时赛）中的达阵总数是否为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>触地球员下方/上方</span></p>
        <p>投注包括预测一名球员在一场比赛（包括加时赛）中得分的总达阵次数是否为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>第一个射门得分</span></p>
        <p>投注包括预测将得分的球队。 1 日一场比赛中的投篮命中（三分球），包括加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>最后进球</span></p>
        <p>投注包括预测将得分的球队。一场比赛中的最后一个进球，包括加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于射门得分</span></p>
        <p>投注包括预测两支球队在一场比赛（包括加时赛）中的总进球数是否为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于射门得分首页</span></p>
        <p>投注包括预测第 1 队在一场比赛（包括加时赛）中的总进球数是否为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于射门得分嘉宾</span></p>
        <p>投注包括预测第 2 队在一场比赛（包括加时赛）中的总进球数是否为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>先下/上下</span></p>
        <p>投注包括预测一场比赛中首回合的总数是否为高于或低于预先设定的保证金。</p>
        <p><span style={{ color: "#ff0000" }}>第一个得分的球队</span></p>
        <p>投注包括预测将得分的球队。无论如何 1 日一场比赛的得分，包括加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>最后得分的球队</span></p>
        <p>投注包括预测将得分的球队。无论如何，比赛的最后一分，包括加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>首先得分并获胜的球队</span></p>
        <p>投注包括预测首先得分的球队是否会成功。或更少也能赢得比赛，包括任何加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>主队得分第一并获胜</span></p>
        <p>投注包括预测 1 队是否得分。第一点他就会赢还包括比赛，包括任何加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>客队率先得分获胜</span></p>
        <p>投注包括预测第 2 队是否会得分。第一点他就会赢还包括比赛，包括任何加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>主队赢得两个半场</span></p>
        <p>投注包括预测主场球队是否会成功或更少得分更高；双方常规赛期间对方球队的得分，不包括加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>客队赢得两个半场</span></p>
        <p>投注包括预测客队是否会在比赛中获胜。或更少得分更高；双方常规赛期间对方球队的得分，不包括加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>第一种实现方法（6个结果）</span></p>
        <p>投注在于预测团队 1 或团队 2 实现目标的方法。会议的第一点，包括加时。</p>
        <p><span style={{ color: "#ff0000" }}>第一种实现方法（3个结果）</span></p>
        <p>投注在于预测实现投注的方法。会议的第一点，包括加时。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 码完成跑动</span></p>
        <p>投注在于预测两名玩家中哪一位将完成游戏。更多的在一场比赛中冲球码数，包括加时赛。</p>
        <p><span style={{ color: "#ff0000" }}>完成跑垒数低于/高于码数</span></p>
        <p>投注包括预测两支球队在一场比赛（包括任何加时赛）中冲球完成的总码数将高于还是低于预先设定的差距。</p>
        <p><span style={{ color: "#ff0000" }}>通过传球完成下/上码数</span></p>
        <p>投注包括预测两支球队在一场比赛（包括加时赛）中完成的总传球码数将高于还是低于预先设定的差距。</p>
        <p><span style={{ color: "#ff0000" }}>下/上翻转</span></p>
        <p>投注包括预测一场比赛中的总营业额（包括任何加时赛）是否会高于或低于预先设定的利润。失误是指由于对方失球或拦截而失去控球权。</p>
        <p><span style={{ color: "#ff0000" }}>球员接球下方/上方</span></p>
        <p>投注包括预测球员在一场比赛（包括任何加时赛）中收到的传球次数是否会高于或低于预先设定的差额。</p>
        <p><span style={{ color: "#ff0000" }}>球员跑垒完成的下/上码数</span></p>
        <p>投注包括预测球员在一场比赛（包括任何加时赛）中跑动完成的码数是否会高于或低于预先设定的差额。</p>
        <p><span style={{ color: "#ff0000" }}>通过球员通行证完成下/上码数</span></p>
        <p>投注包括预测球员在一场比赛（包括任何加时赛）中传球完成的总码数是否会高于或低于预先设定的差额。</p>
        <p><span style={{ color: "#ff0000" }}>触地标记是/否</span></p>
        <p>投注在于预测玩家是否会实现目标在给定赛事中至少一次达阵，包括任何加时赛。</p>
        <p>是=至少获得一次达阵</p>
        <p>NO = 未得分</p>
        <p>如果某个最终达阵的球员没有参加比赛（我们所说的参加是指实际上场的球员）投注的对象，此类投注将被退还。如果球员参加比赛，即使在有限的时间内，对假设得分的投注也是有效的。</p>
        <p><span style={{ color: "#ff0000" }}>达阵第一得分手</span></p>
        <p>投注包括预测在预定义列表中在比赛（包括任何加时赛）中首次达阵得分的球员。列表中是还有“OTHER”项，指的是第一次达阵由不在列表中的球员得分的情况，“NO TOUCHDOWN”则指没有得分的情况。如果公布名单中的球员没有上场，则对该他接受的投注将被视为输家，因此在这种情况下这是不可能的。预计将退还赌注。</p>
        <p><span style={{ color: "#ff0000" }}>达阵最后进球者</span></p>
        <p>投注包括预测预定义列表中在比赛（包括任何加时赛）中最后一次达阵得分的球员。列表中是还有“OTHER”项，指最后一次达阵由不在列表中的球员得分的情况，“NO TOUCHDOWN”则指未得分的情况。如果公布名单中的球员没有上场，则对该他接受的投注将被视为输家，因此在这种情况下这是不可能的。预计将退还赌注。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>飞镖</span></span></p>
        <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
        <p>您必须预测哪位玩家将赢得比赛。它仅适用于可用的锦标赛。预计平局。</p>
        <p><span style={{ color: "#ff0000" }}>头对头比赛结果</span></p>
        <p>您必须预测哪位玩家将赢得比赛。它仅适用于不可用的锦标赛。预计平局。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>GOLF</span></span></p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>投注在于预测赛事获胜的高尔夫球手。</p>
        <p>得分最高的队伍</p>
        <p>投注在于确定两支球队中哪支球队将拥有取得最高分高的。符号为 1 时，投注者预测欧洲队将获得更多分数；符号为 1 时，投注者预测欧洲队将获得更多分数。符号2表示投注者预测美国队得分较多；带有 X 符号的投注者预测两队将取得相同的分数。</p>
        <p><span style={{ color: "#ff0000" }}>杯赛冠军</span></p>
        <p>投注旨在确定哪支球队将在赛事结束时赢得冠军。奖杯。请记住，如果出现平局，奖杯将是分配给管理员。</p>
        <p><span style={{ color: "#ff0000" }}>一杆进洞</span></p>
        <p>投注在于确定是否在比赛期间一杆至少打出一个洞。有两种可能的结果：是 – 是；号。</p>
        <p><br /></p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>在高尔夫球手中获胜</span></p>
        <p>该赌注旨在确定两名高尔夫球手中哪一位得分更高。存在三种可能的结果： 1 – X—— 2.</p>
        <p><span style={{ color: "#ff0000" }}>高尔夫球手得分</span></p>
        <p>投注包括确定高尔夫球手所取得的分数。有三种可能的结果：从 0 到 1.5； 2至3.5；大于或等于4。</p>
        <p><span style={{ color: "#ff0000" }}>最佳球员国籍X</span></p>
        <p>您必须预测所提供的特定国籍的哪些球员将获得比赛结束时的最佳名次。如果名单上的选手没有参加锦标赛，则接受的投注将被视为输家且不被视为有效。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 玩家</span></p>
        <p>您必须预测所提供的两名高尔夫球手中哪一位将获得冠军最终排名中的最佳名次，或者如果在比赛结束时双方的射门次数相同（X 标志），则任何季后赛都不会被计入记分卡。出于有效性目的两名选手都必须参加比赛，否则投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>比赛中 1X2</span></p>
        <p>投注旨在预测两名高尔夫球手之间的比赛结果。</p>
        <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
        <p>投注包括预测所提供的高尔夫球手中哪位将获得比赛结束时的最佳名次。如果名单上的高尔夫球手因任何原因不参加或退出，则对他的匹配投注将被视为失败且不予考虑。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>当天的 1X2 名球员</span></p>
        <p>您必须预测所提供的两名球员中哪一位将获得某场比赛的特定一天结束时的最佳排名，或者在同一天结束时双方的击球数相同。出于投注目的，两名选手必须在指定日期参加比赛，在所有其他情况下，投注将被退还。为了报道你会来仅考虑与指定日期相关的排名。</p>
        <p><span style={{ color: "#ff0000" }}>通过剪切是/否</span></p>
        <p>您必须预测特定的高尔夫球手或团队是否会克服困难或者不通过访问事件的后续阶段来进行剪辑。如果高尔夫球手没有参加比赛，则对他的匹配投注将被退还，在所有其他情况下，这些投注将仍然有效。</p>
        <p><span style={{ color: "#ff0000" }}>在是/否锦标赛中一杆进洞</span></p>
        <p>您必须预测在一场比赛结束时是否至少有一名高尔夫球手会获得一枪打出一个洞。</p>
        <p><span style={{ color: "#ff0000" }}>第一名之后的领导者圆形</span></p>
        <p>你必须预测哪位高尔夫球手将获得冠军特定赛事第一天（第一轮）结束时的最佳名次。如果高尔夫球手在第一天没有参加或退出，则对他的匹配投注将被视为输家，并且不符合资格。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>T/T展览</span></p>
        <p>你必须预测两个玩家中哪一个会获胜。会议。我们将继续如果出于任何原因，所投注的比赛没有进行，则退款。</p>
        <p><span style={{ color: "#ff0000" }}>玩家赢得至少一场大型锦标赛是/否</span></p>
        <p>您必须预测特定玩家是否会赢得比赛。特定年份或更少的专业。如果球员未能参加所有四场大满贯赛，则与后者相关的投注将被退还。在所有其他情况下，投注均有效。</p>
        <p><span style={{ color: "#ff0000" }}>主要锦标赛中获胜的玩家数量</span></p>
        <p>您必须预测指定玩家在指定年份赢得的主要锦标赛的确切数量。如果球员未能参加所有四场大满贯赛，则与后者相关的投注将被退还。在所有其他情况下，投注均有效。</p>
        <p><span style={{ color: "#ff0000" }}>放置在顶部 X 是/否</span></p>
        <p>您必须预测给定的高尔夫球手是否会进入锦标赛最终排名前 X 名或以下。如果被投注的高尔夫球手不参加，投注将被退还，在所有其他情况下，投注仍然有效。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>HOCKEY</span></span></p>
        <p><span style={{ color: "#ff0000" }}>电汇结果</span></p>
        <p>投注包括在任何加时赛结束时预测比赛的获胜者并点球大战。</p>
        <p><span style={{ color: "#ff0000" }}>电汇盘口</span></p>
        <p>投注包括在任何加时赛结束时预测比赛的获胜者，并考虑相对指定的让分而决出胜负。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 结果</span></p>
        <p>投注在于预测常规时间结束时的比赛结果（实际 60 分钟，分为 3 个半场）。</p>
        <p>1表示主队获胜</p>
        <p>X 表示平局。</p>
        <p>2表示客队获胜。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 带障碍</span></p>
        <p>投注包括考虑分配给两支球队之一的让分（以进球数表示），预测常规时间结束时的赛事结果。</p>
        <p>投注结果由劣势球队在场上取得的得分减去让分值决定分配的状态：</p>
        <p>1（带H）表示主队获胜</p>
        <p>X（与 H）平局</p>
        <p>2（带H）客队获胜。</p>
        <p>示例</p>
        <p>博尔扎诺曲棍球 -曲棍球米兰 7 – 4（博尔扎诺让分2.5分）</p>
        <p>获胜结果 1（7-2.5 =4.5 &rarr；最终结果 4.5 - 4 因此 1）</p>
        <p>示例</p>
        <p>博尔扎诺曲棍球 -曲棍球米兰 7 – 5（博尔扎诺让分2.5分）</p>
        <p>获胜结果 2（7-2.5 =4.5 &rarr；最终结果 4.5 - 5 因此 2）</p>
        <p><span style={{ color: "#ff0000" }}>双重机会IN</span></p>
        <p>投注在于预测比赛的最终结果主队获胜或平局。有效结果是规定时间结束时获得的。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会出局</span></p>
        <p>投注在于预测比赛的最终结果客队获胜或平局。有效结果是规定时间结束时获得的。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会进/出</span></p>
        <p>投注在于预测比赛的最终结果主队或客队获胜。有效结果是规定时间结束时获得的。</p>
        <p><span style={{ color: "#ff0000" }}>下/上匹配</span></p>
        <p>投注包括预测一场比赛的总进球数是否为低于（低于）或高于（高于）预先设定的限额 出于投注目的，任何加时赛和点球大战都将被考虑（如果是点球大战，获胜球队将获得进球）。到其分数）。</p>
        <p><span style={{ color: "#ff0000" }}>在家下方/上方</span></p>
        <p>投注旨在预测主队在一场比赛中的总进球数是否低于（低于）或高于（高于）预先设定的限制。任何加时赛和点球大战都包括在内（如果发生点球大战，获胜队将获得进球以增加得分）。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于访客</span></p>
        <p>投注包括预测客队在一场比赛中的总进球数是低于（低于）还是高于（高于）预先设定的限制。任何加时赛和点球大战都包括在内（如果发生点球大战，获胜队将获得进球以增加得分）。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>目标/无目标</span></p>
        <p>投注包括预测两支球队是否都会得分（进球）或两队是否至少有一支球队不会得分。比赛常规时间内没有进球 (NoGoal)。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 结果 + 下/上匹配</span></p>
        <p>投注包括同时预测一场比赛的结果以及两队的总得分是否相同高于或低于预定指标。出于投注目的，仅考虑常规时间。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 让分 1°期间</span></p>
        <p>投注包括通过将投注中指定的进球数的让分差应用于该时段的最终结果来预测第一时段的获胜者。处于劣势的球队获得正让分，而被看好的球队获得负让分。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 1°期间</span></p>
        <p>投注在于预测第一场比赛结束时的结果比赛期间。用 1 预测第一个提议的球队获胜，用 2 预测第二个提议的球队获胜，用 X 预测他们的平局。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会 IN 1°期间</span></p>
        <p>投注在于预测第一个结果是否期间会看到主队获胜或平局。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会 OUT 1°期间</span></p>
        <p>投注在于预测第一个结果是否期间会看到客队平局获胜。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会输入/输出 1°期间</span></p>
        <p>投注在于预测第一个结果是否期间会看到主队或客队的胜利。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 1°期间</span></p>
        <p>投注旨在预测比赛第一节的总进球数是否低于（小于）或高于（大于）预先设定的限制。</p>
        <p><span style={{ color: "#ff0000" }}>在家下方/上方 1°期间</span></p>
        <p>投注旨在预测主队在第一节的总进球数是否低于（低于）或高于（高于）预先设定的限制。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于访客 1°期间</span></p>
        <p>投注旨在预测主队在第一节的总进球数是否低于（低于）或高于（高于）预先设定的限制。</p>
        <p><span style={{ color: "#ff0000" }}>目标/无目标 1°期间</span></p>
        <p>投注包括预测两队是否都会得分（进球）或两队是否至少有一支球队不会得分。第一阶段没有进球 (NoGoal)一场比赛的比赛时间。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 1°期间</span></p>
        <p>投注在于预测两队第一场比赛的进球总数是否相同会议期间将是偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>得分 1°第 1 场进球期间</span></p>
        <p>投注包括预测哪支球队会得分。第一个进球或者如果第一场没有进球会议期间。</p>
        <p><span style={{ color: "#ff0000" }}>第 1 场最后进球期间</span></p>
        <p>投注包括预测哪支球队会得分。最后一个进球或者如果第一个进球没有进球会议期间。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 让分 2°期间</span></p>
        <p>投注包括通过将投注中指定的进球数的让分差应用于最终结果来预测第二节的获胜者。出于投注目的，它将是仅考虑比赛第二节的得分。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 2°期间</span></p>
        <p>投注在于预测第二场比赛的结果比赛期间。出于投注目的，它将是仅考虑比赛第二节的得分。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会 IN 2°期间</span></p>
        <p>投注在于预测第二个的结果是否期间会看到主队获胜或平局。出于投注目的，它将是仅考虑比赛第二节的得分。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会 OUT 2°期间</span></p>
        <p>投注在于预测第二个的结果是否期间会看到客队平局获胜。出于投注目的，它将是仅考虑比赛第二节的得分。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会输入/输出 2°期间</span></p>
        <p>投注在于预测第二个的结果是否期间会看到主队或客队获胜。出于投注目的，它将是仅考虑比赛第二节的得分。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 2°期间</span></p>
        <p>投注包括预测一场比赛前两节的总进球数是否为低于（低于）或高于（高于）预定限值。出于投注目的，它将是仅考虑比赛第二节的得分。</p>
        <p><span style={{ color: "#ff0000" }}>目标/无目标 2°期间</span></p>
        <p>投注包括预测两支球队是否都会得分（进球）或两队是否至少有一支球队不会得分。第二场比赛中没有进球 (NoGoal)一场比赛的比赛时间。出于投注目的，它将是仅考虑比赛第二节的得分。</p>
        <p><br /></p>
        <p><br /></p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 2°期间</span></p>
        <p>投注是预测两队在第二节的进球总数是否会议期间将是偶数或奇数。出于投注目的，它将是仅考虑比赛第二节的得分。</p>
        <p><span style={{ color: "#ff0000" }}>得分 1°第2场进球期间</span></p>
        <p>投注包括预测哪支球队会得分。第一个进球或者第二个进球没有进球会议期间。出于投注目的，它将是仅考虑比赛第二节的得分。</p>
        <p><span style={{ color: "#ff0000" }}>第二个进球期间</span></p>
        <p>投注包括预测哪支球队会得分。最后一个进球或者第二个进球没有进球会议期间。出于投注目的，它将是仅考虑比赛第二节的得分。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 盘口 3°期间</span></p>
        <p>投注包括通过将投注中指定的进球数的让分差应用于最终结果来预测第三节的获胜者。出于投注目的，它将是仅考虑比赛第3节的得分，不包括加时赛和点球大战。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 3°期间</span></p>
        <p>投注在于预测第三场比赛的结果比赛期间。出于投注目的，它将是仅考虑比赛第3节的得分，不包括加时赛和点球大战。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会在 3°期间</span></p>
        <p>投注在于预测第三次比赛的结果是否期间会看到主队获胜或平局。出于投注目的，它将是仅考虑比赛第3节的得分，不包括加时赛和点球大战。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会 OUT 3°期间</span></p>
        <p>投注在于预测第三次比赛的结果是否期间会看到客队平局获胜。出于投注目的，它将是仅考虑比赛第3节的得分，不包括加时赛和点球大战。</p>
        <p><span style={{ color: "#ff0000" }}>双倍机会输入/输出 3°期间</span></p>
        <p>投注在于预测第三次比赛的结果是否期间会看到主队或客队获胜。出于投注目的，它将是仅考虑比赛第3节的得分，不包括加时赛和点球大战。</p>
        <p><span style={{ color: "#ff0000" }}>3°以下/以上期间</span></p>
        <p>投注包括预测一场比赛前 3 节的总进球数是否为低于（低于）或高于（高于）预定限值。出于投注目的，它将是仅考虑比赛第3节的得分，不包括加时赛和点球大战。</p>
        <p><br /></p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>目标/无目标 3°期间</span></p>
        <p>投注包括预测两队是否都会得分（进球）或两队是否至少有一支球队不会得分。第三节期间没有进球 (NoGoal)一场比赛的比赛时间。出于投注目的，它将是仅考虑比赛第3节的得分，不包括加时赛和点球大战。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 3°期间</span></p>
        <p>投注在于预测两队在第三节的进球总和是否会议期间将是偶数或奇数 出于投注目的，它将是仅考虑比赛第3节的得分，不包括加时赛和点球大战。</p>
        <p><span style={{ color: "#ff0000" }}>得分 1°第三节进球期间</span></p>
        <p>投注包括预测哪支球队会得分。第一个进球或如果第三个进球没有进球会议期间。出于投注目的，它将是仅考虑比赛第3节的得分，不包括加时赛和点球大战。</p>
        <p><span style={{ color: "#ff0000" }}>第三回合最后进球期间</span></p>
        <p>投注包括预测哪支球队会得分。最后一个进球或者如果第三个进球没有进球会议期间。出于投注目的，它将是仅考虑比赛第3节的得分，不包括加时赛和点球大战。</p>
        <p><span style={{ color: "#ff0000" }}>胜利边距</span></p>
        <p>投注包括预测哪支球队将赢得比赛。以及幅度是多少。出于投注目的，仅考虑常规时间。</p>
        <p><span style={{ color: "#ff0000" }}>最多的时期目标</span></p>
        <p>投注包括预测哪个时期进球最多。将两队的进球数相加即可得出进球数。将提供 4 种可能的结果 1 个周期，2°周期，3°两节比赛（不包括加时赛和点球大战）和平局（所有比赛时间相同或两个比赛时间相同且比另一比赛得分高时为平局）。</p>
        <p><span style={{ color: "#ff0000" }}>得分 1°目标</span></p>
        <p>投注包括预测哪支球队会得分。比赛常规时间内的第一个进球。</p>
        <p>1预测主队将取得第一个进球</p>
        <p>X 您预测常规时间两支球队都不会得分（常规时间 0-0）</p>
        <p>2您预测客队将率先进球</p>
        <p><span style={{ color: "#ff0000" }}>确切结果</span></p>
        <p>投注包括预测比赛的确切结果。有效结果是规定时间结束时获得的。</p>
        <p><span style={{ color: "#ff0000" }}>总目标</span></p>
        <p>投注包括预测一场比赛中的进球数，包括加时赛和点球大战，在以下范围之一中进行选择：</p>
        <p>0-2</p>
        <p>3-4</p>
        <p>5-6</p>
        <p>7-8</p>
        <p>大于8</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇</span></p>
        <p>投注包括预测比赛结束时的总进球数（包括加时赛和点球大战）是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇主队</span></p>
        <p>投注包括预测主队在比赛结束时的总进球数（包括加时赛和点球大战）是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>双/单客队</span></p>
        <p>投注包括预测客队在比赛结束时的总进球数（包括加时赛和点球大战）是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>比赛现场下/上</span></p>
        <p><span>投注包括预测一场比赛的总进球数是否为低于（低于）或高于（高于）预先设定的限制。</span></p>
        <p><span>出于投注目的，任何加时赛或射门将不被考虑。</span></p>
        <p><span style={{ color: "#ff0000" }}>Casa Live 下/上</span></p>
        <p><span>投注旨在预测主队在一场比赛中的总进球数是否低于（小于）或高于（大于）预先设定的限制。</span></p>
        <p><span>出于投注目的，任何加时赛或射门将不被考虑。</span></p>
        <p><span style={{ color: "#ff0000" }}>低于/高于访客直播</span></p>
        <p><span>投注旨在预测客队在一场比赛中的总进球数是否低于（小于）或高于（大于）预先设定的限制。</span></p>
        <p><span>出于投注目的，任何加时赛或射门将不被考虑。</span></p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>游泳 </span></span></p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>游泳是只允许获胜投注，即预测已发布名单中的游泳运动员中谁将获胜。比赛。</p>
        <p>注意：如果公布名单中的游泳运动员没有参加比赛或在比赛期间退出，则对其接受的投注将被视为输家，因此不予考虑。预计将退还赌注。</p>
        <p>如果出现平局， 2 个或以上运动员，获胜者的份额必须除以先到达的参赛者数量</p>
        <p>示例</p>
        <p>与 2 名运动员并列抵达，价格分别为 2.20 和 3.00。</p>
        <p>赔率将除以 2，因此将分别变为 1.10 和 1.50。</p>
        <p><span style={{ color: "#ff0000" }}>赢得奥运会</span></p>
        <p>它包括在公布的名单中的运动员中预测谁将赢得冠军。金牌。</p>
        <p>注意：如果公布名单中的运动员没有参加比赛或在比赛期间退出，则对其接受的投注将被视为输家，因此不予考虑。预计将退还赌注。</p>
        <p>如果出现平局， 2 个或以上运动员，获胜者的份额必须除以先到达的参赛者数量</p>
        <p>示例：</p>
        <p>与 2 名运动员并列抵达，价格分别为 2.20 和 3.00。</p>
        <p>赔率将除以 2，因此将分别变为 1.10 和 1.50。</p>
        <p><span style={{ color: "#ff0000" }}>获胜直播</span></p>
        <p>这个市场包括预测特定比赛的获胜者。客户打赌选定的游泳者将会到达1°在比赛中。有问题的种族可以可以是预赛或比赛中的任何其他类型的比赛，例如半决赛或决赛。可能的结果数量取决于参加比赛的参与者数量。</p>
        <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
        <p>投注在于预测在列表中指定的运动员或团队中，将实现根据比赛/活动结束时的排名确定最佳名次。</p>
        <p>如果公布名单中的运动员或团队没有参加或退出，则对其接受的投注将被视为输家，因此无效。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>无 X 获胜</span></p>
        <p>投注旨在预测将被分类的运动员、球队或国家。通过从列表中排除特定结果，在比赛或体育赛事中获得第一名。</p>
        <p>如果公布名单中的运动员或团队没有参加比赛或在比赛期间退出，则针对他接受的投注将被视为输家，因此不可能进行。预计退款。如果并非所有可能的结果都出现在提议的列表中，则始终包括“其他”项目。</p>
        <p><span style={{ color: "#ff0000" }}>获胜是/否</span></p>
        <p>投注包括预测提议的运动员或团队是否会赢得比赛（结果是）或不是（结果否）某场比赛/活动。</p>
        <p><span style={{ color: "#ff0000" }}>热火冠军</span></p>
        <p>投注包括预测将完成比赛的运动员或团队最好成绩是特定比赛预赛的预赛。</p>
        <p>注意：如果公布名单中的游泳运动员或队伍没有参加预赛，则对其接受的投注将被视为输家，因此不予考虑。预计将退还赌注。</p>
        <p>如果出现平局， 2 个或以上运动员，获胜者的份额必须除以先到达的参赛者数量</p>
        <p>示例</p>
        <p>与 2 名运动员并列抵达，价格分别为 2.20 和 3.00。</p>
        <p>赔率将除以 2，因此将分别变为 1.10 和 1.50。</p>
        <p><span style={{ color: "#ff0000" }}>奖牌获得者</span></p>
        <p>您必须预测哪个国家将成为获胜者。特定学科奖牌榜的获得者。</p>
        <p>排名将进行帐户，按顺序：</p>
        <p>获得的金牌数量；</p>
        <p>获得银牌的数量；</p>
        <p>获得铜牌的数量；</p>
        <p>如果公布名单中的运动员或团队没有参加比赛或在比赛期间退出，则针对他接受的投注将被视为输家，因此不可能进行。预计退款。如果并非所有可能的结果都出现在提议的列表中，则始终包括“其他”项目。</p>
        <p><span style={{ color: "#ff0000" }}>没有 X 的奖牌获得者</span></p>
        <p>您必须预测哪个国家将成为获胜者。特定学科的奖牌榜获胜者（不包括特定团队的名单）</p>
        <p>排名将进行帐户，按顺序：</p>
        <p>获得的金牌数量；</p>
        <p>获得银牌的数量；</p>
        <p>获得铜牌的数量；</p>
        <p>如果公布名单中的运动员或团队没有参加比赛或在比赛期间退出，则针对他接受的投注将被视为输家，因此不可能进行。预计退款。如果并非所有可能的结果都出现在提议的列表中，则始终包括“其他”项目。</p>
        <p><span style={{ color: "#ff0000" }}>赢得比赛 x 和比赛 y </span></p>
        <p>您必须预测特定运动员或特定团队是否会成功。赢得两场特定的不同比赛。投注认证是取决于运动员或团队参加投注所涵盖的两场比赛；否则，投注将继续进行。返还赌注。</p>
        <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
        <p>投注旨在预测运动员是否会下注特定比赛或赛事的前三名或更少。</p>
        <p><span style={{ color: "#ff0000" }}>国家 x 运动员登上领奖台是/否</span></p>
        <p>投注包括预测至少一名特定国籍的运动员是否会获胜将被分类在特定比赛中获得前三名。</p>
        <p><span style={{ color: "#ff0000" }}>世界纪录是/否</span></p>
        <p>你必须预测在给定的比赛中是否创造或不创造新的世界纪录，改善之前的纪录。出于投注目的，预赛阶段创下的任何记录也会被考虑在内。</p>
        <p><span style={{ color: "#ff0000" }}>世界纪录是/否运动员 –团队</span></p>
        <p>您必须预测在特定比赛中，特定运动员或特定团队是否会取得成功。或者不创造新的世界纪录，提高之前的纪录。出于投注目的，还会考虑资格赛中创下的任何记录。</p>
        <p><span style={{ color: "#ff0000" }}>面对面</span></p>
        <p>投注包括预测在两个提案之间将实现的运动员或团队根据比赛/活动结束时的排名确定最佳名次。</p>
        <p>注意，投注的认证是通过参加比赛的两个结果以及同一比赛的至少一个结果的结束来进行的。否则，投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>合格是/否</span></p>
        <p>您必须预测特定运动员或团队是否有资格。通过预赛阶段即可参加特定的比赛。投注认证是以运动员或队伍参加特定比赛的预赛阶段为准，否则程序将被取消返还赌注。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 金牌</span></p>
        <p>您必须预测指定的两名运动员或队伍中哪一位将赢得比赛。更多的金牌。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 奖牌总数</span></p>
        <p>您必须预测指定的两名运动员或球队中哪一位会获胜取得更多成就奖牌，确定获胜者时会考虑获得的奖牌总数（金、银、铜）。</p>
        <p><span style={{ color: "#ff0000" }}>U/O Ori</span></p>
        <p>您必须预测特定运动员或团队赢得的金牌总数是否为低于（低于）或高于（超过）预设限制。</p>
        <p><span style={{ color: "#ff0000" }}>U/O 奖牌</span></p>
        <p>您必须预测特定运动员或团队赢得的奖牌总数（金牌、银牌和铜牌）是否为低于（低于）或高于（超过）预设限制。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>HANDBALL </span></span></p>
        <p><span style={{ color: "#ff0000" }}>T/T 盘口：</span></p>
        <p>特许公司将两支球队中的一支视为小数让分，因此对于投注来说，不会导致平局。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 匹配</span></p>
        <p>投注在于预测常规时间结束时赛事的最终结果：</p>
        <p>1表示第一主队获胜；</p>
        <p>平局；</p>
        <p>2第二主办队获胜</p>
        <p><span style={{ color: "#ff0000" }}>1X2 让分盘</span></p>
        <p>投注包括在常规时间结束时预测赛事结果，同时考虑分配给两支球队之一的让分（以进球数表示）。</p>
        <p>投注结果由劣势球队在场上取得的得分减去让分值决定分配的状态：</p>
        <p>1（带H）表示第一个提议的队伍获胜；</p>
        <p>X（与 H）平局，</p>
        <p>2（带有H）第二个提议团队的胜利。</p>
        <p>示例</p>
        <p>普雷萨诺 -安科纳 27 – 22（普雷萨诺 4 球让分）</p>
        <p>获胜结果 1（27-4=23 最终决议 23 - 22，因此 1）</p>
        <p>示例</p>
        <p>普雷萨诺 -安科纳 27 – 23（普雷萨诺 4 球让分）</p>
        <p>获胜结果 X（27-4=23 最终决议 23 - 23 因此 X）</p>
        <p>示例</p>
        <p>普雷萨诺 -安科纳 27 – 25（对阵普雷萨诺 4 球让分）</p>
        <p>获胜结果 2（27-4=23 最终决议 23 - 25 因此 2）</p>
        <p><span style={{ color: "#ff0000" }}>下/上</span></p>
        <p>投注包括预测在给定赛事中两支球队在常规时间结束时的进球总数是否为低于（低于）或高于（高于）某个值。</p>
        <p><span style={{ color: "#ff0000" }}>主队下/上</span></p>
        <p>投注包括预测主队在一场比赛中的总得分为低于或高于某个值。出于报告目的，仅考虑常规时间。</p>
        <p><span style={{ color: "#ff0000" }}>客队下/上</span></p>
        <p>投注包括预测客队在一场比赛中的总得分为低于或高于某个值。出于报告目的，仅考虑常规时间。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 让分 1°时间</span></p>
        <p>投注包括预测哪支球队会获胜上半场结束时领先，结果将是通过将让分差值应用于所选球队的总得分来确定。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 1°时间</span></p>
        <p>您必须预测在给定的赛事中，两支球队在上半场结束时的进球总数是否会低于（低于）或高于（高于）给定值。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇</span></p>
        <p>投注包括预测比赛中两队在常规时间内的总得分是单数还是双数。</p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>水球</span></span></p>
        <p><span style={{ color: "#ff0000" }}>最终结果1X2</span></p>
        <p>投注在于预测常规时间结束时赛事的最终结果：</p>
        <p>1表示主队获胜</p>
        <p>X表示平局</p>
        <p>客队取得 2 场胜利。</p>
        <p><span style={{ color: "#ff0000" }}>最终结果 1X2 带让分</span></p>
        <p>投注包括考虑分配给两支球队之一的让分，预测常规时间结束时赛事的最终结果。</p>
        <p>示例A：</p>
        <p>波西利波 –佛罗伦萨 10 – 5（波西利波 3 球让分）</p>
        <p>获胜结果 1：(10 -3=7 &rarr; 最终结果 7-5 因此 1)</p>
        <p>示例 B：</p>
        <p>波西利波 –佛罗伦萨 10 – 7（波西利波 3 球让分）</p>
        <p>获胜结果 X（10-3=7 &rarr；最终结果 7 - 7 因此 X）</p>
        <p>示例C：</p>
        <p>波西利波 –佛罗伦萨 10 – 9（波西利波 3 球让分）</p>
        <p>获胜结果 2（10-3=7 &rarr；最终结果 7 - 9 因此 2）</p>
        <p><span style={{ color: "#ff0000" }}>与让分盘交锋</span></p>
        <p>特许公司将两支球队中的一支视为小数让分，因此对于投注来说，不会导致平局。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 13.5 – 16.5—— 19.5</span></p>
        <p>它包括预测常规时间结束时的总进球数是低于还是高于（13.5 - 16.5 - 19.5 球）。</p>
        <p>在假设下，预测将是最多 13 场比赛 – 16 19 个进球； with over 预测目标将相等或更多共 14 个17—— 20</p>
        <p>注意对于这种类型的投注，用于投注目的的有效结果是规定时间结束时获得的。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>拳击 </span></span></p>
        <p><span style={{ color: "#ff0000" }}>1X2 MATCH</span></p>
        <p>您必须预测比赛的最终结果。</p>
        <p><span style={{ color: "#ff0000" }}>ROUND NUMBER-UNDER/OVER</span></p>
        <p>您必须预测比赛中的总轮数是否会低于或高于某个值。为了分配投注的目的，在半轮的情况下，将执行以下操作：参考各轮的分钟和 30 秒来确定下注或大注的结果。活动中如果比赛因任何原因中断且未结束，就投注而言，只有结果可被证明的投注才会进行结算，否则投注将被视为无效并退款。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>RUGBY</span></span></p>
        <p>对于橄榄球投注，有效结果是常规时间（即比赛 80 分钟）结束时获得的时间，加上可能恢复。</p>
        <p>最终结果1X2</p>
        <p>投注包括预测常规时间（80 分钟加上任何伤停补时）结束时所取得的赛事最终结果：</p>
        <p>1 - 表示主队胜利</p>
        <p>X - 平局</p>
        <p>2 - 客队获胜。</p>
        <p><span style={{ color: "#ff0000" }}>最终结果 1X2 带让分</span></p>
        <p>投注包括考虑分配给两支球队之一的让分（以分数表示），预测常规时间结束时的赛事结果。</p>
        <p>投注结果由劣势球队在场上取得的得分减去让分值决定状态分配：1（带H）表示主队获胜，X（带H）表示平局，2（带H）表示主队获胜。</p>
        <p>示例A：</p>
        <p>意大利 - 威尔士 26 – 18（意大利让分 7 分）</p>
        <p>获胜结果 1：(26-7=19 &rarr; 最终结果 19-18 因此 1)</p>
        <p>示例 B：</p>
        <p>意大利 - 威尔士 26 – 19（意大利让分 7 分）</p>
        <p>获胜结果 X (26-7=19 &rarr; 最终结果 19-19 因此 X)</p>
        <p>示例C：</p>
        <p>意大利 - 威尔士 26 – 20（意大利让分 7 分）</p>
        <p>获胜结果 2：(26-7=19 &rarr; 最终结果 19-20 因此 2)</p>
        <p><span style={{ color: "#ff0000" }}>胜利17场比赛</span></p>
        <p>投注包括预测两队之一在常规时间结束时赢得比赛的分数差异。</p>
        <p>投注包括主队（A）获胜的 8 项赛事、客队（B）胜利的 8 项赛事以及平局的 1 项赛事。</p>
        <p>它所涉及的 17 个可能的事件可接受的投注接受如下：</p>
        <p>1.主队以1分至5分的差距获胜；</p>
        <p>2.分差在6分至10分之间的主队获胜；</p>
        <p>3.主队获胜，分差在 11 分至 15 分之间；</p>
        <p>4.主队获胜，分差在 16 分至 20 分之间；</p>
        <p>5.主队获胜，分差在21分至25分之间；</p>
        <p>6.主队获胜，分差在26分至30分之间；</p>
        <p>7.主队获胜，分差在 31 分至 35 分之间；</p>
        <p>8.分差大于36分的主队获胜；</p>
        <p>9.客队以1分至5分的差距获胜；</p>
        <p>10。分差在6分至10分之间的客队获胜；</p>
        <p>11。客队以11分至15分的差距获胜；</p>
        <p>12.客队以16分至20分的差距获胜；</p>
        <p>13。客队以21分至25分的差距获胜；</p>
        <p>14。客队以26分至30分的差距获胜；</p>
        <p>15。客队以31分至35分的差距获胜；</p>
        <p>16。分差大于36分的客队获胜；</p>
        <p>17。绘制</p>
        <p><span style={{ color: "#ff0000" }}>下/上 </span></p>
        <p>投注包括预测两支球队在常规时间结束时的得分总和是否为：</p>
        <p>UNDER（小于或等于指定点差）</p>
        <p>OVER（高于指定点差）</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>RUGBY A 7</span></span></p>
        <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
        <p>您必须预测哪支球队将赢得比赛。比赛在规定时间结束时进行。</p>
        <p><span style={{ color: "#ff0000" }}>最终结果 1X2 让分盘</span></p>
        <p>投注包括考虑分配给两支球队之一的让分（以分数表示），预测常规时间结束时的赛事结果。</p>
        <p><span style={{ color: "#ff0000" }}>交锋让分</span></p>
        <p>您必须预测哪支球队将赢得比赛。任何加时赛将不考虑用于投注目的。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇</span></p>
        <p>您必须预测一场比赛中两队在常规时间内得分的总和是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>下/上</span></p>
        <p>您必须预测比赛常规时间内两队的总得分是否为低于（低于）或高于（高于）某个值。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于起始点</span></p>
        <p>您必须预测第 1 队在一场比赛的常规时间内获得的总得分是否为低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于宾客积分</span></p>
        <p>您必须预测第 2 队在一场比赛的常规时间内获得的总得分是否为低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 Mete</span></p>
        <p>您必须预测一场比赛的常规时间内两队的总尝试次数是否为低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>Mete Team 1 下/上</span></p>
        <p>您必须预测第 1 队在一场比赛的常规时间内得分的总尝试次数是否为低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>Mete Team 2 下/上</span></p>
        <p>您必须预测第 2 队在一场比赛的常规时间内得分的总尝试次数是否为低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>1X2 1°时间</span></p>
        <p>您必须预测哪支球队将赢得比赛。会议的上半场。</p>
        <p><span style={{ color: "#ff0000" }}>头对头让分 1°时间</span></p>
        <p>您必须预测哪支球队将赢得比赛。第一个比赛时间，将投注中指示的差额应用于第一个比赛结束时取得的结果时间。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于 1°时间</span></p>
        <p>您必须预测两队在上半场比赛中的总得分是否为低于（低于）或高于（高于）某个值。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 1°时间</span></p>
        <p>您必须预测一场比赛上半场的得分是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>得分最高的玩家点</span></p>
        <p>你必须预测将会得分的球员锦标赛中得分最高。</p>
        <p><span style={{ color: "#ff0000" }}>得分最高的玩家目标</span></p>
        <p>你必须预测将会得分的球员锦标赛中尝试次数最多的。</p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>投注在于预测将被分类的球队。在比赛或体育赛事中获得第一名。</p>
        <p><span style={{ color: "#ff0000" }}>获胜是/否</span></p>
        <p>投注在于预测提议的球队是否会赢得比赛。 （结果是）或不是（结果否）某场比赛/活动。</p>
        <p><span style={{ color: "#ff0000" }}>无 X 获胜</span></p>
        <p>投注在于预测将被分类的球队。通过从列表中排除特定结果，在比赛或体育赛事中获得第一名。</p>
        <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
        <p>投注包括预测列表中指定的球队将实现根据比赛/活动结束时的排名确定最佳名次。</p>
        <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
        <p>投注包括预测球队是否会获得第一名。特定比赛或赛事的前三名或更少。</p>
        <p><span style={{ color: "#ff0000" }}>面对面</span></p>
        <p>打赌在于预测两个提案之间哪个团队将实现目标。根据比赛/活动结束时的排名确定最佳名次。</p>
        <p>注意，投注需参加比赛并取得两种结果才能获得认证，否则投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>可能的最终配对</span></p>
        <p>您必须预测提议的球队中哪一组将参加比赛。锦标赛决赛。</p>
        <p><span style={{ color: "#ff0000" }}>四分之一决赛是/否</span></p>
        <p>你必须预测指定的队伍是否会到达或更少进入特定赛事的四分之一决赛。如果选定的团队不参加，我们将继续进行。返还赌注。</p>
        <p><span style={{ color: "#ff0000" }}>半决赛是/否</span></p>
        <p>你必须预测指定的队伍是否会到达在特定赛事的半决赛中或更少。如果选定的团队不参加，我们将继续进行。返还赌注。</p>
        <p><span style={{ color: "#ff0000" }}>最终是/否</span></p>
        <p>你必须预测指定的队伍是否会到达或未进入特定赛事的决赛。如果选定的团队不参加，我们将继续进行。返还赌注。</p>
        <p><span style={{ color: "#ff0000" }}>团队淘汰阶段</span></p>
        <p>您必须预测指定团队将在锦标赛的哪个阶段取得领先。已删除。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>橄榄球联盟</span></span></p>
        <p><span style={{ color: "#ff0000" }}>最终结果 1X2</span></p>
        <p>您必须预测哪支球队将赢得比赛。比赛在规定时间结束时进行。</p>
        <p><span style={{ color: "#ff0000" }}>头对头障碍</span></p>
        <p>您必须通过在最终结果中加上或减去投注中指示的差价来预测常规时间结束时的比赛结果。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于集合点</span></p>
        <p>您必须预测比赛常规时间内两队的总得分是否为低于（低于）或高于（高于）某个值。</p>
        <p><span style={{ color: "#ff0000" }}>UNDER/OVER POINTS 1 HALF</span></p>
        <p>您必须预测两队在上半场比赛中的总得分是否为低于（低于）或高于（高于）某个值。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>奇/偶</span></p>
        <p>您必须预测一场比赛常规时间结束时两队的总得分之和是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>结果 1 HALF 1X2</span></p>
        <p>您必须预测比赛上半场的结果。</p>
        <p><span style={{ color: "#ff0000" }}>头对头差点 1°时间</span></p>
        <p>您必须预测哪支球队将赢得比赛。 1 日比赛时间，通过在第一场比赛结束时的结果中加上或减去投注中指示的让分来计算时间。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇 1°时间</span></p>
        <p>你必须预测第一节结束时两队的总得分之和是否为会议时间将是偶数或奇数。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>乒乓球</span></span></p>
        <p><span style={{ color: "#ff0000" }}>头对头结果</span></p>
        <p>你必须预测哪位玩家会获胜会议。如果一名球员在比赛期间退出，则对该球员接受的投注将被视为输；反之亦然，如果玩家在比赛开始前退出，则投注将被退还</p>
        <p><span style={{ color: "#ff0000" }}>按钮设置 1</span></p>
        <p>你必须预测哪位玩家会获胜9 月 1 日。如果一名球员在第一盘中退赛，则对该球员接受的投注将被视为输；反之亦然，如果选手在第一盘开始前退出，则投注将被退还。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>VOLLEY</span></span></p>
        <p><span style={{ color: "#ff0000" }}>电汇结果</span></p>
        <p>投注包括根据以下方法预测比赛的最终结果：</p>
        <p>1：主队获胜</p>
        <p>2：客队获胜</p>
        <p>示例：</p>
        <p>特雷维索 -摩德纳 3-1 胜分：1</p>
        <p>特雷维索 -摩德纳 2-3 胜绩：2</p>
        <p><span style={{ color: "#ff0000" }}>电汇盘口</span></p>
        <p>投注包括通过将投注中指定的盘数应用让分盘到最终结果来预测比赛的获胜者。差点分布为根据比赛的不同，处于劣势的球队将被指定为正让分，而热门球队将被指定为负让分。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 让分盘</span></p>
        <p>投注包括通过将投注中指定的分数应用让分盘到最终结果来预测比赛的获胜者。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 集 1</span></p>
        <p>投注在于预测第一盘的获胜者。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 套装 2</span></p>
        <p>投注在于预测第二盘的获胜者。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 集 3</span></p>
        <p>投注包括预测第三盘的获胜者</p>
        <p><span style={{ color: "#ff0000" }}>设置 4 YES/NO</span></p>
        <p>投注在于预测在给定的比赛中是否会出现4 号是否播放设置。</p>
        <p><span style={{ color: "#ff0000" }}>设置 5 YES/NO</span></p>
        <p>投注在于预测在给定的比赛中是否会出现5号是否播放设置。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 让分盘 1</span></p>
        <p>投注包括预测第一场比赛的获胜者通过根据投注中指定的分数应用让分差来设置比赛。</p>
        <p><span style={{ color: "#ff0000" }}>下/上点</span></p>
        <p>投注在于预测比赛结束时的最终得分总和（因此将所进行的比赛中累积的所有得分相加）是否低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于团队积分 1</span></p>
        <p>投注包括预测第 1 队在一场比赛中的总得分是否为低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>球队积分低于/高于 2</span></p>
        <p>投注包括预测第 2 队在一场比赛中的总得分是否为低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>下/上点设置 X</span></p>
        <p>投注包括预测给定游戏组的最终得分是低于还是高于给定值。</p>
        <p>如果比赛暂停，为了验证投注，将参考该局比赛场上取得的成绩。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于分组 1 第 1 队</span></p>
        <p>投注包括预测第 1 队在第一盘比赛中的总得分是否为低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>低于/高于分组 1 第 2 队</span></p>
        <p>投注包括预测第 2 队在第一盘比赛中的总得分是否为低于或高于某个值。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇</span></p>
        <p>该投注旨在预测两支球队在一场比赛中的总得分是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>偶数/奇数宫点数</span></p>
        <p>投注包括预测 1 队在一场比赛中的总得分是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>偶数/奇数宾客积分</span></p>
        <p>投注包括预测第 2 队在一场比赛中的总得分是否为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>偶/奇集 1</span></p>
        <p>投注在于预测第一轮的总分是否得分设置为偶数或奇数。</p>
        <p><span style={{ color: "#ff0000" }}>将投注设置为 5</span></p>
        <p>投注包括预测比赛结束的确切比分（以局数表示）。排球比赛。有 6 种可能的选择：</p>
        <p>3-0; 0-3</p>
        <p>3-1; 1-3</p>
        <p>3-2; 2-3</p>
        <p><span style={{ color: "#ff0000" }}>设置数字 (3/5)</span></p>
        <p>投注包括预测一场比赛的总局数。</p>
        <p><span style={{ color: "#ff0000" }}>将投注设置为 7</span></p>
        <p>投注包括预测比赛的最终结果（以局数计算）。该市场提供以 7 盘两胜制形式进行的比赛。</p>
        <p><span style={{ color: "#ff0000" }}>设置数字 (4/7)</span></p>
        <p>投注包括预测一场比赛的总局数。该市场提供以 7 盘两胜制形式进行的比赛。</p>
        <p><span style={{ color: "#ff0000" }}>获胜第一盘和获胜比赛</span></p>
        <p>投注在于预测谁将获胜的确切组合。第一盘谁会获胜比赛。如果比赛因任何原因未进行或最终中断，已接受的投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>获胜比赛和下/上分</span></p>
        <p>投注同时预测比赛的获胜者以及两支球队的总得分是否为高于或低于预定指标。出于投注目的，任何黄金套装均被排除在外。</p>
        <p><span style={{ color: "#ff0000" }}>总体设置为优势</span></p>
        <p>投注在于预测一场比赛将根据优势决定多少局。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>机动 </span></span></p>
        <p>对于赛车投注，有效结果是官方联合会颁发的一份。任何随后发布的排名更改对于投注目的均无效。</p>
        <p>注意，根据官方联合会的要求，侦察圈是比赛本身的一部分。</p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>投注在于预测获胜的车手。单项大奖赛。</p>
        <p>注意，如果车手没有参加比赛，则对该竞争对手接受的投注将被视为输家。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 竞赛</span></p>
        <p>该赌注在于预测在两个提议者之间将实现以下目标的车手根据比赛排名确定最佳名次。出于报告目的，即使比赛因任何原因未完成，官方联合会发布的排名顺序仍然有效，并且只有在一名或两名车手未参加比赛，或者两者均未参加的情况下，投注才会退还两个飞行员的分类相同。</p>
        <p><span style={{ color: "#ff0000" }}>团体赛获胜</span></p>
        <p>投注在于预测列表中指定的车手中谁将实现根据比赛结束时的排名确定最佳名次。出于报告目的，即使比赛因任何原因未完成，官方联合会发布的排名顺序仍然有效。如果公布名单中的车手没有参加或退出，则对其接受的投注将被视为有效。失败者，如果比赛结束时名单上的车手均未入围，则投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>Scuderia del Vincente</span></p>
        <p>投注在于预测获胜车手所属的车队。单一种族。如果该车队的车手均未参加比赛，则对该车队接受的投注将被视为输。出于报告目的，参考国际汽联发布的官方排名。</p>
        <p><span style={{ color: "#ff0000" }}>国籍获胜者的</span></p>
        <p>投注在于预测玩家的国籍。获胜车手的单项大奖赛。</p>
        <p>注意，如果车手没有参加比赛，则对该竞争对手接受的投注将被视为输家。</p>
        <p><span style={{ color: "#ff0000" }}>多圈比GP还快</span></p>
        <p>投注在于预测将取得最佳成绩的车手。最长一圈大奖赛期间速度很快。</p>
        <p>注意，如果车手没有参加比赛，则对该竞争对手接受的投注将被视为输家。</p>
        <p><span style={{ color: "#ff0000" }}>赢得官方资格</span></p>
        <p>投注在于预测获胜的车手。官方资格。</p>
        <p>注意，如果车手没有参加官方排位赛，则对该竞争对手接受的投注将被视为输家。</p>
        <p><span style={{ color: "#ff0000" }}>电汇资质</span></p>
        <p>该赌注在于预测在两个提议者之间将实现以下目标的车手根据特定大奖赛的官方排位赛排名得出的最佳名次。出于报告目的，即使由于任何原因未能完成资格赛，如果一名或两名车手未参加资格赛或两人均未获得排名，则官方联合会发布的排名顺序投注将被退还；在同一结尾。</p>
        <p><span style={{ color: "#ff0000" }}>资格组冠军</span></p>
        <p>投注在于预测列表中指定的车手中谁将实现根据官方资格赛结束时的排名确定最佳名次。出于报告目的，即使由于任何原因未能完成资格赛，官方联合会发布的排名顺序仍然有效。如果公布名单中的车手没有参加或退出，则对其接受的投注将被视为输家。 .，如果官方排位赛结束时名单上的车手均未入围，则投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>Scuderia del Vincente 排位赛</span></p>
        <p>投注在于预测获胜车手所属的车队。官方资格。如果该车队的车手均未参加，则该车队接受的投注将被视为输。出于报告目的，参考国际汽联发布的官方排名。</p>
        <p><span style={{ color: "#ff0000" }}>赢得免费练习 X</span></p>
        <p>投注在于预测哪位拟议的车手将赢得比赛。给定的自由练习课。该列表还包括结果“其他”。国际汽联提供的单圈时间和排名顺序将作为官方参考。如果车手不参加，对该竞争对手接受的投注将被视为输。</p>
        <p><span style={{ color: "#ff0000" }}>讲台/地点是/否</span></p>
        <p>投注包括预测骑手是否会分类在特定比赛中获得前三名。</p>
        <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
        <p>投注包括预测比赛或赛事结束时登上领奖台的确切顺序（按顺序排列为第一、第二、第三）。如果公布名单中的车手没有参加或退出，则对其接受的投注将被视为有效，因此不被视为有效。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>讲台不按顺序</span></p>
        <p>该投注旨在预测比赛结束时登上领奖台的人员组成，无论所选车手到达的顺序如何。</p>
        <p><span style={{ color: "#ff0000" }}>按顺序配对前两个</span></p>
        <p>在“赌注”中按顺序配对前两个”您需要预测大奖赛期间将获得第一名和第二名的车手配对，并从提供商提供的列表中进行选择。该列表还包括结果“其他”。即使在比赛因任何原因未完成的情况下进行报告，以国际汽联提供的排名顺序作为官方参考。</p>
        <p><span style={{ color: "#ff0000" }}>前两对不按顺序</span></p>
        <p>投注在于预测比赛或赛事结束时登上领奖台的第一名和第二名的组成，而不考虑所选车手到达的确切顺序。如果参加选拔的车手没有参加或退出，则对其接受的投注将被视为有效，因此无效。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>跻身前 6 是/否</span></p>
        <p>投注包括预测特定车手是否会在大奖赛中获得名次或少于前 6 位。出于投注目的，所选车手必须参加比赛（绿灯起跑），否则比赛费用将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>点飞行员是/否</span></p>
        <p>投注在于预测在大奖赛中特定车手是否会获得冠军或少于世界锦标赛排名所需积分的有效排名（即，他们是否排名在第一名和第十名之间）。出于投注目的，所选车手必须参加比赛（绿灯起跑），否则比赛费用将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>积分团队是/否</span></p>
        <p>该投注旨在预测在大奖赛中，同一支球队的两名单座赛车是否将获得有效的名次，以分配世界锦标赛排名所需的积分（即，他们的排名将在第一名和第一名之间； 10°）</p>
        <p><span style={{ color: "#ff0000" }}>单一 GP 车队的两位车手均得分 YES/NO</span></p>
        <p>该投注旨在预测在大奖赛中，同一支球队的两名单座赛车是否将获得有效的名次，以分配世界锦标赛排名所需的积分（即，他们将排名在第一名和第十名之间）地方）。出于投注目的，所选球队的两名单座选手都必须参加比赛（绿灯时起跑），并且不得宣布“未开始”。由负责举办活动的官方机构负责，否则将退款。</p>
        <p><span style={{ color: "#ff0000" }}>分类是/否</span></p>
        <p>投注在于预测指定的车手是否会成功。比赛结束时分类或未分类。要进行分类，飞行员必须已完成获胜者至少 90% 的圈数（向下舍入到最接近的整数圈数）</p>
        <p>注意，该投注的认证取决于可能的投注对象是否参加比赛，否则投注将被退还。</p>
        <p>示例1：</p>
        <p>意大利大奖赛：预计 70 圈。</p>
        <p>要被视为机密，驾驶员必须已完成至少 63 圈。</p>
        <p>示例2：</p>
        <p>意大利大奖赛：预计 70 圈。</p>
        <p>获胜者完成了 60 圈。</p>
        <p>要被视为机密，驾驶员必须已完成至少 54 圈。</p>
        <p><span style={{ color: "#ff0000" }}>排名低于/高于排名</span></p>
        <p>投注包括预测完成大奖赛的车手人数是否为高于（高于）或低于（低于）建议指数。根据国际汽联规定，车手必须至少完成获胜者所完成圈数的 90%，才能被视为分类。</p>
        <p><span style={{ color: "#ff0000" }}> 下/上车手第一名退役游览</span></p>
        <p>投注在于预测第一轮比赛中是否有因任何原因退出的车手总数比赛的圈数将高于或低于预先设定的指数。</p>
        <p><span style={{ color: "#ff0000" }}>飞行员1日退出游览</span></p>
        <p>在“赌注”中N° 飞行员以 1° 退出骑”您需要在可用的选择中预测实际从起跑线出发但在比赛第一圈结束前退赛的车手数量。</p>
        <p><span style={{ color: "#ff0000" }}>第一届结束时的领导者游览</span></p>
        <p>投注在于预测列表中指定的车手中的哪位车手将成为在给定比赛的第一圈结束时获得第一名（不包括侦察圈）。如果名单上的车手没有参加比赛，或因任何原因在未完成第一圈的情况下退赛，则针对该特定车手接受的投注将被视为输家且不会结算。预计退款。如果在赛道上有安全车的情况下开始比赛，则该盘口的投注将被退还。如果由于比赛明确中断而导致第一圈未完成，则投注将已退款。</p>
        <p><span style={{ color: "#ff0000" }}>第一个退休的车手</span></p>
        <p>赌注在于预测哪一个会是第一个在比赛中永久退役的车手。为了确定获胜结果，如果有多支车队在同一圈中退赛，则参考退赛发生的比赛圈数。对于驾驶员，适用公平原则。出于投注目的，选定的车手必须参加比赛（绿灯时开始），如果他根本不参加比赛或在勘察圈期间退赛，则针对该特定车手的匹配投注将被视为输家并且不是；预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>第一个退出的队伍</span></p>
        <p>赌注在于预测哪一个会是第一个在比赛中永久退役的车手的车队。获胜结果以退出比赛的圈数为准。如果不同车队的车手在同一圈退出，则适用同等规则。出于投注目的，所选车队中至少有一名车手必须参加比赛（绿灯起跑）；在所有其他情况下，投注将被视为失败且不符合资格。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>国籍第一个退休的司机</span></p>
        <p>投注在于预测玩家的国籍。第一位在比赛中永久退役的车手。不同国籍车手在同一圈退赛时，以退赛的比赛圈数为准确定胜负。不同的是，适用公平原则的规则。出于投注目的，至少有一名国籍的车手被选中的人必须参加比赛（绿灯时开始），在所有其他情况下，投注将被视为输家，而不是预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>1°排名/最后排名</span></p>
        <p>投注包括同时预测获胜车手和最终排名的车手。在某场比赛中排名最后。出于投注目的，不考虑未分类的车手，并且联合会发布的比赛分类有效。如果参加选拔的车手因任何原因退出或不参加比赛，则投注将被视为失败且不符合资格。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>帽子戏法是/否</span></p>
        <p>投注包括预测是否有车手会在给定的大奖赛中取得成功。获得杆位、大奖赛胜利和最快圈速快。</p>
        <p><span style={{ color: "#ff0000" }}>帽子戏法是/否飞行员</span></p>
        <p>投注包括预测特定车手是否会在给定的大奖赛中取得成功。获得杆位、大奖赛胜利和最快圈速快。</p>
        <p><span style={{ color: "#ff0000" }}>安全车是/否</span></p>
        <p>投注在于预测大奖赛期间是否会发生——包括出发的那一刻——将有安全车进入赛道（虚拟安全车对于投注目的无效）。</p>
        <p><span style={{ color: "#ff0000" }}>进站更多快</span></p>
        <p>投注包括预测哪支球队将表现出色为来自最大车队的车手更换轮胎（全部）在大奖赛过程中很快。</p>
        <p><span style={{ color: "#ff0000" }}>最佳单一 GP 驱动程序列表</span></p>
        <p>投注旨在预测 AAMS 提出的名单中的哪位车手将在给定的大奖赛中获得最佳最终名次。</p>
        <p><span style={{ color: "#ff0000" }}>胜利/开始单人GP</span></p>
        <p>投注包括预测起始网格上的哪个位置赢得特定大奖赛的车手开始。</p>
        <p>你可以从以下网格位置之一中选择：</p>
        <p>杆位</p>
        <p>2°地点</p>
        <p>3°或4°地点</p>
        <p>5° , 6°或7°地点</p>
        <p>8号起至 13 日地点</p>
        <p>其他</p>
        <p><span style={{ color: "#ff0000" }}>赢得 GP F1 Live</span></p>
        <p>投注在于预测获胜的车手。单一全科医生。接受投注可以距离比赛终点线大约一圈。</p>
        <p><span style={{ color: "#ff0000" }}>制造商Motore Del Vincente Gara</span></p>
        <p>投注包括预测将赢得比赛的车手所拥有的汽车的发动机制造商。单一种族。如果制造商的车手均未参加比赛，则对该制造商接受的投注将被视为输家。</p>
        <p><span style={{ color: "#ff0000" }}>1世纪发动机制造商单场比赛退役的车手</span></p>
        <p>该赌注包括预测第一位在比赛期间最终退役的车手的汽车发动机制造商。为了确定获胜结果，如果有多支车队在同一圈中退赛，则参考退赛发生的比赛圈数。配备不同制造商发动机的汽车，适用公平原则。投注将被视为输家，但事实并非如此。如果没有配备所选制造商发动机的车辆参加比赛（绿灯亮起），预计将获得报销。</p>
        <p><span style={{ color: "#ff0000" }}>无 X 获胜</span></p>
        <p>投注在于预测将被分类的车手或车队。通过从列表中排除某个结果而在比赛中获得第一名。如果公布名单中的车手或车队没有参加比赛或在比赛期间退出，则针对他接受的投注将被视为输家，因此不予考虑。预计退款。</p>
        <p><br /></p>
        <p>&nbsp;</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>摩托车</span></span></p>
        <p>对于 MotoGP 投注，有效结果为由主管联合会颁发的一份。任何随后发布的排名更改对于投注目的均无效。</p>
        <p><span style={{ color: "#ff0000" }}>获胜 GP</span></p>
        <p>投注在于预测获胜的车手。单项大奖赛。</p>
        <p>注意，如果车手没有参加比赛，则对该竞争对手接受的投注将被视为输家。</p>
        <p><span style={{ color: "#ff0000" }}>T/T 竞赛</span></p>
        <p>该赌注在于预测在两个提议者之间将实现以下目标的车手根据单场大奖赛的排名确定最佳名次。如果一名或两名车手没有参加比赛，或者比赛结束时两名车手均未获得参赛资格，则投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>获胜是/否</span></p>
        <p>投注包括预测车手是否会赢得比赛。比赛与否。</p>
        <p><span style={{ color: "#ff0000" }}>获胜组</span></p>
        <p>投注在于预测在列表中指定的运动员或团队中，将实现根据比赛/活动结束时的排名确定最佳名次。</p>
        <p>如果公布名单中的运动员或团队没有参加或退出，则对其接受的投注将被视为输家，因此无效。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>无 X 获胜</span></p>
        <p>投注包括预测将被分类的运动员或球队通过从列表中排除特定结果而在比赛或体育赛事中获得第一名。如果公布名单中的运动员或队伍没有参加比赛或在比赛期间退出，则对其接受的投注将被视为输家，因此无效。预计退款。如果并非所有可能的结果都出现在提议的列表中，则始终包括“其他”项目。</p>
        <p><span style={{ color: "#ff0000" }}>Scuderia del Vincente</span></p>
        <p>投注在于预测获胜车手所属的车队。单一种族。如果该车队的车手均未参加比赛，则该车队接受的投注将被视为输。</p>
        <p><span style={{ color: "#ff0000" }}>国籍获胜者的</span></p>
        <p>投注在于预测玩家的国籍。获胜车手的单项大奖赛。如果车手没有参加比赛，则对该竞争对手接受的投注将被视为输。</p>
        <p><span style={{ color: "#ff0000" }}>赢得官方资格</span></p>
        <p>投注在于预测提议名单中指定的车手将获得官方排位赛期间记录的最好成绩。</p>
        <p>注意，如果车手没有参加官方排位赛，则对该竞争对手接受的投注将被视为输家。</p>
        <p><span style={{ color: "#ff0000" }}>电汇资质</span></p>
        <p>该投注旨在预测特定比赛的官方排位赛中两名车手之间的获胜者。对于报告，将考虑所达到的时间，并且不会进行进一步的测试。考虑到飞行员受到的任何处罚，甚至在资格测试之前。</p>
        <p>注意，投注的认证是通过两种结果（例如车手）参加比赛以及至少一个结果的同一比赛的结束来进行的。否则，投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>Scuderia del Vincente 排位赛</span></p>
        <p>投注在于预测获胜车手所属的车队。官方资格。如果该车队的车手均未参加，则该车队接受的投注将被视为输。</p>
        <p><span style={{ color: "#ff0000" }}>国籍获奖者资格</span></p>
        <p>投注在于预测玩家的国籍。获胜车手的官方资格。如果车手不参加，对该竞争对手接受的投注将被视为输。</p>
        <p><span style={{ color: "#ff0000" }}>赢得团体自由泳 1</span></p>
        <p>投注在于预测列表中指定的车手中哪位车手将取得胜利根据第一期结束时的排名确定最佳名次免费会议。如果公布名单中的车手不参加或退出，则对他接受的投注将被视为输家，因此不值得。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>胜组自由泳2</span></p>
        <p>投注在于预测列表中指定的车手中哪位车手将取得胜利根据第二次自由练习结束时的排名确定最佳名次。如果公布名单中的车手不参加或退出，则对他接受的投注将被视为输家，因此不值得。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>胜组自由泳3</span></p>
        <p>投注在于预测列表中指定的车手中哪位车手将取得胜利根据第三次自由练习结束时的排名确定最佳名次。如果公布名单中的车手不参加或退出，则对他接受的投注将被视为输家，因此不值得。预计退款。</p>
        <p><span style={{ color: "#ff0000" }}>是/否帽子戏法</span></p>
        <p>投注包括预测是否有车手会在给定的大奖赛中取得成功。获得杆位、大奖赛胜利和最快圈速快。</p>
        <p><span style={{ color: "#ff0000" }}>分类是/否</span></p>
        <p>投注包括预测特定车手是否会排名第一。或在比赛结束时更少。如果车手没有参加比赛，投注将被退还。</p>
        <p><span style={{ color: "#ff0000" }}>登上领奖台是/否</span></p>
        <p>投注包括预测骑手是否会分类在特定比赛中获得前三名。</p>
        <p><span style={{ color: "#ff0000" }}>登上领奖台</span></p>
        <p>投注在于预测比赛或赛事结束时登上领奖台的确切顺序（按顺序排列为第一、第二、第三）。</p>
        <p><span style={{ color: "#ff0000" }}>讲台不按顺序</span></p>
        <p>该投注旨在预测比赛结束时登上领奖台的人员组成，无论所选车手到达的顺序如何。</p>
        <p><span style={{ color: "#ff0000" }}>第一和第二配对按顺序</span></p>
        <p>投注包括考虑确切的顺序，预测比赛或赛事结束时登上领奖台的第一名和第二名的组成。</p>
        <p><span style={{ color: "#ff0000" }}>配对 1°和2°不按顺序</span></p>
        <p>投注在于预测比赛或赛事结束时登上领奖台的第一名和第二名的组成，而不考虑确切的顺序。</p>
        <p><span style={{ color: "#ff0000" }}>GP单点队</span></p>
        <p>该投注旨在预测在大奖赛中，同一支球队的两名单座赛车是否将获得有效的名次，以分配世界锦标赛排名所需的积分（即，他们的排名将在第一名和第一名之间； 10°）</p>
        <p><span style={{ color: "#ff0000" }}>GP单组最佳</span></p>
        <p>投注包括预测在提议列表中指定的车手中，谁将实现根据单场大奖赛的排名确定最佳名次。</p>
        <p>注意，如果车手没有参加比赛，则对该竞争对手接受的投注将被视为输家。</p>
        <p><span style={{ color: "#ff0000" }}>第一组末尾的领导者游览</span></p>
        <p>投注在于预测哪位车手将越过终点线1号终点线比赛第一圈结束时的位置。</p>
        <p>如果比赛重新开始，投注时考虑的分数为仅与比赛的第一次出发有关。</p>
        <p><span style={{ color: "#ff0000" }}>多圈GP快速</span></p>
        <p>投注在于预测将取得最佳成绩的车手。最长一圈大奖赛期间速度很快。</p>
        <p>注意，如果车手没有参加比赛，则对该竞争对手接受的投注将被视为输家。</p>
        <p><span style={{ color: "#ff0000" }}>制造商Motore Del Vincente Gara</span></p>
        <p>该投注旨在预测将赢得比赛的骑手所属的摩托车发动机的制造商。单一种族。如果制造商的车手均未参加比赛，则对该制造商接受的投注将被视为输家。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>1st Century 发动机制造商单场比赛退役的车手</span></p>
        <p>该赌注包括预测第一个在比赛中最终退役的骑手的摩托车发动机制造商。为了确定获胜结果，如果有多支车队在同一圈中退赛，则参考退赛发生的比赛圈数。配备不同制造商发动机的摩托车，适用公平原则。投注将被视为输家，但事实并非如此。如果没有配备所选制造商发动机的摩托车参加比赛（绿灯亮起），预计将获得报销。</p>
        <p><span style={{ color: "#ff0000" }}>摩托车锦标赛直播</span></p>
        <p>在摩托车投注中，还提供实时现场投注，赔率在比赛期间会有所不同。</p>
        <p><span style={{ color: "#ff0000" }}>现场获胜</span></p>
        <p>投注在于预测获胜的车手。单一全科医生。</p>
        <p>接受投注可以是大约在比赛结束后 1 圈内进行。</p>
        <p><span style={{ color: "#ff0000" }}>赢得官方现场资格</span></p>
        <p>投注旨在预测哪位车手将在特定大奖赛的官方排位赛结束时排名第一。</p>
        <p>游戏接受结束距离最后一次杆位测试结束后大约 30 秒（官方资格赛）。</p>
        <p><span style={{ color: "#ff0000" }}>最佳组</span></p>
        <p>投注包括预测在提议列表中指定的车手中，谁将实现根据单场大奖赛的排名确定最佳名次。</p>
        <p>接受投注可以是大约在比赛结束后 1 圈内进行。</p>
        <p>注意，如果车手没有参加比赛，则对该竞争对手接受的投注将被视为输家。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>意大利乐透投注</span></span></p>
        <p><span style={{ color: "#ff0000" }}>大量 [X] 提取</span></p>
        <p>（适用于：第一抽签、第二抽签、第三抽签、第四抽签、第五抽签）</p>
        <p>对于这种类型的投注，您需要预测相关号码属于哪个组（从 1 到 30、从 31 到 60 以及从 61 到 90）。</p>
        <p><span style={{ color: "#ff0000" }}>U/O 轮组 [X]</span></p>
        <p>对于这种类型的投注，您必须预测指定轮盘上开出的号码的总和是否为低于（低于）或高于（高于）指示的参考值。如果存在百搭号码（或红球），则不包括在内。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}>批量号码小丑 [X]</span></p>
        <p>对于这种类型的投注，您必须预测抽出的第一个 Jolly 号码（或奖金球）属于哪一组。</p>
        <p><span style={{ color: "#ff0000" }}>奇数/偶数轮</span></p>
        <p>对于这种类型的投注，您需要预测参考轮上的数字总和是否为偶数或奇数。如果存在百搭号码（或红球），则不包括在内。</p>
        <p><span style={{ color: "#ff0000" }}>抽得最多的批次高</span></p>
        <p>对于这种类型的投注，您必须预测轮盘上抽出的第一个和最后一个数字将是哪个最高的。如果存在百搭号码（或红球），则不包括在内。</p>
        <p><span style={{ color: "#ff0000" }}>乐透获胜/失败轮盘</span></p>
        <p>对于这种类型的投注，您需要预测结果是什么。具有最高数字总和的轮盘高（获胜）和/或具有最高数字总和的轮盘低（失败者）。如果存在百搭号码（或红球），则不包括在内。</p>
        <p><span style={{ color: "#ff0000" }}>乐透特别配对</span></p>
        <p>对于这种类型的投注，您需要预测赛事中出现的哪个轮盘将有最多摘录的总和高的。如果存在百搭号码（或红球），则不包括在内。</p>
        <p><span style={{ color: "#ff0000" }}>意大利迟到投注</span></p>
        <p><span style={{ color: "#ff0000" }}>[x]LATECOME</span></p>
        <p>（适用于：第一迟到者、第二迟到者、第三迟到者、第四迟到者）</p>
        <p>对于这种类型的投注，您必须预测指定的数字是否会出现。或小于参考轮。他会来的在活动结束后考虑抽签。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>娱乐活动</span></span></p>
        <p><span style={{ color: "#ff0000" }}>获胜</span></p>
        <p>投注旨在预测特定娱乐赛事的获胜者。如果选定的参赛者从一开始就没有参加比赛或在比赛期间因任何原因退出，则对其接受的投注将被视为失败且不被接受。预计将退还赌注。如果没有提供所有参与者的姓名，还包括其他。报道参考相关活动官网发布的正式报道。</p>
        <p><br /></p>
        <p><span style={{ color: "#ff0000" }}><span style={{ fontSize: "large" }}>PADEL</span></span></p>
        <p><span style={{ color: "#ff0000" }}>T/T MATCH</span></p>
        <p>投注包括预测将赢得比赛的球员或一对球员。如果一名球员或两名球员在比赛期间退出，则对该球员或两名球员所接受的投注将被视为输。赌注将是相反，如果至少比赛的第一分尚未打完，则退款。报告时以相关活动主办方发布的规定和官方数据为准。对于一切不是的上述规定，适用现行部长令的规定。</p>
        <p><span style={{ color: "#ff0000" }}>T/T IN SET</span></p>
        <p>投注包括预测两名玩家或一对玩家中哪一位会获胜。比赛中的集合x。如果该选手或一对选手在第 x 盘期间退出，则对该选手或该对选手所接受的投注将被视为输家，而如果在第 x 盘开始之前退出，则该投注将被退还。出于报告目的，赛事组织者在相关比赛结束时发布的内容有效。对于一切不是的上述规定，适用现行部长令的规定。</p>
        <p><span style={{ color: "#ff0000" }}>下注 A 3</span></p>
        <p>投注包含 3 盘两胜制比赛的最终准确比分，包括 4 种结果：2-0、2-1、1-2、0-2。如果比赛未进行或最终中断，则对盘口投注的投注将被退还。报告时以相关活动主办方发布的规定和官方数据为准。对于一切不是的上述规定，适用现行部长令的规定。</p>
        <p><span style={{ color: "#ff0000" }}>U/O 游戏</span></p>
        <p>投注包括预测相关比赛的比赛总和是否为低于（低于）或高于（高于）预先设定的值。如果超级抢七是在一场比赛的决定性盘中进行的，则出于记分目的，后者将被被视为单一游戏。如果比赛期间一名/两名球员退出，则投注金额将仅当结果可以被认为是有效的一定要确定，否则就会已退款。报告时以相关活动主办方发布的规定和官方数据为准。对于一切不是的上述规定，适用现行部长令的规定。</p>
        <p><span style={{ color: "#ff0000" }}>T/T SET X GAME Y</span></p>
        <p>投注包括预测两名玩家或一对玩家中哪一位会获胜。比赛期间 x 组的第 y 场比赛。如果两名球员或两名球员中的一人在比赛开始前退出，则相关投注将被退还。然而，如果一名球员或两名球员在比赛期间退出，他们将被视为失败者。报告时以相关活动主办方发布的规定和官方数据为准。对于一切不是的上述规定，适用现行部长令的规定。</p>
      </p>
    </>
  )
}